(function () {
  function parseJSON(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return fallback;
    }
  }

  function isSupplierPricing(properties) {
    properties = properties || {};
    return properties._pricing_mode === 'supplier_quote' || properties._pricing_mode === 'personalization_quote' || properties._pricing_mode === 'quote_required'
      || Object.keys(properties).some(function (key) { return key.indexOf('_xd_') === 0 || key.indexOf('_personalization_') === 0; });
  }

  function supplierInteger(value, allowZero) {
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^(?:0|[1-9]\d*)$/.test(value))) return null;
    var parsed = Number(value);
    if (!Number.isSafeInteger(parsed)) return null;
    return allowZero ? parsed >= 0 ? parsed : null : parsed > 0 ? parsed : null;
  }

  function readSeparateSupplierFees(item) {
    var properties = item && item.properties || {};
    if (properties._fee_mode !== 'separate') return null;
    var quantity = supplierInteger(item && item.quantity);
    var unitPriceCents = supplierInteger(properties._applied_unit_price_cents);
    var itemsTotalPriceCents = supplierInteger(properties._items_total_price_cents);
    var technicalFeesCents = supplierInteger(properties._technical_fees_cents, true);
    var preparationFeesCents = supplierInteger(properties._preparation_fees_cents, true);
    var totalPriceCents = supplierInteger(properties._total_price_cents);
    var personalized = properties._personalization_pricing === '1' || properties._pricing_mode === 'personalization_quote';
    var quoteMode = personalized ? 'personalization_quote' : 'supplier_quote';
    var quotedQuantity = supplierInteger(personalized ? properties._personalization_quote_quantity : properties._xd_quote_quantity);
    var validUntil = personalized ? properties._personalization_quote_valid_until : properties._xd_quote_valid_until;
    var validUntilMs = typeof validUntil === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/.test(validUntil)
      ? Date.parse(validUntil) : NaN;
    var valid = properties._pricing_mode === quoteMode && properties._pricing_currency === 'EUR'
      && (!personalized || properties._personalization_quote_only === '1')
      && quantity !== null && quotedQuantity === quantity
      && unitPriceCents !== null && itemsTotalPriceCents !== null
      && technicalFeesCents !== null && preparationFeesCents !== null && totalPriceCents !== null
      && itemsTotalPriceCents === unitPriceCents * quantity
      && totalPriceCents === itemsTotalPriceCents + technicalFeesCents + preparationFeesCents
      && Number.isFinite(validUntilMs) && validUntilMs > Date.now();
    return valid ? { unitPriceCents: unitPriceCents, itemsTotalPriceCents: itemsTotalPriceCents,
      technicalFeesCents: technicalFeesCents, preparationFeesCents: preparationFeesCents, totalPriceCents: totalPriceCents } : { invalid: true };
  }

  function applySeparateSupplierFees(item, pricing) {
    var components = readSeparateSupplierFees(item);
    if (!components) return pricing;
    if (components.invalid || pricing && pricing.valid === false) return { estimated: true, valid: false, currency: pricing && pricing.currency || 'EUR', sourceCurrency: 'EUR',
      unitPriceCents: null, linePriceCents: null, itemsTotalPriceCents: null, technicalFeesCents: null, preparationFeesCents: null,
      discountPct: 0, appliedTierQty: null, pricingMode: 'quote_required', feeMode: 'separate' };
    var quantity = Number(item && item.quantity || 0);
    var unitPriceCents = components.unitPriceCents;
    var itemsTotalPriceCents = components.itemsTotalPriceCents;
    var technicalFeesCents = components.technicalFeesCents;
    var preparationFeesCents = components.preparationFeesCents;
    var currency = pricing && pricing.currency || (window.TodayMerchMoney ? window.TodayMerchMoney.activeCurrency() : 'EUR');
    if (window.TodayMerchMoney) {
      unitPriceCents = window.TodayMerchMoney.convert(unitPriceCents, 'EUR');
      itemsTotalPriceCents = unitPriceCents == null ? null : unitPriceCents * quantity;
      technicalFeesCents = window.TodayMerchMoney.convert(technicalFeesCents, 'EUR');
      preparationFeesCents = window.TodayMerchMoney.convert(preparationFeesCents, 'EUR');
    }
    if (![unitPriceCents, itemsTotalPriceCents, technicalFeesCents, preparationFeesCents].every(Number.isSafeInteger)) {
      return { estimated: true, valid: false, currency: currency, sourceCurrency: 'EUR', unitPriceCents: null, linePriceCents: null,
        itemsTotalPriceCents: null, technicalFeesCents: null, preparationFeesCents: null, discountPct: 0, appliedTierQty: null,
        pricingMode: 'quote_required', feeMode: 'separate' };
    }
    return Object.assign({}, pricing || {}, { estimated: true, valid: true, currency: currency, sourceCurrency: 'EUR',
      unitPriceCents: unitPriceCents, itemsTotalPriceCents: itemsTotalPriceCents,
      technicalFeesCents: technicalFeesCents, preparationFeesCents: preparationFeesCents,
      linePriceCents: itemsTotalPriceCents + technicalFeesCents + preparationFeesCents,
      sourceUnitPriceCents: components.unitPriceCents, sourceItemsTotalPriceCents: components.itemsTotalPriceCents,
      sourceTechnicalFeesCents: components.technicalFeesCents, sourcePreparationFeesCents: components.preparationFeesCents,
      sourceLinePriceCents: components.totalPriceCents, pricingMode: pricing && pricing.pricingMode || 'supplier_quote', feeMode: 'separate' });
  }

  function selectorEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/([ #;?%&,.+*~\':"!^$\[\]()=>|\/])/g, '\\$1');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  var QUOTE_REQUEST_ID_ALPHABET = '23456789ABCDEFGHJKMNPQRSTVWXYZ';
  var QUOTE_REQUEST_ID_LENGTH = 10;
  var QUOTE_REQUEST_ID_REJECTION_LIMIT = 240;

  function createQuoteRequestId() {
    var formatRandomCode = function (fillBytes) {
      var code = '';
      var attempts = 0;
      while (code.length < QUOTE_REQUEST_ID_LENGTH && attempts < 8) {
        var bytes = new Uint8Array(QUOTE_REQUEST_ID_LENGTH);
        fillBytes(bytes);
        for (var byteIndex = 0; byteIndex < bytes.length && code.length < QUOTE_REQUEST_ID_LENGTH; byteIndex += 1) {
          if (bytes[byteIndex] >= QUOTE_REQUEST_ID_REJECTION_LIMIT) continue;
          code += QUOTE_REQUEST_ID_ALPHABET[bytes[byteIndex] % QUOTE_REQUEST_ID_ALPHABET.length];
        }
        attempts += 1;
      }
      if (code.length !== QUOTE_REQUEST_ID_LENGTH) {
        throw new Error('Secure quote request generation did not yield enough entropy');
      }
      return 'TM-' + code.slice(0, 5) + '-' + code.slice(5);
    };
    try {
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        return formatRandomCode(function (bytes) {
          window.crypto.getRandomValues(bytes);
        });
      }
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return formatRandomCode(function (bytes) {
          var filled = 0;
          while (filled < bytes.length) {
            var hex = String(window.crypto.randomUUID()).replace(/[^a-f0-9]/giu, '');
            if (hex.length < 32) throw new Error('Invalid secure UUID');
            for (var index = 0; index < hex.length && filled < bytes.length; index += 2) {
              bytes[filled] = parseInt(hex.slice(index, index + 2), 16);
              filled += 1;
            }
          }
        });
      }
    } catch (error) {
      // The caller fails closed below when secure randomness is unavailable.
    }
    throw new Error('Secure quote request generation is unavailable');
  }

  function QuoteBuilder(root) {
    this.root = root;
    this.config = parseJSON(root.querySelector('[data-qb-config]'), {});
    this.i18n = this.config.translations && typeof this.config.translations === 'object' ? this.config.translations : {};
    this.optionValueLabels = this.i18n.optionValueLabels && typeof this.i18n.optionValueLabels === 'object'
      ? this.i18n.optionValueLabels
      : {};
    this.apparelItems = this.config.apparelItems && typeof this.config.apparelItems === 'object' ? this.config.apparelItems : {};
    this.productionDays = this.config.productionDays && typeof this.config.productionDays === 'object' ? this.config.productionDays : {};
    this.regularUnitPrices = this.config.regularUnitPrices && typeof this.config.regularUnitPrices === 'object' ? this.config.regularUnitPrices : {};
    this.apparelSizes = this.normalizeSizeOptions(this.config.apparelSizes);
    this.itemRules = parseJSON(root.querySelector('[data-qb-item-rules]'), {});
    this.cart = this.normalizeCart(parseJSON(root.querySelector('[data-qb-cart]'), { items: [] }));
    this.form = root.querySelector('form');
    this.cartItemsEl = root.querySelector('[data-qb-cart-items]');
    this.statusEl = root.querySelector('[data-qb-status]');
    this.successPageEl = root.querySelector('[data-qb-submit-success]');
    this.summaryReferenceUnitsEls = root.querySelectorAll('[data-qb-summary-reference-units]');
    this.summaryProductsEls = root.querySelectorAll('[data-qb-summary-products]');
    this.summaryTargetDateEls = root.querySelectorAll('[data-qb-summary-target-date]');
    this.summarySubtotalEls = root.querySelectorAll('[data-qb-summary-subtotal]');
    this.summaryTotalEls = root.querySelectorAll('[data-qb-summary-total], [data-qb-mobile-total]');
    this.summaryShippingEls = root.querySelectorAll('[data-qb-summary-shipping]');
    this.headerCountEls = document.querySelectorAll('[data-qb-header-count]');
    this.submitButtons = root.querySelectorAll('[data-qb-submit]');
    this.mobileBarEl = root.querySelector('[data-qb-mobile-bar]');
    this.mobileSubmitEl = root.querySelector('[data-qb-mobile-submit]');
    this.mobileContextEl = root.querySelector('[data-qb-mobile-context]');
    this.wizardEl = root.querySelector('[data-qb-wizard]') || document.querySelector('[data-qb-wizard]');
    this.stepPanels = Array.prototype.slice.call(root.querySelectorAll('[data-qb-step]'));
    this.stepNavButtons = Array.prototype.slice.call(root.querySelectorAll('[data-qb-step-nav]'));
    if (this.wizardEl && !root.contains(this.wizardEl)) {
      this.stepNavButtons = this.stepNavButtons.concat(Array.prototype.slice.call(this.wizardEl.querySelectorAll('[data-qb-step-nav]')));
    }
    this.stepPrevEl = root.querySelector('[data-qb-step-prev]');
    this.stepNextEl = root.querySelector('[data-qb-step-next]');
    this.wizardAssuranceEl = root.querySelector('[data-qb-wizard-assurance]');
    this.progressLabelEl = root.querySelector('[data-qb-progress-label]');
    this.progressTrackEl = root.querySelector('[data-qb-progress-track]');
    this.progressFillEl = root.querySelector('[data-qb-progress-fill]');
    this.progressBackEl = root.querySelector('[data-qb-progress-back]');
    this.progressCatalogBackEl = root.querySelector('[data-qb-progress-catalog-back]');
    this.summaryCardEl = root.querySelector('[data-qb-summary-card]');
    this.shippingDetailEl = root.querySelector('[data-qb-shipping-detail]');
    this.shippingMultiNoteEl = root.querySelector('[data-qb-shipping-multi-note]');
    this.shippingSingleAddressEl = root.querySelector('[data-qb-shipping-single-address]');
    this.shippingSingleAddressInputs = this.shippingSingleAddressEl
      ? this.shippingSingleAddressEl.querySelectorAll('input, textarea, select')
      : [];
    this.shippingDecisionInputs = root.querySelectorAll('[data-qb-shipping-decision]');
    this.shippingModeInputs = root.querySelectorAll('[data-qb-shipping-mode]');
    this.shippingDecisionGroup = root.querySelector('[data-qb-shipping-decision-group]');
    this.shippingModeGroup = root.querySelector('[data-qb-shipping-mode-group]');
    this.shippingDecisionErrorEl = root.querySelector('[data-qb-shipping-decision-error]');
    this.shippingModeErrorEl = root.querySelector('[data-qb-shipping-mode-error]');
    this.targetDateChoiceGroup = root.querySelector('[data-qb-target-date-choice-group]');
    this.targetDateChoiceInputs = root.querySelectorAll('[data-qb-target-date-choice]');
    this.targetDateField = root.querySelector('[data-qb-target-date-field]');
    this.targetDateInput = this.targetDateField ? this.targetDateField.querySelector('[data-qb-target-date-input]') : null;
    this.targetDatePicker = root.querySelector('[data-qb-target-date-picker]');
    this.targetDateSelectedEl = root.querySelector('[data-qb-date-selected]');
    this.targetDateChoiceSelectedEl = root.querySelector('[data-qb-target-date-choice-selected]');
    this.calendarMonthEl = root.querySelector('[data-qb-calendar-month]');
    this.calendarGridEl = root.querySelector('[data-qb-calendar-grid]');
    this.calendarPrevEl = root.querySelector('[data-qb-calendar-prev]');
    this.calendarNextEl = root.querySelector('[data-qb-calendar-next]');
    this.dateStripDaysEl = root.querySelector('[data-qb-date-strip-days]');
    this.dateStripPrevEl = root.querySelector('[data-qb-date-strip-prev]');
    this.dateStripNextEl = root.querySelector('[data-qb-date-strip-next]');
    this.calendarToggleEl = root.querySelector('[data-qb-calendar-toggle]');
    this.calendarPopoverEl = root.querySelector('[data-qb-calendar-popover]');
    this.briefTitleEl = root.querySelector('[data-qb-brief-title]');
    this.progressiveBlocks = root.querySelectorAll('[data-qb-progressive-block]');
    this.progressiveDateBlock = root.querySelector('[data-qb-progressive-block="date"]');
    this.progressiveProjectBlock = root.querySelector('[data-qb-progressive-block="project"]');
    this.progressiveShippingBlock = root.querySelector('[data-qb-progressive-block="shipping"]');
    this.targetDateErrorEl = root.querySelector('[data-qb-target-date-error]');
    this.consentWrapper = root.querySelector('[data-qb-consent-wrapper]');
    this.consentInput = root.querySelector('[data-qb-consent]');
    this.consentErrorEl = root.querySelector('[data-qb-consent-error]');
    this.projectSelect = root.querySelector('[data-qb-project-select]');
    this.projectCardsGroup = root.querySelector('[data-qb-project-cards]');
    this.projectCards = root.querySelectorAll('[data-qb-project-card]');
    this.assetsDrawerEl = root.querySelector('[data-qb-assets-drawer]');
    this.hiddenNameEl = root.querySelector('[data-qb-hidden-name]');
    this.hiddenPhoneEl = root.querySelector('[data-qb-hidden-phone]');
    this.phoneInputEl = root.querySelector('[data-qb-phone]');
    this.contactPreferenceEl = root.querySelector('[data-qb-contact-preference]');
    this.phoneRequiredEl = root.querySelector('[data-qb-phone-required]');
    this.phoneOptionalEl = root.querySelector('[data-qb-phone-optional]');
    this.hiddenRequestIdEl = root.querySelector('[data-qb-hidden-request-id]');
    this.hiddenReferencesEl = root.querySelector('[data-qb-hidden-references]');
    this.hiddenUnitsEl = root.querySelector('[data-qb-hidden-units]');
    this.hiddenSubtotalEl = root.querySelector('[data-qb-hidden-subtotal]');
    this.hiddenShippingEl = root.querySelector('[data-qb-hidden-shipping]');
    this.hiddenMockupsEl = root.querySelector('[data-qb-hidden-mockups]');
    this.hiddenDesignsEl = root.querySelector('[data-qb-hidden-designs]');
    this.hiddenItemsEl = root.querySelector('[data-qb-hidden-items]');
    this.hiddenBodyEl = root.querySelector('[data-qb-hidden-body]');
    this.hiddenUploadcareEl = root.querySelector('[data-qb-hidden-uploadcare]');
    this.hiddenClientProjectEl = root.querySelector('[data-qb-hidden-client-project]');
    this.uploadcareStateEl = root.querySelector('[data-qb-uploadcare-state]');
    this.uploadcareListEl = root.querySelector('[data-qb-uploadcare-list]');
    this.toastEl = root.querySelector('[data-qb-toast]');
    this.toastMessageEl = root.querySelector('[data-qb-toast-message]');
    this.loadingLineKey = null;
    this.cartBusy = false;
    this.removedItem = null;
    this.toastTimer = null;
    this.uploadcareUrls = [];
    this.uploadcareInitialized = false;
    this.storageKey = this.config.storageKey || null;
    this.submitLoading = false;
    this.quoteSubmissionInFlight = false;
    this.clientProjectSubmitInFlight = false;
    this.clientProjectRequestPromise = null;
    this.clientProjectCreated = false;
    this.clientProjectReference = '';
    this.autoReplySubmitInFlight = false;
    this.autoReplySent = false;
    this.quoteRequestId = createQuoteRequestId();
    this.quoteSubmittedAt = '';
    this.openSizeEditorLineKey = null;
    this.sizeAutoSaveTimers = {};
    this.lineViewOptions = this.collectLineViewOptions();
    this.calendarMonthDate = null;
    this.dateStripStartDate = null;
    this.currentStep = 1;
    this.maxWizardStep = 1;
    this.totalWizardSteps = Math.max(this.stepPanels.length || 3, 1);
  }

  QuoteBuilder.prototype.translate = function (key, replacements) {
    var template = typeof this.i18n[key] === 'string' ? this.i18n[key] : '';
    var values = replacements && typeof replacements === 'object' ? replacements : {};

    return Object.keys(values).reduce(function (result, token) {
      return result.split('%%' + token + '%%').join(String(values[token] == null ? '' : values[token]));
    }, template);
  };

  QuoteBuilder.prototype.getPluralCategory = function (count) {
    try {
      return new Intl.PluralRules(this.config.locale).select(Number(count));
    } catch (error) {
      return Number(count) === 1 ? 'one' : 'other';
    }
  };

  QuoteBuilder.prototype.translateCount = function (singularKey, pluralKey, count) {
    return this.translate(this.getPluralCategory(count) === 'one' ? singularKey : pluralKey, { count: count });
  };

  QuoteBuilder.prototype.lookupStoredRules = function (item) {
    if (!item) return {};
    return this.itemRules[item.key] || this.itemRules['variant:' + item.id] || {};
  };

  QuoteBuilder.prototype.getItemProductionDays = function (item) {
    if (!item) return '';

    var keys = [
      item.key,
      'product:' + item.product_id,
      'variant:' + (item.variant_id || item.id)
    ];

    for (var key of keys) {
      var value = this.productionDays[key];
      if (value != null && String(value).trim() !== '') return String(value).trim();
    }

    return '';
  };

  QuoteBuilder.prototype.getLeadTimeNote = function (productionDays) {
    var dayLabelKey = Number(productionDays) === 1 ? 'leadTimeDaySingular' : 'leadTimeDayPlural';
    return this.translate('leadTimeNote', {
      days: productionDays,
      dayLabel: this.translate(dayLabelKey)
    });
  };

  QuoteBuilder.prototype.rememberItemRules = function (item, rules) {
    if (!item || !rules) return;
    this.itemRules[item.key] = { min: rules.min, increment: rules.increment, max: rules.max };
    if (item.id) this.itemRules['variant:' + item.id] = { min: rules.min, increment: rules.increment, max: rules.max };
  };

  QuoteBuilder.prototype.normalizeCart = function (cart) {
    var normalized = cart || {};
    normalized.items = Array.isArray(normalized.items) ? normalized.items : [];
    normalized.items = normalized.items.map(function (item, index) {
      var normalizedItem = item || {};
      normalizedItem.line = index + 1;
      var nativePricing = this.config && this.config.nativePricingVariants;
      if (nativePricing && nativePricing[String(normalizedItem.variant_id || normalizedItem.id)]) {
        normalizedItem.properties = Object.assign({}, normalizedItem.properties || {}, { _pricing_native: 'true' });
      }
      var storedRules = this.lookupStoredRules(normalizedItem);
      var quantityRule = normalizedItem.quantity_rule || {};
      normalizedItem.quantity_rule = {
        min: Math.max(Number(quantityRule.min || storedRules.min || 1) || 1, 1),
        increment: Math.max(Number(quantityRule.increment || storedRules.increment || 1) || 1, 1),
        max: quantityRule.max == null || quantityRule.max === '' ? (storedRules.max == null ? null : Number(storedRules.max)) : Number(quantityRule.max)
      };
      var currentPricing = this.config && this.config.currentPricingVariants && this.config.currentPricingVariants[String(normalizedItem.variant_id || normalizedItem.id)];
      var money = window.TodayMerchMoney;
      var pricingHelper = window.TodayMerchQuantityPricing;
      var sourceCurrency = normalizedItem.properties && normalizedItem.properties._pricing_currency || (money && money.baseCurrency());
      if (money && pricingHelper && currentPricing && currentPricing.currency === money.activeCurrency() && sourceCurrency !== money.activeCurrency() && Array.isArray(currentPricing.tiers) && currentPricing.tiers.length) {
        var refreshedProperties = Object.assign({}, normalizedItem.properties || {}, {
          _pricing_tiers: JSON.stringify(currentPricing.tiers),
          _pricing_currency: currentPricing.currency
        });
        normalizedItem.properties = pricingHelper.buildUpdatedProperties(refreshedProperties, normalizedItem.quantity, normalizedItem.quantity_rule) || refreshedProperties;
      }
      this.rememberItemRules(normalizedItem, normalizedItem.quantity_rule);
      return normalizedItem;
    }, this);
    if (typeof normalized.item_count !== 'number') {
      normalized.item_count = normalized.items.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
    }
    var pricing = normalized.items.map(function (item) { return this.getDisplayPricing(item); }, this);
    normalized.pricing_valid = pricing.every(function (value) { return value.valid !== false && Number.isFinite(value.linePriceCents); });
    normalized.items_subtotal_price = normalized.pricing_valid ? pricing.reduce(function (sum, value) {
      return sum + value.linePriceCents;
    }, 0) : null;
    normalized.items_articles_subtotal_price = normalized.pricing_valid ? pricing.reduce(function (sum, value) {
      return sum + (Number.isFinite(value.itemsTotalPriceCents) ? value.itemsTotalPriceCents : value.linePriceCents);
    }, 0) : null;
    normalized.technical_fees_price = normalized.pricing_valid ? pricing.reduce(function (sum, value) {
      return sum + (Number.isFinite(value.technicalFeesCents) ? value.technicalFeesCents : 0);
    }, 0) : null;
    normalized.preparation_fees_price = normalized.pricing_valid ? pricing.reduce(function (sum, value) {
      return sum + (Number.isFinite(value.preparationFeesCents) ? value.preparationFeesCents : 0);
    }, 0) : null;
    return normalized;
  };

  QuoteBuilder.prototype.normalizeViewOptions = function (views) {
    var seen = {};
    var zoneLabels = this.i18n && this.i18n.zoneLabels && typeof this.i18n.zoneLabels === 'object'
      ? this.i18n.zoneLabels
      : {};
    var localizeStandardLabel = function (value) {
      var label = String(value || '').trim();
      var normalizedKey = this.normalizeMarkingZoneKey(label);
      var localizedLabel = normalizedKey && Object.prototype.hasOwnProperty.call(zoneLabels, normalizedKey)
        ? String(zoneLabels[normalizedKey] || '').trim()
        : '';
      return localizedLabel || label;
    }.bind(this);

    return (Array.isArray(views) ? views : []).map(function (view, index) {
      var image = String(view && view.image ? view.image : '').trim();
      var label = localizeStandardLabel(view && view.label);
      var key = String(view && view.key ? view.key : label || ('view-' + index)).trim();
      var rawZone = view && view.zone && typeof view.zone === 'object' ? view.zone : null;
      var rawZones = Array.isArray(view && view.zones) ? view.zones : (rawZone ? [rawZone] : []);
      if (!image || !label) return null;

      var zones = rawZones.map(function (zone) {
        var parts = Array.isArray(zone && zone.parts) ? zone.parts : [];
        return {
          id: String(zone && (zone.id || zone.key || zone.placementId) || '').trim(),
          placementId: String(zone && (zone.placementId || zone.groupId) || '').trim(),
          legacyKeys: Array.isArray(zone && zone.legacyKeys) ? zone.legacyKeys.map(String) : [],
          label: String(zone && zone.label || label).trim(),
          x: Number(zone && zone.x),
          y: Number(zone && zone.y),
          width: Number(zone && zone.width),
          height: Number(zone && zone.height),
          rotation: Number(zone && (zone.rotation || zone.angle) || 0),
          parts: parts.map(function (part) {
            return {
              id: String(part && part.id || '').trim(),
              x: Number(part && part.x),
              y: Number(part && part.y),
              width: Number(part && part.width),
              height: Number(part && part.height),
              rotation: Number(part && (part.rotation || part.angle) || 0)
            };
          }).filter(function (part) {
            return Number.isFinite(part.x) && Number.isFinite(part.y) && Number.isFinite(part.width) && Number.isFinite(part.height) && part.width > 0 && part.height > 0;
          })
        };
      }).filter(function (zone) {
        return Number.isFinite(zone.x) && Number.isFinite(zone.y) &&
          Number.isFinite(zone.width) && Number.isFinite(zone.height) &&
          zone.width > 0 && zone.height > 0;
      });

      return {
        key: key,
        sourceViewId: String(view && view.sourceViewId ? view.sourceViewId : '').trim(),
        label: label,
        image: image,
        alt: String(view && view.alt ? view.alt : label).trim(),
        zones: zones,
        zone: zones[0] || null
      };
    }).filter(function (view) {
      if (!view) return false;
      var dedupeKey = String(view.key || view.label).toLowerCase();
      if (seen[dedupeKey]) return false;
      seen[dedupeKey] = true;
      return true;
    });
  };

  QuoteBuilder.prototype.getQuoteVariantLookupKeys = function (variantId) {
    var value = String(variantId || '').trim();
    var numericId = (value.match(/(\d+)(?:\D*)$/) || [])[1] || '';
    return Array.from(new Set([
      value,
      numericId,
      numericId ? 'gid://shopify/ProductVariant/' + numericId : ''
    ].filter(Boolean)));
  };

  QuoteBuilder.prototype.buildV2LineViewOptions = function (rawConfig, variantId) {
    var compat = window.TodayMerchStudioConfigCompat;
    var config = compat && typeof compat.adapt === 'function' ? compat.adapt(rawConfig || {}) : rawConfig || {};
    if (Number(config.schemaVersion) !== 2) return [];

    var placements = Array.isArray(config.placements) ? config.placements : [];
    var views = Array.isArray(config.views) ? config.views : [];
    var zones = Array.isArray(config.zones) ? config.zones : [];
    var variantMedia = config.variantMediaV2 && typeof config.variantMediaV2 === 'object' ? config.variantMediaV2 : {};
    var variantKeys = this.getQuoteVariantLookupKeys(variantId);
    var mappingKey = variantKeys.find(function (key) {
      return variantMedia[key] && typeof variantMedia[key] === 'object';
    });
    var assignments = mappingKey ? variantMedia[mappingKey] : null;
    var optionsByPlacement = {};

    placements.forEach(function (placement) {
      if (!placement || placement.active === false || placement.active === 'false') return;
      var placementId = String(placement.id || '').trim();
      var instances = Array.isArray(placement.instances) ? placement.instances : [];
      var mappedValue = assignments && assignments[placementId];
      var mappedViewId = String(mappedValue && mappedValue.viewId || mappedValue || '').trim();
      var instance = mappedViewId ? instances.find(function (candidate) {
        return String(candidate && candidate.viewId || '') === mappedViewId;
      }) : null;

      if (!instance && assignments) return;
      if (!instance) {
        instance = instances.find(function (candidate) {
          var view = views.find(function (item) { return String(item.key || '') === String(candidate && candidate.viewId || ''); });
          var ids = Array.isArray(view && view.variantIds) ? view.variantIds.map(String) : [];
          return !ids.length || ids.some(function (id) { return variantKeys.indexOf(id) >= 0; });
        }) || instances[0];
      }
      if (!instance) return;

      var viewId = String(instance.viewId || '').trim();
      var view = views.find(function (candidate) { return String(candidate && candidate.key || '') === viewId; });
      var zone = zones.find(function (candidate) {
        return candidate && candidate.active !== false && candidate.active !== 'false' &&
          String(candidate.placementId || candidate.groupId || '') === placementId &&
          String(candidate.view || '') === viewId;
      });
      if (!view || !view.image || !zone) return;

      if (!optionsByPlacement[placementId]) {
        optionsByPlacement[placementId] = {
          key: placementId,
          sourceViewId: viewId,
          label: String(placement.label || zone.label || view.label || viewId),
          image: String(view.image || ''),
          alt: String(view.alt || view.label || placement.label || zone.label || ''),
          zones: []
        };
      }
      optionsByPlacement[placementId].zones.push({
        id: zone.key || zone.id || '',
        placementId: placementId,
        legacyKeys: Array.isArray(placement.legacyKeys) ? placement.legacyKeys : [],
        label: String(placement.label || zone.label || ''),
        x: zone.x,
        y: zone.y,
        width: zone.width,
        height: zone.height,
        rotation: zone.rotation || zone.angle || 0,
        parts: Array.isArray(zone.parts) ? zone.parts : []
      });
    });

    return Object.keys(optionsByPlacement).map(function (placementId) { return optionsByPlacement[placementId]; });
  };

  QuoteBuilder.prototype.collectLineViewOptions = function () {
    var lineViewOptions = {};
    var studioConfigs = {};
    this.root.querySelectorAll('[data-qb-line-studio-config]').forEach(function (node) {
      var lineKey = node.getAttribute('data-line-key');
      if (!lineKey) return;
      var parsedConfig = parseJSON(node, {});
      var localizedConfig = window.TodayMerchStudioI18n && typeof window.TodayMerchStudioI18n.localizeConfigNode === 'function'
        ? window.TodayMerchStudioI18n.localizeConfigNode(node, parsedConfig)
        : parsedConfig;
      studioConfigs[lineKey] = {
        config: localizedConfig,
        variantId: node.getAttribute('data-variant-id') || ''
      };
    });
    this.root.querySelectorAll('[data-qb-line-views]').forEach(function (node) {
      var lineKey = node.getAttribute('data-line-key');
      if (!lineKey) return;
      var studioEntry = studioConfigs[lineKey];
      var sourceViews = studioEntry && Number(studioEntry.config && studioEntry.config.schemaVersion) === 2
        ? this.buildV2LineViewOptions(studioEntry.config, studioEntry.variantId)
        : parseJSON(node, []);
      lineViewOptions[lineKey] = this.normalizeViewOptions(sourceViews);
    }, this);
    return lineViewOptions;
  };

  QuoteBuilder.prototype.getItemViewOptions = function (item) {
    if (!item) return [];
    var lineViewOptions = this.lineViewOptions && typeof this.lineViewOptions === 'object' ? this.lineViewOptions : {};
    return lineViewOptions[item.key] || [];
  };

  QuoteBuilder.prototype.normalizeStudioPreviewUrl = function (value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (/^(https?:)?\/\//i.test(url) || url.charAt(0) === '/') return url;
    return '';
  };

  QuoteBuilder.prototype.getItemStudioPreviewState = function (item) {
    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var rawManifest = properties._tm_studio_preview_manifest || properties._studio_cart_preview_manifest;
    var emptyState = { activeViewId: '', views: {} };
    if (!rawManifest) return emptyState;

    try {
      var manifest = typeof rawManifest === 'string' ? JSON.parse(rawManifest) : rawManifest;
      if (!manifest || [1, 2].indexOf(Number(manifest.version)) < 0 || !Array.isArray(manifest.views)) {
        return emptyState;
      }

      var isV2 = Number(manifest.version) === 2;
      var previewsByView = {};
      manifest.views.slice(0, 8).forEach(function (view, index) {
        if (!view || typeof view !== 'object') return;
        var viewId = String(isV2 ? view.viewId : (view.key || ('view-' + (index + 1)))).trim();
        if (!viewId || previewsByView[viewId]) return;

        var previewProperty = String(view.previewProperty || '').trim();
        var customizedImage = previewProperty ? this.normalizeStudioPreviewUrl(properties[previewProperty]) : '';
        var fallbackImage = this.normalizeStudioPreviewUrl(isV2 ? view.fallbackImage : view.image);
        var image = customizedImage || fallbackImage;
        if (!image) return;

        var zoneId = String(view.zoneId || '').trim();
        previewsByView[viewId] = {
          key: viewId,
          zoneId: zoneId,
          sourceViewId: String(view.sourceViewId || '').trim(),
          label: String(view.label || view.alt || this.getMarkingZoneLabel(zoneId) || '').trim(),
          alt: String(view.alt || '').trim(),
          image: image,
          customized: Boolean(customizedImage)
        };
      }, this);

      return {
        activeViewId: String(
          manifest.activeViewId ||
          manifest.activeKey ||
          properties._tm_studio_view_id ||
          properties._studio_view ||
          ''
        ).trim(),
        views: previewsByView
      };
    } catch (error) {
      return emptyState;
    }
  };

  QuoteBuilder.prototype.normalizeStudioReference = function (value) {
    return this.normalizeLabelForMatch(value).replace(/[_\s]+/g, '-');
  };

  QuoteBuilder.prototype.viewMatchesStudioReference = function (view, reference) {
    var normalizedReference = this.normalizeStudioReference(reference);
    if (!view || !normalizedReference) return false;

    var candidates = [view.key, view.sourceViewId, view.label, view.alt, view.zone && view.zone.id, view.zone && view.zone.placementId]
      .concat(Array.isArray(view.zones) ? view.zones.reduce(function (list, zone) {
        return list.concat([zone && zone.id, zone && zone.placementId, zone && zone.label], Array.isArray(zone && zone.legacyKeys) ? zone.legacyKeys : []);
      }, []) : [])
      .map(this.normalizeStudioReference.bind(this));

    return candidates.indexOf(normalizedReference) >= 0;
  };

  QuoteBuilder.prototype.zoneMatchesStudioReference = function (zone, reference) {
    var normalizedReference = this.normalizeStudioReference(reference);
    if (!zone || !normalizedReference) return false;

    return [zone.id, zone.placementId, zone.label]
      .concat(Array.isArray(zone.legacyKeys) ? zone.legacyKeys : [])
      .map(this.normalizeStudioReference.bind(this))
      .indexOf(normalizedReference) >= 0;
  };

  QuoteBuilder.prototype.getItemBrandingMockupViewOptions = function (item) {
    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var productTitle = String(item && (item.product_title || item.title) || '').trim();
    var views = [];
    var usedKeys = {};

    Object.keys(properties).forEach(function (key) {
      var match = key.match(/^_tm_branding_mockup_(\d+)$/);
      if (!match) return;

      var image = this.normalizeStudioPreviewUrl(properties[key]);
      if (!image) return;

      var index = match[1];
      var zoneId = String(properties['_tm_branding_mockup_' + index + '_zone_id'] || '').trim();
      var viewId = String(properties['_tm_branding_mockup_' + index + '_view_id'] || '').trim();
      var keyValue = viewId || zoneId || ('branding-mockup-' + index);
      if (usedKeys[keyValue]) keyValue = zoneId && !usedKeys[zoneId] ? zoneId : ('branding-mockup-' + index);
      usedKeys[keyValue] = true;
      var label = this.getMarkingZoneLabel(zoneId) || zoneId || viewId || this.translate('studioMockupLabel') || ('Mockup ' + index);

      views.push({
        key: keyValue,
        sourceViewId: viewId,
        zoneId: zoneId,
        label: label,
        image: image,
        alt: [productTitle, label].filter(Boolean).join(' - '),
        zones: [],
        zone: null,
        customized: true
      });
    }, this);

    return views;
  };

  QuoteBuilder.prototype.getLegacyItemMediaViewOptions = function (item) {
    var viewOptions = this.getItemViewOptions(item);
    var previewState = this.getItemStudioPreviewState(item);
    var previewViews = previewState.views || {};
    var previewViewIds = Object.keys(previewViews);
    var seen = {};
    var productTitle = String(item && (item.product_title || item.title) || '').trim();
    var mergedViews = previewViewIds.map(function (viewId) {
      var preview = previewViews[viewId];
      var baseView = viewOptions.find(function (view) {
        if (view.key === viewId) return true;
        if (preview.zoneId && this.viewMatchesStudioReference(view, preview.zoneId)) return true;
        return preview.sourceViewId && this.viewMatchesStudioReference(view, preview.sourceViewId);
      }, this);
      var label = preview.label || (baseView && baseView.label) || this.getMarkingZoneLabel(preview.zoneId || viewId) || viewId;
      var mergedView = Object.assign({}, baseView || {}, {
        key: baseView && baseView.key ? baseView.key : viewId,
        sourceViewId: preview.sourceViewId || (baseView && baseView.sourceViewId) || '',
        label: label,
        image: preview.image || (baseView && baseView.image),
        alt: preview.alt || (baseView && baseView.alt) || [productTitle, label].filter(Boolean).join(' - '),
        zones: baseView && Array.isArray(baseView.zones) ? baseView.zones : [],
        zone: baseView && baseView.zone ? baseView.zone : null,
        customized: preview.customized
      });
      seen[mergedView.key] = true;
      seen[viewId] = true;
      return mergedView;
    }, this);

    viewOptions.forEach(function (view) {
      if (!view || seen[view.key]) return;
      mergedViews.push(view);
    });

    if (previewViewIds.length) return mergedViews;

    var brandingMockups = this.getItemBrandingMockupViewOptions(item);
    if (brandingMockups.length) {
      return brandingMockups.map(function (mockup) {
        var baseView = viewOptions.find(function (view) {
          if (mockup.zoneId && this.viewMatchesStudioReference(view, mockup.zoneId)) return true;
          return mockup.sourceViewId && this.viewMatchesStudioReference(view, mockup.sourceViewId);
        }, this);

        return Object.assign({}, baseView || {}, mockup, {
          zones: baseView && Array.isArray(baseView.zones) ? baseView.zones : [],
          zone: baseView && baseView.zone ? baseView.zone : null
        });
      }, this);
    }

    var itemImage = item && item.image;
    if (itemImage && typeof itemImage === 'object') {
      itemImage = itemImage.src || itemImage.url || itemImage.preview_image && itemImage.preview_image.src || '';
    }
    itemImage = this.normalizeStudioPreviewUrl(itemImage);
    if (!itemImage || !mergedViews.length) return mergedViews;

    var firstSourceViewId = String(mergedViews[0].sourceViewId || mergedViews[0].key || '').trim();
    return mergedViews.map(function (view) {
      var sourceViewId = String(view && (view.sourceViewId || view.key) || '').trim();
      if (sourceViewId !== firstSourceViewId) return view;
      return Object.assign({}, view, { image: itemImage });
    });
  };

  QuoteBuilder.prototype.getItemMediaState = function (item) {
    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var viewOptions = this.getItemViewOptions(item);
    var resolver = window.TodayMerchStudioPreview;
    var itemImage = item && item.image;
    if (itemImage && typeof itemImage === 'object') {
      itemImage = itemImage.src || itemImage.url || itemImage.preview_image && itemImage.preview_image.src || '';
    }

    if (resolver && typeof resolver.resolveLinePreview === 'function') {
      try {
        var resolved = resolver.resolveLinePreview(properties, {
          viewOptions: viewOptions,
          itemImage: itemImage,
          variantId: item && (item.variant_id || item.id),
          productTitle: item && (item.product_title || item.title) || '',
          labelForId: function (id) {
            return this.getMarkingZoneLabel(id) || id;
          }.bind(this)
        }) || {};
        var resolvedViews = (Array.isArray(resolved.views) ? resolved.views : []).map(function (view, index) {
          var key = String(view && (view.key || view.viewId) || ('view-' + (index + 1))).trim();
          var sourceViewId = String(view && view.sourceViewId || '').trim();
          var sourceOption = viewOptions.find(function (option) {
            return option && option.key === key;
          }) || viewOptions.find(function (option) {
            return option && sourceViewId && String(option.sourceViewId || '') === sourceViewId;
          }) || viewOptions.find(function (option) {
            return option && view && view.zoneId && this.viewMatchesStudioReference(option, view.zoneId);
          }, this);
          var src = this.normalizeStudioPreviewUrl(view && view.src);
          if (!src) return null;

          return Object.assign({}, sourceOption || {}, {
            key: key,
            viewId: String(view && view.viewId || key).trim(),
            sourceViewId: sourceViewId || String(sourceOption && sourceOption.sourceViewId || '').trim(),
            zoneId: String(view && view.zoneId || '').trim(),
            label: String(view && view.label || sourceOption && sourceOption.label || key).trim(),
            alt: String(view && view.alt || sourceOption && sourceOption.alt || item && (item.product_title || item.title) || '').trim(),
            image: src,
            src: src,
            baseSrc: this.normalizeStudioPreviewUrl(view && view.baseSrc),
            compositeSrc: this.normalizeStudioPreviewUrl(view && view.compositeSrc),
            customized: Boolean(view && view.customized),
            overlay: view && view.overlay || null,
            artworks: Array.isArray(view && view.artworks) ? view.artworks : [],
            zones: sourceOption && Array.isArray(sourceOption.zones) ? sourceOption.zones : [],
            zone: sourceOption && sourceOption.zone || null
          });
        }, this).filter(Boolean);
        var activeKey = String(
          resolved.activeViewId ||
          resolved.activeView && (resolved.activeView.key || resolved.activeView.viewId) ||
          ''
        ).trim();
        var activeView = resolvedViews.find(function (view) {
          return view.key === activeKey || view.viewId === activeKey || view.sourceViewId === activeKey;
        }) || resolvedViews[0] || null;

        return {
          activeViewId: activeView ? activeView.key : '',
          activeView: activeView,
          views: resolvedViews,
          canonical: true
        };
      } catch (error) {
        // Keep the quote usable with its safe, non-fabricated local fallback.
      }
    }

    var fallbackViews = this.getLegacyItemMediaViewOptions(item);
    var fallbackActiveView = this.getPreferredViewOption(item, fallbackViews);
    return {
      activeViewId: fallbackActiveView ? fallbackActiveView.key : '',
      activeView: fallbackActiveView,
      views: fallbackViews,
      canonical: false
    };
  };

  QuoteBuilder.prototype.getItemMediaViewOptions = function (item) {
    return this.getItemMediaState(item).views;
  };

  QuoteBuilder.prototype.getPreferredViewOption = function (item, viewOptions) {
    var options = Array.isArray(viewOptions) ? viewOptions : [];
    if (!options.length) return null;

    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var previewState = this.getItemStudioPreviewState(item);
    var preferredValues = [
      previewState.activeViewId,
      properties._tm_studio_view_id,
      properties._studio_view,
      properties['Studio - Vue'],
      properties._studio_zone_key,
      properties['Studio - Zone']
    ].map(function (value) {
      return String(value || '').trim().toLowerCase();
    }).filter(Boolean);

    for (var i = 0; i < preferredValues.length; i += 1) {
      var preferred = preferredValues[i];
      var match = options.find(function (view) {
        return view.key.toLowerCase() === preferred ||
          String(view.sourceViewId || '').toLowerCase() === preferred ||
          view.label.toLowerCase() === preferred;
      });
      if (match) return match;
    }

    return options[0];
  };

  QuoteBuilder.prototype.normalizeLabelForMatch = function (value) {
    var label = String(value || '').trim().toLowerCase();
    if (typeof label.normalize === 'function') {
      label = label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return label;
  };

  QuoteBuilder.prototype.localizeOptionValue = function (value) {
    var rawValue = String(value || '').trim();
    var self = this;
    var labels = this.optionValueLabels && typeof this.optionValueLabels === 'object'
      ? this.optionValueLabels
      : {};
    if (!rawValue) return '';

    return rawValue.split(/(\s*(?:\/|·|,)\s*)/).map(function (part) {
      var key = self.normalizeLabelForMatch(part);
      return key && labels[key] ? labels[key] : part;
    }).join('');
  };

  QuoteBuilder.prototype.getResolvedArtworkOverlays = function (item, mediaState) {
    var state = mediaState || { views: [], canonical: false };
    var views = Array.isArray(state.views) ? state.views : [];
    if (!state.canonical) return [];

    return views.map(function (view) {
      var overlay = view && view.overlay;
      var reference = String(overlay && overlay.zoneId || view && view.zoneId || '').trim();
      var sourceZones = view && Array.isArray(view.zones) ? view.zones : [];
      var sourceZone = sourceZones.find(function (zone) {
        return this.zoneMatchesStudioReference(zone, reference);
      }, this) || (sourceZones.length === 1 ? sourceZones[0] : view && view.zone);
      var sourceParts = sourceZone && Array.isArray(sourceZone.parts) ? sourceZone.parts : [];
      var hasUnsupportedGeometry = sourceZone && (
        Math.abs(Number(sourceZone.rotation || 0)) > 0.0001 ||
        sourceParts.length > 1 ||
        sourceParts.some(function (part) { return Math.abs(Number(part && part.rotation || 0)) > 0.0001; })
      );
      var left = Number(overlay && overlay.left);
      var top = Number(overlay && overlay.top);
      var width = Number(overlay && overlay.width);
      var height = Number(overlay && overlay.height);
      if (
        !overlay || hasUnsupportedGeometry || !this.normalizeStudioPreviewUrl(overlay.src) ||
        !Number.isFinite(left) || !Number.isFinite(top) ||
        !Number.isFinite(width) || !Number.isFinite(height) ||
        width <= 0 || height <= 0
      ) return null;

      return {
        image: overlay.src,
        label: overlay.alt || view.alt || view.label || this.translate('originalDesignLabel'),
        viewKey: view.key || '',
        zone: {
          x: left,
          y: top,
          width: width,
          height: height,
          rotation: Number.isFinite(Number(overlay.rotation)) ? Number(overlay.rotation) : 0,
          parts: []
        }
      };
    }, this).filter(Boolean);
  };

  QuoteBuilder.prototype.buildItemArtworkHtml = function (item, mediaState, options) {
    var state = mediaState || { views: [], activeView: null, canonical: false };
    var viewOptions = Array.isArray(state.views) ? state.views : [];
    var activeView = state.activeView || null;
    var renderOptions = options || {};
    var overlays = this.getResolvedArtworkOverlays(item, state);
    if (!overlays.length) return '';

    return overlays.reduce(function (markup, overlay) {
      var overlayView = overlay.viewKey
        ? viewOptions.find(function (view) { return view.key === overlay.viewKey; })
        : activeView;
      if (!state.canonical && overlayView && overlayView.customized) return markup;
      var isActive = !overlay.viewKey || (activeView && overlay.viewKey === activeView.key);
      if (renderOptions.activeOnly && !isActive) return markup;
      var zone = overlay.zone || {};
      var parts = Array.isArray(zone.parts) && zone.parts.length ? zone.parts : [zone];
      return markup + parts.map(function (part) {
        var style = [
          '--qb-artwork-x:' + escapeHtml(part.x) + '%',
          '--qb-artwork-y:' + escapeHtml(part.y) + '%',
          '--qb-artwork-width:' + escapeHtml(part.width) + '%',
          '--qb-artwork-height:' + escapeHtml(part.height) + '%',
          '--qb-artwork-rotation:' + escapeHtml(part.rotation || 0) + 'deg'
        ].join(';');

        return (
          '<span class="' + (renderOptions.summary ? 'qb__summary-product-artwork' : 'quote-cart-item__artwork') + (isActive ? ' is-active' : '') + '" ' + (renderOptions.summary ? 'data-qb-summary-product-artwork' : 'data-qb-product-artwork') + ' data-view-key="' + escapeHtml(overlay.viewKey) + '" style="' + style + '"' + (isActive ? '' : ' hidden') + '>' +
            '<img src="' + escapeHtml(overlay.image) + '" alt="' + escapeHtml(overlay.label) + '" loading="lazy">' +
          '</span>'
        );
      }).join('');
    }, '');
  };

  QuoteBuilder.prototype.syncProductMediaStage = function (image) {
    if (!image || typeof image.closest !== 'function') return;
    var stage = image.closest('[data-qb-media-stage]');
    var media = stage && stage.parentElement;
    if (!stage || !media) return;

    var self = this;
    if (!image._qbMediaStageLoadHandler) {
      image._qbMediaStageLoadHandler = function () { self.syncProductMediaStage(image); };
      image.addEventListener('load', image._qbMediaStageLoadHandler);
    }

    var naturalWidth = Number(image.naturalWidth || 0);
    var naturalHeight = Number(image.naturalHeight || 0);
    var mediaWidth = Number(media.clientWidth || 0);
    var mediaHeight = Number(media.clientHeight || 0);
    if (!(naturalWidth > 0) || !(naturalHeight > 0) || !(mediaWidth > 0) || !(mediaHeight > 0)) {
      stage.removeAttribute('data-qb-media-stage-ready');
      return;
    }

    var imageRatio = naturalWidth / naturalHeight;
    var mediaRatio = mediaWidth / mediaHeight;
    var widthPercent = imageRatio >= mediaRatio ? 100 : (imageRatio / mediaRatio) * 100;
    var heightPercent = imageRatio >= mediaRatio ? (mediaRatio / imageRatio) * 100 : 100;
    stage.style.width = widthPercent + '%';
    stage.style.height = heightPercent + '%';
    stage.style.aspectRatio = naturalWidth + ' / ' + naturalHeight;
    stage.setAttribute('data-qb-media-stage-ready', 'true');
  };

  QuoteBuilder.prototype.syncProductMediaStages = function (container) {
    var scope = container || this.root;
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    scope.querySelectorAll('[data-qb-media-stage] > [data-qb-product-image], [data-qb-media-stage] > [data-qb-summary-product-image]').forEach(function (image) {
      this.syncProductMediaStage(image);
    }, this);
  };

  QuoteBuilder.prototype.buildItemMediaHtml = function (item, title) {
    var mediaState = this.getItemMediaState(item);
    var viewOptions = mediaState.views;
    var activeView = mediaState.activeView;
    var image = activeView && activeView.image ? activeView.image : item.image;
    var imageAlt = activeView && activeView.alt ? activeView.alt : (item.product_title || item.title || title || '');
    var artworkHtml = this.buildItemArtworkHtml(item, mediaState);

    if (!image) {
      return (
        '<div class="quote-cart-item__visual" data-qb-product-visual>' +
          '<div class="quote-cart-item__media quote-cart-item__media--placeholder">' + escapeHtml(this.translate('noVisualLabel')) + '</div>' +
        '</div>'
      );
    }

    var switcherHtml = '';
    if (viewOptions.length > 1) {
      switcherHtml = (
        '<div class="quote-cart-item__view-switcher" role="group" aria-label="' + escapeHtml(this.translate('productViewsLabel')) + '">' +
          '<span class="quote-cart-item__view-indicator" data-qb-product-view-indicator aria-hidden="true"></span>' +
          viewOptions.map(function (view) {
            var isActive = activeView && view.key === activeView.key;
            return (
              '<button class="quote-cart-item__view-button' + (isActive ? ' is-active' : '') + '" type="button" data-qb-product-view data-view-key="' + escapeHtml(view.key) + '" data-image="' + escapeHtml(view.image) + '" data-alt="' + escapeHtml(view.alt || imageAlt) + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">' +
                escapeHtml(view.label) +
              '</button>'
            );
          }).join('') +
        '</div>'
      );
    }

    return (
      '<div class="quote-cart-item__visual" data-qb-product-visual>' +
        '<a class="quote-cart-item__media media-wrapper" data-qb-product-media href="' + escapeHtml(item.url || '#') + '" tabindex="-1" aria-label="' + escapeHtml(title) + '">' +
          '<span class="quote-cart-item__media-stage" data-qb-media-stage>' +
            '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy" data-qb-product-image>' +
            artworkHtml +
          '</span>' +
        '</a>' +
        switcherHtml +
      '</div>'
    );
  };

  QuoteBuilder.prototype.syncProductViewSwitcher = function (switcher, options) {
    if (!switcher) return;
    var opts = options || {};
    var activeButton = switcher.querySelector('[data-qb-product-view].is-active') || switcher.querySelector('[data-qb-product-view][aria-pressed="true"]');
    if (!activeButton) return;

    var buttonWidth = activeButton.offsetWidth;
    if (!buttonWidth) {
      if (opts.deferIfUnmeasured !== false) this.scheduleProductViewSwitcherSync(switcher, opts);
      return;
    }

    if (switcher._qbViewSwitcherRetryFrame) {
      window.cancelAnimationFrame(switcher._qbViewSwitcherRetryFrame);
      switcher._qbViewSwitcherRetryFrame = null;
    }
    if (switcher._qbViewSwitcherResizeObserver) {
      switcher._qbViewSwitcherResizeObserver.disconnect();
      switcher._qbViewSwitcherResizeObserver = null;
    }

    var buttonX = activeButton.offsetLeft - switcher.scrollLeft;
    var indicator = switcher.querySelector('[data-qb-product-view-indicator]');

    if (opts.animate === false) {
      switcher.style.setProperty('--qb-view-tab-x', buttonX + 'px');
      switcher.style.setProperty('--qb-view-tab-w', buttonWidth + 'px');
      if (indicator) {
        indicator.style.transition = 'none';
        indicator.style.width = buttonWidth + 'px';
        indicator.style.transform = 'translate3d(' + buttonX + 'px, 0, 0)';
        void indicator.offsetWidth;
        indicator.style.transition = '';
      }
      return;
    }

    var beforeStyle = window.getComputedStyle(switcher, '::before');
    var indicatorStyle = indicator ? window.getComputedStyle(indicator) : beforeStyle;
    var currentX = buttonX;
    var currentWidth = parseFloat(indicatorStyle.width) || buttonWidth;
    var transform = indicatorStyle.transform || '';
    var matrix = transform.match(/^matrix\((.+)\)$/);
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);

    if (matrix) {
      currentX = parseFloat(matrix[1].split(',')[4]) || 0;
    } else if (matrix3d) {
      currentX = parseFloat(matrix3d[1].split(',')[12]) || 0;
    } else {
      currentX = parseFloat(window.getComputedStyle(switcher).getPropertyValue('--qb-view-tab-x')) || buttonX;
    }

    window.clearTimeout(switcher._qbViewSwitcherTimer);
    if (switcher._qbViewSwitcherFrame) window.cancelAnimationFrame(switcher._qbViewSwitcherFrame);

    switcher.classList.add('is-view-switching');
    switcher.style.setProperty('--qb-view-tab-x', currentX + 'px');
    switcher.style.setProperty('--qb-view-tab-w', currentWidth + 'px');

    if (indicator) {
      indicator.style.transition = 'none';
      indicator.style.width = currentWidth + 'px';
      indicator.style.transform = 'translate3d(' + currentX + 'px, 0, 0)';
      void indicator.offsetWidth;
      indicator.style.transition = '';
    } else {
      void switcher.offsetWidth;
    }

    switcher._qbViewSwitcherFrame = window.requestAnimationFrame(function () {
      switcher._qbViewSwitcherFrame = window.requestAnimationFrame(function () {
        switcher.style.setProperty('--qb-view-tab-x', buttonX + 'px');
        switcher.style.setProperty('--qb-view-tab-w', buttonWidth + 'px');
        if (indicator) {
          indicator.style.width = buttonWidth + 'px';
          indicator.style.transform = 'translate3d(' + buttonX + 'px, 0, 0)';
        }
      });
    });

    switcher._qbViewSwitcherTimer = window.setTimeout(function () {
      switcher.classList.remove('is-view-switching');
    }, 760);
  };

  QuoteBuilder.prototype.scheduleProductViewSwitcherSync = function (switcher, options) {
    if (!switcher) return;
    if (switcher._qbViewSwitcherRetryFrame && typeof window.cancelAnimationFrame === 'function') {
      window.cancelAnimationFrame(switcher._qbViewSwitcherRetryFrame);
      switcher._qbViewSwitcherRetryFrame = null;
    }
    if (switcher._qbViewSwitcherResizeObserver) {
      switcher._qbViewSwitcherResizeObserver.disconnect();
      switcher._qbViewSwitcherResizeObserver = null;
    }

    var self = this;
    var opts = Object.assign({}, options || {});
    var attempts = 0;
    var maxAttempts = 8;

    var syncWhenMeasurable = function () {
      if (!switcher.isConnected) {
        if (switcher._qbViewSwitcherResizeObserver) {
          switcher._qbViewSwitcherResizeObserver.disconnect();
          switcher._qbViewSwitcherResizeObserver = null;
        }
        return false;
      }

      var activeButton = switcher.querySelector('[data-qb-product-view].is-active') || switcher.querySelector('[data-qb-product-view][aria-pressed="true"]');
      if (!activeButton || !activeButton.offsetWidth) return false;
      self.syncProductViewSwitcher(switcher, Object.assign({}, opts, { deferIfUnmeasured: false }));
      return true;
    };

    if (typeof window.ResizeObserver === 'function') {
      switcher._qbViewSwitcherResizeObserver = new window.ResizeObserver(function () {
        syncWhenMeasurable();
      });
      switcher._qbViewSwitcherResizeObserver.observe(switcher);
    }

    if (typeof window.requestAnimationFrame !== 'function') return;

    var retry = function () {
      switcher._qbViewSwitcherRetryFrame = null;
      if (syncWhenMeasurable() || !switcher.isConnected) return;

      attempts += 1;
      if (attempts < maxAttempts) {
        switcher._qbViewSwitcherRetryFrame = window.requestAnimationFrame(retry);
      }
    };

    switcher._qbViewSwitcherRetryFrame = window.requestAnimationFrame(retry);
  };

  QuoteBuilder.prototype.syncProductViewSwitchers = function (container, options) {
    var scope = container || this.root;
    if (!scope) return;
    scope.querySelectorAll('.quote-cart-item__view-switcher').forEach(function (switcher) {
      this.syncProductViewSwitcher(switcher, options);
    }, this);
  };

  QuoteBuilder.prototype.buildEditUrl = function (item) {
    var baseUrl = item && item.url ? item.url : '#';
    if (!item || !item.key || baseUrl === '#') return baseUrl;

    try {
      var url = new URL(baseUrl, window.location.origin);
      if (item.variant_id && !url.searchParams.get('variant')) {
        url.searchParams.set('variant', item.variant_id);
      }
      url.searchParams.set('tm_edit_line', item.key);
      url.searchParams.set('tm_return', window.location.pathname + window.location.search);
      url.searchParams.set('studio', '1');
      return url.pathname + url.search + url.hash;
    } catch (error) {
      var separator = baseUrl.indexOf('?') >= 0 ? '&' : '?';
      return baseUrl + separator + 'tm_edit_line=' + encodeURIComponent(item.key) + '&tm_return=' + encodeURIComponent(window.location.pathname + window.location.search) + '&studio=1';
    }
  };

  QuoteBuilder.prototype.switchProductView = function (button) {
    if (!button) return;
    var visual = button.closest('[data-qb-product-visual]');
    if (!visual) return;

    var nextImage = button.getAttribute('data-image');
    if (!nextImage) return;

    var image = visual.querySelector('[data-qb-product-image]');
    if (image) {
      image.src = nextImage;
      image.alt = button.getAttribute('data-alt') || image.alt;
      this.syncProductMediaStage(image);
    }

    var viewKey = button.getAttribute('data-view-key') || '';
    visual.querySelectorAll('[data-qb-product-artwork]').forEach(function (artwork) {
      var isActive = !artwork.getAttribute('data-view-key') || artwork.getAttribute('data-view-key') === viewKey;
      artwork.hidden = !isActive;
      artwork.classList.toggle('is-active', isActive);
    });

    visual.querySelectorAll('[data-qb-product-view]').forEach(function (viewButton) {
      var isActive = viewButton === button;
      viewButton.classList.toggle('is-active', isActive);
      viewButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.syncProductViewSwitcher(button.closest('.quote-cart-item__view-switcher'));
  };

  QuoteBuilder.prototype.money = function (cents) {
    if (cents == null || !Number.isFinite(Number(cents))) return '—';
    if (window.TodayMerchQuantityPricing && typeof window.TodayMerchQuantityPricing.formatMoney === 'function') {
      return window.TodayMerchQuantityPricing.formatMoney(cents);
    }

    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(this.config.locale || document.documentElement.lang || undefined, {
        style: 'currency',
        currency: this.config.currency || 'EUR',
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + (this.config.currency || 'EUR');
    }
  };

  QuoteBuilder.prototype.unitLabel = function (count) {
    return this.translate(this.getPluralCategory(count) === 'one' ? 'unitSingular' : 'unitPlural');
  };

  QuoteBuilder.prototype.referencesLabel = function (count) {
    return this.translate(this.getPluralCategory(count) === 'one' ? 'referenceSingular' : 'referencePlural');
  };

  QuoteBuilder.prototype.getDisplayPricing = function (item) {
    if (window.TodayMerchQuantityPricing && typeof window.TodayMerchQuantityPricing.getDisplayPricing === 'function') {
      var pricing = window.TodayMerchQuantityPricing.getDisplayPricing(item || {});
      var separated = applySeparateSupplierFees(item || {}, pricing);
      if (separated) return separated;
      if (pricing) return pricing;
    }

    var separatedFallback = applySeparateSupplierFees(item || {}, null);
    if (separatedFallback) return separatedFallback;

    var properties = item && item.properties || {};
    var hasCustomPricing = properties._pricing_native !== true && properties._pricing_native !== 'true' && !!(properties._pricing_tiers || properties._applied_unit_price_cents);
    return {
      estimated: hasCustomPricing,
      valid: !hasCustomPricing,
      currency: window.TodayMerchMoney ? window.TodayMerchMoney.activeCurrency() : (this.config && this.config.currency) || 'EUR',
      unitPriceCents: hasCustomPricing ? null : Number(item && item.final_price || 0),
      linePriceCents: hasCustomPricing ? null : Number(item && item.final_line_price || 0),
      discountPct: 0,
      appliedTierQty: null,
      pricingMode: 'native'
    };
  };

  QuoteBuilder.prototype.getRegularUnitPriceCents = function (item, pricing) {
    if (pricing && pricing.valid === false) return 0;
    var currentUnitPrice = Number(pricing && pricing.unitPriceCents || item && item.final_price || 0);
    var variantId = item && (item.variant_id || item.id);
    var configuredPrice = Number(
      this.regularUnitPrices[item && item.key] ||
      this.regularUnitPrices['variant:' + variantId] ||
      0
    );
    var priceCandidates = [
      configuredPrice,
      Number(item && item.original_price || 0),
      Number(item && item.price || 0),
      Number(item && item.final_price || 0)
    ];
    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};

    if (window.TodayMerchQuantityPricing && typeof window.TodayMerchQuantityPricing.parseTiers === 'function') {
      var tiers = window.TodayMerchQuantityPricing.parseTiers(properties._pricing_tiers);
      if (tiers.length && properties._pricing_native !== true && properties._pricing_native !== 'true') {
        var tierPrice = Number(tiers[0].unit_price_cents || 0);
        if (window.TodayMerchMoney) tierPrice = window.TodayMerchMoney.convert(tierPrice, properties._pricing_currency || window.TodayMerchMoney.baseCurrency());
        if (tierPrice !== null) priceCandidates.push(tierPrice);
      }
    }

    var regularUnitPrice = Math.max.apply(Math, priceCandidates);
    return regularUnitPrice > currentUnitPrice ? regularUnitPrice : 0;
  };

  QuoteBuilder.prototype.status = function (message, isError) {
    if (!this.statusEl) return;
    this.statusEl.textContent = message || '';
    this.statusEl.hidden = !message;
    this.statusEl.style.color = isError ? '#c84d36' : '';
    this.statusEl.setAttribute('role', isError ? 'alert' : 'status');
    if (message && isError) {
      try { this.statusEl.focus({ preventScroll: true }); } catch (error) {}
      try { this.statusEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (error) {}
    }
  };

  QuoteBuilder.prototype.getHeaderHeight = function () {
    var header = document.querySelector('.quote-conversion-header, header[is="sticky-header"], sticky-header, #shopify-section-header, .header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    return Math.max(0, Math.round(rect.height || header.offsetHeight || 0));
  };

  QuoteBuilder.prototype.getWizardHeight = function () {
    if (!this.wizardEl) return 0;
    if (this.wizardEl.closest && this.wizardEl.closest('.quote-conversion-header')) return 0;
    var rect = this.wizardEl.getBoundingClientRect();
    return Math.max(0, Math.round(rect.height || this.wizardEl.offsetHeight || 0));
  };

  QuoteBuilder.prototype.getHeaderOffset = function () {
    return Math.max(20, this.getHeaderHeight() + this.getWizardHeight() + 20);
  };

  QuoteBuilder.prototype.setStickyOffset = function () {
    var headerHeight = this.getHeaderHeight();
    this.root.style.setProperty('--qb-header-height', headerHeight + 'px');
    this.root.style.setProperty('--qb-wizard-top', headerHeight + 'px');
    this.root.style.setProperty('--qb-sticky-top', this.getHeaderOffset() + 'px');
  };

  QuoteBuilder.prototype.getWizardStepLabel = function (step) {
    var labels = {
      1: this.translate('wizardStepProductsLabel'),
      2: this.translate('wizardStepBriefLabel'),
      3: this.translate('wizardStepContactLabel')
    };
    return labels[step] || this.translate('wizardStepFallback', { number: step });
  };

  QuoteBuilder.prototype.updateSplitSummaryProgress = function (step) {
    if (!this.progressLabelEl && !this.progressTrackEl && !this.progressFillEl) return;

    var currentStep = Math.min(Math.max(Number(step) || 1, 1), this.totalWizardSteps);
    var progressValue = currentStep / this.totalWizardSteps * 100;

    if (this.progressLabelEl) {
      this.progressLabelEl.textContent = currentStep + '/' + this.totalWizardSteps + ' ' + this.getWizardStepLabel(currentStep);
    }
    if (this.progressTrackEl) {
      this.progressTrackEl.setAttribute('aria-valuemax', String(this.totalWizardSteps));
      this.progressTrackEl.setAttribute('aria-valuenow', String(currentStep));
      this.progressTrackEl.setAttribute('aria-valuetext', this.getWizardStepLabel(currentStep));
    }
    if (this.progressFillEl) {
      this.progressFillEl.style.setProperty('--qb-progress-value', progressValue + '%');
    }
    if (this.progressBackEl) this.progressBackEl.hidden = currentStep <= 1;
    if (this.progressCatalogBackEl) this.progressCatalogBackEl.hidden = currentStep > 1;
  };

  QuoteBuilder.prototype.getStepPanel = function (step) {
    return this.stepPanels.find(function (panel) {
      return Number(panel.getAttribute('data-qb-step')) === Number(step);
    }) || null;
  };

  QuoteBuilder.prototype.focusWizardElement = function (element) {
    if (!element) return;
    if (typeof element.scrollIntoView === 'function') {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function focusTarget() {
      if (typeof element.focus !== 'function') return;
      var active = document.activeElement;
      var activeTag = active && active.tagName ? active.tagName.toLowerCase() : '';
      var activeInsideBuilder = active && typeof active.closest === 'function' ? active.closest('[data-qb-root]') : null;
      var userMovedFocus = active && active !== element && activeInsideBuilder && activeTag !== 'iframe' && !active.matches('[data-qb-submit], [data-qb-mobile-submit]');
      if (userMovedFocus) return;
      try {
        element.focus({ preventScroll: true });
      } catch (error) {
        element.focus();
      }
    }
    focusTarget();
    [80, 260, 700, 1200].forEach(function (delay) {
      window.setTimeout(focusTarget, delay);
    });
  };

  QuoteBuilder.prototype.scrollToWizardStep = function () {
    var target = this.getStepPanel(this.currentStep) || this.wizardEl || this.root;
    if (!target || typeof window.scrollTo !== 'function') return;
    var rect = target.getBoundingClientRect();
    var offset = this.getHeaderOffset();
    var top = Math.max(0, Math.round(rect.top + window.pageYOffset - offset));
    window.scrollTo({ top: top, behavior: 'smooth' });
  };

  QuoteBuilder.prototype.setCurrentWizardStep = function (step, options) {
    var nextStep = Math.min(Math.max(Number(step) || 1, 1), this.totalWizardSteps);
    var shouldScroll = options && options.scroll;
    this.currentStep = nextStep;
    this.maxWizardStep = Math.max(this.maxWizardStep, nextStep);
    this.root.setAttribute('data-qb-current-step', String(nextStep));
    this.root.classList.toggle('is-final-step', nextStep === this.totalWizardSteps);

    this.stepPanels.forEach(function (panel) {
      var panelStep = Number(panel.getAttribute('data-qb-step')) || 1;
      var isActive = panelStep === nextStep;
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.stepNavButtons.forEach(function (button) {
      var buttonStep = Number(button.getAttribute('data-qb-step-nav')) || 1;
      var isCurrent = buttonStep === nextStep;
      var isReachable = buttonStep <= this.maxWizardStep;
      var isComplete = buttonStep < this.maxWizardStep && !isCurrent;
      var state = isCurrent ? 'current' : (isComplete ? 'complete' : 'todo');
      var stateLabel = isCurrent
        ? this.translate('wizardStatusCurrent')
        : (isComplete ? this.translate('wizardStatusComplete') : this.translate('wizardStatusTodo'));
      var labelEl = button.querySelector('.qb__wizard-label');
      var stateEl = button.querySelector('[data-qb-step-state]');

      button.disabled = !isReachable;
      button.classList.toggle('is-current', isCurrent);
      button.classList.toggle('is-complete', isComplete);
      button.classList.toggle('is-todo', state === 'todo');
      button.setAttribute('data-qb-step-state-value', state);
      button.setAttribute('aria-current', isCurrent ? 'step' : 'false');
      button.setAttribute('aria-disabled', isReachable ? 'false' : 'true');
      if (labelEl) labelEl.textContent = buttonStep + '. ' + this.getWizardStepLabel(buttonStep);
      if (stateEl) stateEl.textContent = stateLabel;
      if (isComplete) {
        button.setAttribute('aria-label', this.translate('editItemLabel', { title: this.getWizardStepLabel(buttonStep) }));
      } else {
        button.setAttribute('aria-label', this.getWizardStepLabel(buttonStep) + ' : ' + stateLabel);
      }
    }, this);

    if (this.stepPrevEl) this.stepPrevEl.hidden = nextStep === 1;
    if (this.stepNextEl) {
      this.stepNextEl.hidden = nextStep === this.totalWizardSteps;
      this.stepNextEl.textContent = this.translate('wizardContinueLabel');
    }
    if (this.mobileContextEl) {
      this.mobileContextEl.textContent = nextStep === this.totalWizardSteps
        ? this.translate('subtotalProductsLabel')
        : this.getWizardStepLabel(nextStep + 1);
    }
    if (this.wizardAssuranceEl) {
      this.wizardAssuranceEl.textContent = this.translate('wizardAssuranceText');
    }

    this.updateSplitSummaryProgress(nextStep);

    this.setStickyOffset();
    this.updateSubmitState();
    if (shouldScroll) this.scrollToWizardStep();
  };

  QuoteBuilder.prototype.validateInputsInStep = function (step) {
    var panel = this.getStepPanel(step);
    if (!panel) return { valid: true, element: null };
    var valid = true;
    var firstInvalid = null;
    var self = this;

    panel.querySelectorAll('[data-qb-field-wrapper] input, [data-qb-field-wrapper] textarea, [data-qb-field-wrapper] select').forEach(function (input) {
      if (!self.validateInput(input)) {
        valid = false;
        if (!firstInvalid) firstInvalid = input;
      }
    });

    return { valid: valid, element: firstInvalid };
  };

  QuoteBuilder.prototype.validateWizardStep = function (step) {
    var stepNumber = Number(step) || this.currentStep;
    var result;

    if (stepNumber === 1) {
      if (!this.cart.items.length) {
        this.status(this.translate('submitEmpty'), true);
        this.focusWizardElement(this.cartItemsEl);
        return false;
      }
      result = this.validateSizeBreakdowns();
      if (!result.valid) {
        this.focusWizardElement(result.element || this.cartItemsEl);
        return false;
      }
      this.status('', false);
      return true;
    }

    if (stepNumber === 2) {
      this.syncProgressiveBrief();
      if (!this.validateTargetDateChoice()) {
        this.focusWizardElement(this.targetDateChoiceGroup);
        return false;
      }
      this.syncProjectOther();
      result = this.validateInputsInStep(2);
      if (!result.valid) {
        this.focusWizardElement(result.element);
        return false;
      }
      this.syncShippingUI();
      if (!this.validateShipping()) {
        this.focusWizardElement(this.shippingDecisionGroup || this.shippingModeGroup);
        return false;
      }
      return true;
    }

    return this.validateForm();
  };

  QuoteBuilder.prototype.goToNextWizardStep = function () {
    if (this.submitLoading) return;
    if (!this.validateWizardStep(this.currentStep)) return;
    if (this.currentStep >= this.totalWizardSteps) {
      if (this.form && typeof this.form.requestSubmit === 'function') {
        var submit = this.form.querySelector('[data-qb-submit]');
        this.form.requestSubmit(submit || undefined);
      } else if (this.form) {
        this.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
      return;
    }
    this.setCurrentWizardStep(this.currentStep + 1, { scroll: true });
  };

  QuoteBuilder.prototype.goToPreviousWizardStep = function () {
    if (this.submitLoading || this.currentStep <= 1) return;
    this.setCurrentWizardStep(this.currentStep - 1, { scroll: true });
  };

  QuoteBuilder.prototype.goToWizardStep = function (step) {
    var targetStep = Number(step) || 1;
    if (targetStep > this.maxWizardStep || targetStep === this.currentStep) return;
    for (var candidate = this.currentStep; candidate < targetStep; candidate += 1) {
      if (!this.validateWizardStep(candidate)) return;
    }
    this.setCurrentWizardStep(targetStep, { scroll: true });
  };

  QuoteBuilder.prototype.getShippingState = function () {
    var decision = this.form.querySelector('[data-qb-shipping-decision]:checked');
    var mode = this.form.querySelector('[data-qb-shipping-mode]:checked');
    if (!decision) {
      return { label: this.translate('shippingUndecidedLabel'), timing: '', mode: '' };
    }
    if (decision.getAttribute('data-qb-shipping-decision') === 'later') {
      return { label: this.translate('shippingLaterLabel') || decision.value, timing: decision.value, mode: '' };
    }
    if (!mode) {
      return { label: this.translate('shippingPendingLabel'), timing: decision.value, mode: '' };
    }
    var modeKey = mode.getAttribute('data-qb-shipping-mode') === 'multiple' ? 'shippingMultiLabel' : 'shippingSingleLabel';
    var modeLabel = this.translate(modeKey);
    return { label: modeLabel, timing: decision.value, mode: modeLabel };
  };

  QuoteBuilder.prototype.syncShippingUI = function () {
    var decision = this.form.querySelector('[data-qb-shipping-decision]:checked');
    var isNow = decision && decision.getAttribute('data-qb-shipping-decision') === 'now';
    if (this.shippingDetailEl) this.shippingDetailEl.hidden = !isNow;

    this.shippingModeInputs.forEach(function (input) {
      input.disabled = !isNow;
      if (!isNow) input.checked = false;
    });

    var selectedMode = this.form.querySelector('[data-qb-shipping-mode]:checked');
    var selectedModeValue = selectedMode ? selectedMode.getAttribute('data-qb-shipping-mode') : '';
    var isSingle = Boolean(isNow && selectedModeValue === 'single');
    var isMultiple = Boolean(isNow && selectedModeValue === 'multiple');

    if (this.shippingSingleAddressEl) this.shippingSingleAddressEl.hidden = !isSingle;
    this.shippingSingleAddressInputs.forEach(function (input) {
      input.disabled = !isSingle;
    });

    if (this.shippingMultiNoteEl) {
      this.shippingMultiNoteEl.hidden = !isMultiple;
    }
  };

  QuoteBuilder.prototype.syncProjectOther = function () {
    if (!this.projectSelect) return;
    this.syncProjectCards();
  };

  QuoteBuilder.prototype.syncProjectCards = function () {
    if (!this.projectCards || !this.projectCards.length || !this.projectSelect) return;
    var selectedValue = String(this.projectSelect.value || '');

    this.projectCards.forEach(function (card) {
      var isSelected = card.getAttribute('data-qb-project-value') === selectedValue;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  };

  QuoteBuilder.prototype.setProjectChoice = function (value) {
    if (!this.projectSelect) return;
    this.projectSelect.value = value || '';
    this.syncProjectOther();
    this.syncProgressiveBrief();
    this.validateInput(this.projectSelect);
    this.syncSummary();
    this.syncHiddenFields();
    this.saveState();
    this.updateSubmitState();
  };

  QuoteBuilder.prototype.hasCompleteProjectChoice = function () {
    if (!this.projectSelect) return false;
    return Boolean(String(this.projectSelect.value || '').trim());
  };

  QuoteBuilder.prototype.getTargetDateChoice = function () {
    if (!this.form) return null;
    return this.form.querySelector('[data-qb-target-date-choice]:checked');
  };

  QuoteBuilder.prototype.isExactTargetDateChoice = function (choice) {
    if (!choice || typeof choice.getAttribute !== 'function') return false;
    var value = choice.getAttribute('data-qb-target-date-choice');
    return value === 'exact' || value === 'yes';
  };

  QuoteBuilder.prototype.padDatePart = function (value) {
    return ('0' + value).slice(-2);
  };

  QuoteBuilder.prototype.getTodayDate = function () {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  };

  QuoteBuilder.prototype.getMinimumTargetDate = function () {
    var date = this.getTodayDate();
    var offset = Number(this.config.targetDateMinimumDays);
    if (!Number.isFinite(offset) || offset < 1) offset = 7;
    date.setDate(date.getDate() + offset);
    return date;
  };

  QuoteBuilder.prototype.addDays = function (date, amount) {
    var next = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    next.setDate(next.getDate() + amount);
    return next;
  };

  QuoteBuilder.prototype.formatDateISO = function (date) {
    return [
      date.getFullYear(),
      this.padDatePart(date.getMonth() + 1),
      this.padDatePart(date.getDate())
    ].join('-');
  };

  QuoteBuilder.prototype.parseISODate = function (value) {
    var parts = String(value || '').split('-');
    if (parts.length !== 3) return null;
    var year = Number(parts[0]);
    var month = Number(parts[1]);
    var day = Number(parts[2]);
    if (!year || !month || !day) return null;
    var date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    return date;
  };

  QuoteBuilder.prototype.formatLocalizedDate = function (date, options) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';

    try {
      return new Intl.DateTimeFormat(this.config.locale, options || {}).format(date);
    } catch (error) {
      return this.formatDateISO(date);
    }
  };

  QuoteBuilder.prototype.formatCalendarMonthLabel = function (date) {
    return this.formatLocalizedDate(date, { month: 'long', year: 'numeric' });
  };

  QuoteBuilder.prototype.formatSelectedDateLabel = function (value) {
    var date = this.parseISODate(value);
    if (!date) return '';
    return this.formatLocalizedDate(date, { weekday: 'long', day: 'numeric', month: 'long' });
  };

  QuoteBuilder.prototype.formatDateStripWeekday = function (date) {
    return this.formatLocalizedDate(date, { weekday: 'short' });
  };

  QuoteBuilder.prototype.formatDateStripMonth = function (date) {
    return this.formatLocalizedDate(date, { month: 'short' });
  };

  QuoteBuilder.prototype.getDateStripWindowSize = function () {
    return 10;
  };

  QuoteBuilder.prototype.ensureDateStripStart = function () {
    var minimumDate = this.getMinimumTargetDate();
    var selectedDate = this.targetDateInput ? this.parseISODate(this.targetDateInput.value) : null;
    var startDate = this.dateStripStartDate || selectedDate || minimumDate;
    var stripSize = this.getDateStripWindowSize();

    if (startDate < minimumDate) startDate = minimumDate;

    if (selectedDate && this.dateStripStartDate) {
      var endDate = this.addDays(startDate, stripSize - 1);
      if (selectedDate < startDate || selectedDate > endDate) {
        startDate = selectedDate < minimumDate ? minimumDate : selectedDate;
      }
    }

    this.dateStripStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    return this.dateStripStartDate;
  };

  QuoteBuilder.prototype.renderTargetDateStrip = function () {
    if (!this.dateStripDaysEl) return;

    var startDate = this.ensureDateStripStart();
    var selectedValue = this.targetDateInput ? String(this.targetDateInput.value || '') : '';
    var stripSize = this.getDateStripWindowSize();
    var minimumDate = this.getMinimumTargetDate();

    if (this.dateStripPrevEl) this.dateStripPrevEl.disabled = startDate <= minimumDate;

    this.dateStripDaysEl.innerHTML = '';

    for (var index = 0; index < stripSize; index += 1) {
      var date = this.addDays(startDate, index);
      var iso = this.formatDateISO(date);
      var isSelected = selectedValue === iso;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'qb__date-strip-day' + (isSelected ? ' is-selected' : '');
      button.setAttribute('data-qb-date-strip-day', iso);
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      button.setAttribute('aria-label', this.formatSelectedDateLabel(iso));
      button.innerHTML = [
        '<span class="qb__date-strip-weekday">',
        escapeHtml(this.formatDateStripWeekday(date)),
        '</span>',
        '<span class="qb__date-strip-number">',
        escapeHtml(date.getDate()),
        '</span>',
        '<span class="qb__date-strip-month">',
        escapeHtml(this.formatDateStripMonth(date)),
        '</span>'
      ].join('');
      this.dateStripDaysEl.appendChild(button);
    }
  };

  QuoteBuilder.prototype.changeDateStrip = function (direction) {
    var startDate = this.ensureDateStripStart();
    var minimumDate = this.getMinimumTargetDate();
    var nextDate = this.addDays(startDate, direction * 7);
    if (nextDate < minimumDate) nextDate = minimumDate;
    this.dateStripStartDate = nextDate;
    this.renderTargetDateStrip();
  };

  QuoteBuilder.prototype.toggleTargetCalendarPopover = function (forceOpen) {
    if (!this.calendarPopoverEl) return;
    var shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : this.calendarPopoverEl.hidden;
    this.calendarPopoverEl.hidden = !shouldOpen;
    if (this.calendarToggleEl) this.calendarToggleEl.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    if (this.targetDateField) this.targetDateField.classList.toggle('is-calendar-open', shouldOpen);
  };

  QuoteBuilder.prototype.ensureCalendarMonth = function () {
    var selectedDate = this.targetDateInput ? this.parseISODate(this.targetDateInput.value) : null;
    var minimumDate = this.getMinimumTargetDate();
    var currentMonth = new Date(minimumDate.getFullYear(), minimumDate.getMonth(), 1);
    var monthDate = this.calendarMonthDate || selectedDate || minimumDate;
    monthDate = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
    if (monthDate < currentMonth) monthDate = currentMonth;
    this.calendarMonthDate = monthDate;
    return monthDate;
  };

  QuoteBuilder.prototype.renderTargetDateCalendar = function () {
    if (!this.calendarGridEl) return;

    var monthDate = this.ensureCalendarMonth();
    var minimumDate = this.getMinimumTargetDate();
    var currentMonth = new Date(minimumDate.getFullYear(), minimumDate.getMonth(), 1);
    var selectedValue = this.targetDateInput ? String(this.targetDateInput.value || '') : '';
    var selectedDate = selectedValue ? this.parseISODate(selectedValue) : null;

    if (selectedDate && selectedDate < minimumDate) {
      selectedValue = '';
      selectedDate = null;
      if (this.targetDateInput) this.targetDateInput.value = '';
    }

    if (selectedDate) {
      this.calendarMonthDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
      monthDate = this.calendarMonthDate;
    }

    if (this.calendarMonthEl) this.calendarMonthEl.textContent = this.formatCalendarMonthLabel(monthDate);
    if (this.calendarPrevEl) this.calendarPrevEl.disabled = monthDate <= currentMonth;

    var selectedLabel = selectedValue ? this.formatSelectedDateLabel(selectedValue) : '';

    if (this.targetDateSelectedEl) {
      this.targetDateSelectedEl.textContent = selectedLabel;
      this.targetDateSelectedEl.hidden = !selectedLabel;
    }

    if (this.targetDateChoiceSelectedEl) {
      this.targetDateChoiceSelectedEl.textContent = selectedLabel ? '· ' + selectedLabel : '';
      this.targetDateChoiceSelectedEl.hidden = !selectedLabel;
    }

    this.calendarGridEl.innerHTML = '';

    var firstDay = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
    var daysInMonth = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
    var leadingBlanks = (firstDay.getDay() + 6) % 7;
    var index;

    for (index = 0; index < leadingBlanks; index += 1) {
      var blank = document.createElement('span');
      blank.className = 'qb__date-day qb__date-day--blank';
      blank.setAttribute('aria-hidden', 'true');
      this.calendarGridEl.appendChild(blank);
    }

    for (var day = 1; day <= daysInMonth; day += 1) {
      var date = new Date(monthDate.getFullYear(), monthDate.getMonth(), day);
      var iso = this.formatDateISO(date);
      var button = document.createElement('button');
      var isPast = date < minimumDate;
      var isSelected = selectedValue === iso;

      button.type = 'button';
      button.className = 'qb__date-day' + (isSelected ? ' is-selected' : '');
      button.textContent = String(day);
      button.setAttribute('data-qb-calendar-day', iso);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      if (isPast) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
      this.calendarGridEl.appendChild(button);
    }

    this.renderTargetDateStrip();
  };

  QuoteBuilder.prototype.changeTargetCalendarMonth = function (direction) {
    var monthDate = this.ensureCalendarMonth();
    this.calendarMonthDate = new Date(monthDate.getFullYear(), monthDate.getMonth() + direction, 1);
    this.renderTargetDateCalendar();
  };

  QuoteBuilder.prototype.selectTargetDate = function (value) {
    if (!this.targetDateInput) return;
    this.targetDateInput.value = value;
    var selectedDate = this.parseISODate(value);
    if (selectedDate) this.dateStripStartDate = selectedDate;
    this.clearFieldError(this.targetDateField);
    this.renderTargetDateCalendar();
    this.syncProgressiveBrief();
    this.syncSummary();
    this.updateSubmitState();
    this.syncHiddenFields();
    this.saveState();
  };

  QuoteBuilder.prototype.resetProjectAnswer = function () {
    if (this.projectSelect) this.projectSelect.value = '';
    this.syncProjectCards();
    this.syncProjectOther();
  };

  QuoteBuilder.prototype.resetShippingAnswer = function () {
    this.shippingDecisionInputs.forEach(function (input) {
      input.checked = false;
    });
    this.shippingModeInputs.forEach(function (input) {
      input.checked = false;
    });
  };

  QuoteBuilder.prototype.clearTargetDateChoiceError = function () {
    if (this.targetDateChoiceGroup) this.targetDateChoiceGroup.classList.remove('is-error');
    this.targetDateChoiceInputs.forEach(function (input) {
      input.setAttribute('aria-invalid', 'false');
    });
    if (this.targetDateErrorEl) {
      this.targetDateErrorEl.textContent = '';
      this.targetDateErrorEl.classList.remove('is-visible');
    }
  };

  QuoteBuilder.prototype.syncProgressiveBrief = function () {
    var wantsDate = this.isExactTargetDateChoice(this.getTargetDateChoice());

    // Keep all brief questions on one step; only date and address details are conditional.
    if (this.briefTitleEl) this.briefTitleEl.textContent = this.getWizardStepLabel(2);
    this.progressiveBlocks.forEach(function (block) {
      block.hidden = false;
      block.classList.add('is-active');
    });
    if (this.targetDateField) this.targetDateField.hidden = !wantsDate;
    if (this.targetDateInput) {
      this.targetDateInput.disabled = !wantsDate;
      if (!wantsDate) this.targetDateInput.value = '';
    }
    this.toggleTargetCalendarPopover(wantsDate);
    this.renderTargetDateCalendar();

    if (this.projectSelect) {
      this.projectSelect.disabled = false;
      this.projectSelect.required = true;
    }
    this.projectCards.forEach(function (card) { card.disabled = false; });
    this.shippingDecisionInputs.forEach(function (input) { input.disabled = false; });
    this.syncProjectOther();
    this.syncShippingUI();
  };

  QuoteBuilder.prototype.syncContactPreference = function () {
    if (!this.phoneInputEl) return;
    var preference = this.contactPreferenceEl;
    var option = preference && preference.options ? preference.options[preference.selectedIndex] : null;
    var method = option ? option.getAttribute('data-qb-contact-method') : '';
    var value = String(preference && preference.value || '').toLowerCase();
    if (typeof value.normalize === 'function') value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    var requiresPhone = method === 'phone' || method === 'whatsapp' || /^(telephone|phone|telefon[eo]?|whatsapp)$/.test(value.trim());
    this.phoneInputEl.required = requiresPhone;
    this.phoneInputEl.setAttribute('aria-required', requiresPhone ? 'true' : 'false');
    if (this.phoneRequiredEl) this.phoneRequiredEl.hidden = !requiresPhone;
    if (this.phoneOptionalEl) this.phoneOptionalEl.hidden = requiresPhone;
    if (!requiresPhone) this.clearFieldError(this.phoneInputEl.closest('[data-qb-field-wrapper]'));
  };

  QuoteBuilder.prototype.validateTargetDateChoice = function () {
    if (!this.targetDateChoiceGroup) return true;
    var choice = this.getTargetDateChoice();
    var valid = Boolean(choice);
    var wantsDate = this.isExactTargetDateChoice(choice);
    this.targetDateChoiceGroup.classList.toggle('is-error', !valid);
    this.targetDateChoiceInputs.forEach(function (input) {
      input.setAttribute('aria-invalid', valid ? 'false' : 'true');
    });
    if (this.targetDateErrorEl) {
      this.targetDateErrorEl.textContent = valid ? '' : this.translate('targetDateError');
      this.targetDateErrorEl.classList.toggle('is-visible', !valid);
    }
    if (!valid) return false;

    if (wantsDate && this.targetDateInput && !String(this.targetDateInput.value || '').trim()) {
      this.setFieldError(this.targetDateField, this.translate('targetDatePickError'));
      return false;
    }

    this.clearFieldError(this.targetDateField);
    return valid;
  };

  QuoteBuilder.prototype.isDateStageComplete = function () {
    var choice = this.getTargetDateChoice();
    if (!choice) return false;
    if (!this.isExactTargetDateChoice(choice)) return true;
    return Boolean(this.targetDateInput && String(this.targetDateInput.value || '').trim());
  };

  QuoteBuilder.prototype.isShippingStageComplete = function () {
    var decision = this.form.querySelector('[data-qb-shipping-decision]:checked');
    if (!decision) return false;
    if (decision.getAttribute('data-qb-shipping-decision') === 'later') return true;
    var mode = this.form.querySelector('[data-qb-shipping-mode]:checked');
    if (!mode) return false;
    if (mode.getAttribute('data-qb-shipping-mode') === 'multiple') return true;
    return this.hasCompleteSingleShippingAddress();
  };

  QuoteBuilder.prototype.hasCompleteSingleShippingAddress = function () {
    if (!this.shippingSingleAddressInputs || !this.shippingSingleAddressInputs.length) return false;

    return Array.prototype.every.call(this.shippingSingleAddressInputs, function (input) {
      if (input.disabled || !input.required) return true;
      return Boolean(String(input.value || '').trim());
    });
  };

  QuoteBuilder.prototype.isStepActionReady = function () {
    if (this.submitLoading) return false;
    if (this.currentStep === 1) return Boolean(this.cart.items.length);
    if (this.currentStep === 2) {
      this.syncProgressiveBrief();
      return this.isDateStageComplete() && this.hasCompleteProjectChoice() && this.isShippingStageComplete();
    }
    if (this.currentStep >= this.totalWizardSteps) return Boolean(this.cart.items.length);
    return true;
  };

  QuoteBuilder.prototype.getItemRules = function (item) {
    var storedRules = this.lookupStoredRules(item);
    var min = 1;
    var increment = 1;
    var max = null;

    if (item && item.quantity_rule) {
      min = Math.max(Number(item.quantity_rule.min || 1) || 1, 1);
      increment = Math.max(Number(item.quantity_rule.increment || 1) || 1, 1);
      if (item.quantity_rule.max != null && item.quantity_rule.max !== '') max = Number(item.quantity_rule.max);
    }

    if (storedRules.min) min = Math.max(min, Number(storedRules.min) || 1);
    if (storedRules.increment) increment = Math.max(increment, Number(storedRules.increment) || 1);
    if ((max == null || isNaN(max)) && storedRules.max != null && storedRules.max !== '') max = Number(storedRules.max);
    if (item && item.properties && item.properties._moq) min = Math.max(min, Number(item.properties._moq) || 1);

    return {
      min: min,
      increment: increment,
      max: max != null && !isNaN(max) ? max : null
    };
  };

  QuoteBuilder.prototype.normalizeQuantity = function (rawQuantity, rules, mode) {
    var quantity = parseInt(rawQuantity, 10);
    if (isNaN(quantity)) quantity = rules.min;
    if (quantity <= 0) return 0;
    if (quantity < rules.min) quantity = rules.min;

    if (rules.increment > 1) {
      var delta = quantity - rules.min;
      if (delta < 0) {
        quantity = rules.min;
      } else {
        var steps = mode === 'decrease' ? Math.floor(delta / rules.increment) : Math.ceil(delta / rules.increment);
        quantity = rules.min + (steps * rules.increment);
      }
    }

    if (rules.max != null && quantity > rules.max) quantity = rules.max;
    if (quantity < rules.min) quantity = rules.min;
    return quantity;
  };

  QuoteBuilder.prototype.normalizeSizeOptions = function (sizes) {
    var fallback = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
    var source = Array.isArray(sizes) && sizes.length ? sizes : fallback;
    var seen = {};
    var normalized = source.map(function (size) {
      return String(size || '').trim();
    }).filter(function (size) {
      var key = size.toUpperCase();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
    return normalized.length ? normalized : fallback;
  };

  QuoteBuilder.prototype.normalizeSizeKey = function (value) {
    var normalized = String(value || '').trim().toUpperCase();
    if (normalized === '2XL') return 'XXL';
    if (normalized === '3XXL' || normalized === 'XXXL') return '3XL';
    return normalized;
  };

  QuoteBuilder.prototype.getItemProperties = function (item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  };

  QuoteBuilder.prototype.cloneItemProperties = function (item) {
    return Object.assign({}, this.getItemProperties(item));
  };

  QuoteBuilder.prototype.getItemByLineKey = function (lineKey) {
    return this.cart.items.find(function (item) {
      return String(item.key || '') === String(lineKey || '');
    }) || null;
  };

  QuoteBuilder.prototype.isTruthyProperty = function (value) {
    var normalized = String(value == null ? '' : value).trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'oui';
  };

  QuoteBuilder.prototype.isApparelItem = function (item) {
    if (!item) return false;
    var properties = this.getItemProperties(item);
    if (this.isTruthyProperty(properties._tm_apparel)) return true;

    var keys = [
      item.key,
      item.product_id ? 'product:' + item.product_id : '',
      item.variant_id ? 'variant:' + item.variant_id : '',
      item.id ? 'variant:' + item.id : ''
    ].filter(Boolean);

    return keys.some(function (key) {
      return Boolean(this.apparelItems && this.apparelItems[key]);
    }, this);
  };

  QuoteBuilder.prototype.parseSizeSummaryText = function (value) {
    var sizes = this.apparelSizes || [];
    var sizeLookup = sizes.reduce(function (map, size) {
      map[this.normalizeSizeKey(size)] = size;
      return map;
    }.bind(this), {});
    var breakdown = {};

    String(value || '').split(/\s*[·,;]\s*/).forEach(function (part) {
      var match = String(part || '').match(/^([^:]+):\s*([0-9]+)$/);
      if (!match) return;
      var size = sizeLookup[this.normalizeSizeKey(match[1])] || '';
      var quantity = parseInt(match[2], 10);
      if (size && quantity > 0) breakdown[size] = quantity;
    }, this);

    return breakdown;
  };

  QuoteBuilder.prototype.parseSizeBreakdown = function (item) {
    var properties = this.getItemProperties(item);
    var resolvedProperties = window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.resolve
      ? window.TodayMerchLineItemProperties.resolve(properties)
      : null;
    var sizes = this.apparelSizes || [];
    var sizeLookup = sizes.reduce(function (map, size) {
      map[this.normalizeSizeKey(size)] = size;
      return map;
    }.bind(this), {});
    var breakdown = {};
    var rawJson = String(properties._tm_size_breakdown || '').trim();

    if (rawJson) {
      try {
        var parsed = JSON.parse(rawJson);
        if (parsed && typeof parsed === 'object') {
          Object.keys(parsed).forEach(function (key) {
            var size = sizeLookup[this.normalizeSizeKey(key)] || '';
            var quantity = parseInt(parsed[key], 10);
            if (size && quantity > 0) breakdown[size] = quantity;
          }, this);
        }
      } catch (error) {}
    }

    if (!Object.keys(breakdown).length) {
      breakdown = this.parseSizeSummaryText(resolvedProperties
        ? resolvedProperties.sizes.summary
        : (properties._tm_size_summary || properties.Tailles || properties.Sizes));
    }

    return breakdown;
  };

  QuoteBuilder.prototype.hasSizeBreakdown = function (item) {
    var properties = this.getItemProperties(item);
    var resolvedProperties = window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.resolve
      ? window.TodayMerchLineItemProperties.resolve(properties)
      : null;
    return Boolean(String(properties._tm_size_breakdown || '').trim() || String(
      (resolvedProperties ? resolvedProperties.sizes.summary : (properties._tm_size_summary || properties.Tailles || properties.Sizes)) || ''
    ).trim());
  };

  QuoteBuilder.prototype.getSizeBreakdownTotal = function (breakdown) {
    return Object.keys(breakdown || {}).reduce(function (total, size) {
      return total + (parseInt(breakdown[size], 10) || 0);
    }, 0);
  };

  QuoteBuilder.prototype.buildSizeBreakdownSummary = function (breakdown) {
    var parts = (this.apparelSizes || []).map(function (size) {
      var quantity = parseInt(breakdown && breakdown[size], 10) || 0;
      return quantity > 0 ? size + ': ' + quantity : '';
    }).filter(Boolean);
    return parts.join(' · ');
  };

  QuoteBuilder.prototype.getSizeBreakdownState = function (item, overrideBreakdown) {
    var breakdown = overrideBreakdown || this.parseSizeBreakdown(item);
    var total = this.getSizeBreakdownTotal(breakdown);
    var target = Math.max(parseInt(item && item.quantity, 10) || 0, 0);
    var hasBreakdown = this.hasSizeBreakdown(item) || total > 0;
    var valid = !hasBreakdown || total === target;

    return {
      breakdown: breakdown,
      total: total,
      target: target,
      hasBreakdown: hasBreakdown,
      valid: valid,
      summary: this.buildSizeBreakdownSummary(breakdown)
    };
  };

  QuoteBuilder.prototype.getSizeAdjustmentText = function (state) {
    if (!state || state.valid) return '';
    return this.translate('sizeNeedsAdjustmentLabel') + ' (' + state.total + '/' + state.target + ')';
  };

  QuoteBuilder.prototype.isSizeEditorOpen = function (item, state) {
    if (!item) return false;
    var sizeState = state || this.getSizeBreakdownState(item);
    return this.openSizeEditorLineKey === item.key || (sizeState.hasBreakdown && !sizeState.valid);
  };

  QuoteBuilder.prototype.buildSizeBreakdownHtml = function (item) {
    if (!this.isApparelItem(item)) return '';

    var state = this.getSizeBreakdownState(item);
    var isOpen = this.isSizeEditorOpen(item, state);
    var lineKey = escapeHtml(item.key || '');
    var ctaLabel = this.translate(state.hasBreakdown ? 'sizeEditLabel' : 'sizeCtaLabel');
    var messageText = this.translate('sizeTotalLabel') + ' : ' + state.total + '/' + state.target;

    var fieldsHtml = (this.apparelSizes || []).map(function (size) {
      var inputId = 'QuoteSize-' + String(item.line || item.key || '').replace(/[^a-zA-Z0-9_-]/g, '-') + '-' + size;
      var value = parseInt(state.breakdown[size], 10) || '';
      return (
        '<label class="quote-cart-item__size-field" for="' + escapeHtml(inputId) + '">' +
          '<span>' + escapeHtml(size) + '</span>' +
          '<input id="' + escapeHtml(inputId) + '" type="number" min="0" step="1" inputmode="numeric" autocomplete="off" value="' + escapeHtml(value) + '" data-qb-size-input data-size="' + escapeHtml(size) + '">' +
        '</label>'
      );
    }).join('');

    if (!isOpen) {
      return (
        '<div class="quote-cart-item__sizes quote-cart-item__sizes--closed" data-qb-size-shell data-line-key="' + lineKey + '" data-target-quantity="' + escapeHtml(state.target) + '" tabindex="-1">' +
          '<button class="quote-cart-item__sizes-trigger" type="button" data-qb-size-toggle data-line-key="' + lineKey + '">' + escapeHtml(ctaLabel) + '</button>' +
        '</div>'
      );
    }

    return (
      '<div class="quote-cart-item__sizes' + (state.hasBreakdown && !state.valid ? ' is-error' : '') + '" data-qb-size-shell data-line-key="' + lineKey + '" data-target-quantity="' + escapeHtml(state.target) + '" tabindex="-1">' +
        '<div class="quote-cart-item__sizes-panel" data-qb-size-editor>' +
          '<div class="quote-cart-item__sizes-grid">' +
            fieldsHtml +
            '<button class="quote-cart-item__sizes-later" type="button" data-qb-size-cancel data-line-key="' + lineKey + '">' + escapeHtml(this.translate('sizeCancelLabel')) + '</button>' +
          '</div>' +
          '<div class="quote-cart-item__sizes-footer">' +
            '<p class="quote-cart-item__sizes-message" data-qb-size-message>' + escapeHtml(messageText) + '</p>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  };

  QuoteBuilder.prototype.buildQuantityControlHtml = function (item, options) {
    var rules = this.getItemRules(item);
    var itemMin = rules.min;
    var itemQuantity = Number(item && item.quantity || 0) || 0;
    var minusDisabled = itemQuantity <= itemMin ? ' disabled aria-disabled="true"' : '';
    var plusDisabled = rules.max != null && itemQuantity >= rules.max ? ' disabled aria-disabled="true"' : '';
    var lineKey = escapeHtml(item && item.key || '');
    var productTitle = item && (item.product_title || item.title) || this.translate('genericProductLabel');
    var singleSizeLabel = options && options.singleSize ? this.translate('singleSizeLabel') : '';

    return (
      '<div class="quote-cart-item__quantity' + (singleSizeLabel ? ' quote-cart-item__quantity--single-size' : '') + '">' +
        (singleSizeLabel ? '<span class="quote-cart-item__single-size-label">' + escapeHtml(singleSizeLabel) + '</span>' : '') +
        '<div class="quote-cart-quantity quantity" aria-label="' + escapeHtml(this.translate('quantityLabel')) + '">' +
          '<button class="quantity__button" type="button" name="minus" data-qb-qty="decrease" data-line-key="' + lineKey + '" aria-label="' + escapeHtml(this.translate('qtyDecreaseLabel', { product: productTitle })) + '"' + minusDisabled + '>−</button>' +
          '<input class="quantity__input" type="number" min="' + escapeHtml(itemMin) + '" step="' + escapeHtml(rules.increment) + '"' + (rules.max != null ? ' max="' + escapeHtml(rules.max) + '"' : '') + ' inputmode="numeric" autocomplete="off" size="2" value="' + escapeHtml(itemQuantity) + '" data-line-key="' + lineKey + '" data-min="' + escapeHtml(itemMin) + '" data-step="' + escapeHtml(rules.increment) + '"' + (rules.max != null ? ' data-max="' + escapeHtml(rules.max) + '"' : '') + ' data-qb-qty-input aria-label="' + escapeHtml(this.translate('quantityInputLabel', { product: productTitle })) + '">' +
          '<button class="quantity__button" type="button" name="plus" data-qb-qty="increase" data-line-key="' + lineKey + '" aria-label="' + escapeHtml(this.translate('qtyIncreaseLabel', { product: productTitle })) + '"' + plusDisabled + '>+</button>' +
        '</div>' +
      '</div>'
    );
  };

  QuoteBuilder.prototype.normalizeMarkingProfile = function (profile) {
    var value = String(profile || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    if (value === 'hoodie') return 'apparel_hoodie';
    if (value === 'none') return 'none';
    if (value === 'notebook' || value === 'bottle' || value === 'tote') return value;
    return value || 'apparel_tshirt';
  };

  QuoteBuilder.prototype.normalizeMarkingZoneKey = function (zoneKey) {
    var value = String(zoneKey || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase()
      .replace(/œ/g, 'oe')
      .replace(/&/g, 'and')
      .replace(/[\s-]+/g, '_')
      .replace(/__+/g, '_');

    if (!value) return '';
    if (value.indexOf('zone_') === 0 && (value.slice(5) === '360' || !/^\d+$/.test(value.slice(5)))) value = value.slice(5);

    var aliases = {
      coeur: 'heart',
      left_chest: 'heart',
      leftchest: 'heart',
      anti_coeur: 'chest',
      anticoeur: 'chest',
      antiheart: 'chest',
      anti_heart: 'chest',
      poitrine: 'chest',
      center_chest: 'chest',
      centre_chest: 'chest',
      chest_center: 'chest',
      chest_centre: 'chest',
      face: 'front',
      face_avant: 'front',
      devant: 'front',
      dos: 'back',
      rear: 'back',
      upperback: 'upper_back',
      haut_du_dos: 'upper_back',
      hautdos: 'upper_back',
      manche: 'sleeve',
      leftsleeve: 'left_sleeve',
      sleeveleft: 'left_sleeve',
      sleeve_left: 'left_sleeve',
      left_manche: 'left_sleeve',
      manche_gauche: 'left_sleeve',
      gauche_manche: 'left_sleeve',
      rightsleeve: 'right_sleeve',
      sleeveright: 'right_sleeve',
      sleeve_right: 'right_sleeve',
      right_manche: 'right_sleeve',
      manche_droite: 'right_sleeve',
      droite_manche: 'right_sleeve',
      leftshoulder: 'left_shoulder',
      shoulder_left: 'left_shoulder',
      left_epaule: 'left_shoulder',
      epaule_gauche: 'left_shoulder',
      gauche_epaule: 'left_shoulder',
      rightshoulder: 'right_shoulder',
      shoulder_right: 'right_shoulder',
      right_epaule: 'right_shoulder',
      epaule_droite: 'right_shoulder',
      droite_epaule: 'right_shoulder',
      capuche: 'hood',
      nuque: 'nape',
      col: 'neck',
      etiquette: 'label',
      frontcover: 'front_cover',
      recto: 'front_cover',
      backcover: 'back_cover',
      verso: 'back_cover',
      full_wrap: 'wrap',
      fullwrap: 'wrap',
      tour_complet: 'wrap',
      tourcomplet: 'wrap',
      '360': 'wrap',
      interieur: 'inside',
      interior: 'inside',
      sur_mesure: 'custom',
      surmesure: 'custom',
      special_request: 'custom',
      demande_speciale: 'custom',
      demande_special: 'custom',
      special: 'custom'
    };

    return aliases[value] || value;
  };

  QuoteBuilder.prototype.getMarkingZoneLabel = function (zoneKey) {
    var normalizedKey = this.normalizeMarkingZoneKey(zoneKey);
    var labels = this.i18n.zoneLabels && typeof this.i18n.zoneLabels === 'object' ? this.i18n.zoneLabels : {};

    if (!normalizedKey) return '';
    if (labels[normalizedKey]) return labels[normalizedKey];
    return String(zoneKey || '').trim();
  };

  QuoteBuilder.prototype.parseCommaSeparatedList = function (value) {
    return String(value || '')
      .split(',')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  };

  QuoteBuilder.prototype.dedupeList = function (values) {
    var seen = {};
    return (values || []).filter(function (value) {
      var key = String(value || '').trim();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };

  QuoteBuilder.prototype.absoluteAssetUrl = function (value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    if (raw.indexOf('blob:') === 0 || raw.indexOf('data:') === 0) return '';

    try {
      return new URL(raw, window.location.origin).href;
    } catch (error) {
      return raw;
    }
  };

  QuoteBuilder.prototype.valueLooksLikeAssetUrl = function (value) {
    var raw = String(value || '').trim();
    return Boolean(
      raw &&
      raw.indexOf('blob:') !== 0 &&
      raw.indexOf('data:') !== 0 &&
      (
        raw.indexOf('://') > -1 ||
        raw.charAt(0) === '/' ||
        raw.indexOf('/uploads/') > -1 ||
        raw.indexOf('/files/') > -1 ||
        raw.indexOf('/cdn/shop/files/') > -1
      )
    );
  };

  QuoteBuilder.prototype.getAssetFileName = function (value) {
    var raw = String(value || '').trim();
    if (!raw) return '';

    try {
      var url = new URL(raw, window.location.origin);
      return decodeURIComponent(url.pathname.split('/').filter(Boolean).pop() || '');
    } catch (error) {
      return decodeURIComponent(raw.split('?')[0].split('#')[0].split('/').filter(Boolean).pop() || raw);
    }
  };

  QuoteBuilder.prototype.normalizeAssetLabel = function (value, fallback) {
    var label = String(value || '').replace(/\s+/g, ' ').trim();
    return label || fallback || this.translate('uploadedFileLabel');
  };

  QuoteBuilder.prototype.addAssetEntry = function (list, entry) {
    if (!Array.isArray(list) || !entry) return;

    var href = this.valueLooksLikeAssetUrl(entry.href || entry.value) ? String(entry.href || entry.value).trim() : '';
    var value = String(entry.value || entry.href || entry.fileName || '').trim();
    var fileNameSource = entry.fileName || (href ? this.getAssetFileName(href) : entry.value || '');
    var fileName = String(fileNameSource || '') || this.translate('uploadedFileLabel');
    var label = this.normalizeAssetLabel(entry.label, href ? this.translate('fileLinkLabel') : this.translate('uploadedFileLabel'));
    var dedupeKey = [label.toLowerCase(), href || value || fileName].join('|');

    if (!href && !value && !fileName) return;
    if (list.some(function (item) { return item.dedupeKey === dedupeKey; })) return;

    list.push({
      label: label,
      href: href,
      value: value,
      fileName: fileName,
      zoneLabel: entry.zoneLabel || '',
      actionLabel: entry.actionLabel || '',
      dedupeKey: dedupeKey
    });
  };

  QuoteBuilder.prototype.propertyKeyLooksLikeMockup = function (key) {
    var normalized = this.normalizeLabelForMatch(key);
    return normalized.indexOf('mockup') > -1 ||
      normalized.indexOf('maquette') > -1 ||
      normalized.indexOf('rendu') > -1 ||
      normalized.indexOf('apercu') > -1 ||
      normalized.indexOf('preview') > -1;
  };

  QuoteBuilder.prototype.propertyKeyLooksLikeDesignSource = function (key) {
    var normalized = this.normalizeLabelForMatch(key);
    return /^Studio artwork\s+\d+$/i.test(key) ||
      key.indexOf('Logo - ') === 0 ||
      normalized.indexOf('design original') > -1 ||
      normalized.indexOf('source design') > -1 ||
      normalized.indexOf('fichier source') > -1 ||
      normalized.indexOf('artwork original') > -1;
  };

  QuoteBuilder.prototype.getAssetZoneLabelFromProperty = function (key) {
    var match = String(key || '').match(/^(?:Design original\s+\d+|Mockup|Logo)\s*-\s*(.+)$/i);
    return match ? String(match[1] || '').trim() : '';
  };

  QuoteBuilder.prototype.parseMockupStatus = function (value) {
    try {
      var parsed = JSON.parse(String(value || ''));
      if (!parsed || typeof parsed !== 'object') return { zones: [] };
      var zones = Array.isArray(parsed.zones) ? parsed.zones.slice(0, 24).map(function (zone) {
        return {
          key: String(zone && zone.key || '').trim(),
          label: String(zone && zone.label || '').trim(),
          status: String(zone && zone.status || '').trim(),
          reason: String(zone && zone.reason || '').trim(),
          fileName: String(zone && (zone.file_name || zone.fileName) || '').trim(),
          size: Number(zone && zone.size || 0)
        };
      }) : [];
      return { version: Number(parsed.version || 1), zones: zones };
    } catch (error) {
      return { zones: [] };
    }
  };

  QuoteBuilder.prototype.parseStudioTransform = function (value) {
    try {
      var parsed = JSON.parse(String(value || ''));
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  };

  QuoteBuilder.prototype.isSizeOptionName = function (name) {
    var normalized = String(name || '').trim().toLowerCase();
    return ['taille', 'tailles', 'size', 'sizes', 'talla', 'tallas', 'tamanho', 'tamanhos', 'größe', 'größen', 'grösse', 'grosse', 'taglia', 'taglie', 'tamaño', 'tamanos'].indexOf(normalized) !== -1;
  };

  QuoteBuilder.prototype.getItemVariantLabel = function (item) {
    var options = Array.isArray(item && item.options_with_values) ? item.options_with_values : [];
    if (options.length) {
      return options.filter(function (option) {
        return option && !this.isSizeOptionName(option.name);
      }, this).map(function (option) {
        var value = String(option.value || '').trim();
        return value && value !== 'Default Title' ? this.localizeOptionValue(value) : '';
      }, this).filter(Boolean).join(' / ');
    }

    // Legacy apparel lines must not turn a technical Shopify size into a requested size.
    if (this.isApparelItem(item)) return this.getSummaryProductColorLabel(item);
    var variantTitle = String(item && item.variant_title || '').trim();
    return variantTitle && variantTitle !== 'Default Title' ? this.localizeOptionValue(variantTitle) : '';
  };

  QuoteBuilder.prototype.getItemPresentation = function (item) {
    var self = this;
    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var resolvedProperties = window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.resolve
      ? window.TodayMerchLineItemProperties.resolve(properties)
      : null;
    var variantText = this.getItemVariantLabel(item);
    var personalizationText = String(properties.Personnalisation || properties.Personalization || '').trim();
    var fallbackZoneKeys = (resolvedProperties ? resolvedProperties.branding.zoneIds : this.parseCommaSeparatedList(properties._marking_zone_keys || ''))
      .map(function (zoneKey) { return self.normalizeMarkingZoneKey(zoneKey); })
      .filter(Boolean);
    var logoZoneKeys = (resolvedProperties ? resolvedProperties.branding.logoZoneIds : this.parseCommaSeparatedList(properties._marking_logo_zone_keys || ''))
      .map(function (zoneKey) { return self.normalizeMarkingZoneKey(zoneKey); })
      .filter(Boolean);

    fallbackZoneKeys = this.dedupeList(fallbackZoneKeys);
    logoZoneKeys = this.dedupeList(logoZoneKeys);

    if (fallbackZoneKeys.length) {
      personalizationText = fallbackZoneKeys.map(function (zoneKey) {
        return self.getMarkingZoneLabel(zoneKey);
      }).join(', ');
    }

    var logoSummary = String(properties.Logo || '').trim();
    var logoLinks = [];
    var designLinks = [];
    var mockupLinks = [];
    var mockupStatus = resolvedProperties ? resolvedProperties.branding.status : this.parseMockupStatus(properties._tm_mockup_status || '');
    var studioTransform = resolvedProperties ? resolvedProperties.studio.transform : this.parseStudioTransform(properties._studio_artwork_transform || '');
    var studioFile = resolvedProperties ? resolvedProperties.studio.fileNames.join(', ') : String(properties['Studio - Fichier'] || properties['Studio - File'] || properties._studio_artwork_file_name || '').trim();
    var studioViewKey = resolvedProperties ? resolvedProperties.studio.viewId : String(properties._studio_view || studioTransform.view || '').trim();
    var studioZoneKey = resolvedProperties ? resolvedProperties.studio.zoneId : String(properties._studio_zone_key || studioTransform.zone || '').trim();
    var studioView = String(properties['Studio - Vue'] || '').trim() || (studioTransform.view
      ? this.getMarkingZoneLabel(studioTransform.view)
      : this.getMarkingZoneLabel(studioViewKey));
    var studioZone = String(properties['Studio - Zone'] || '').trim() || (studioTransform.zone
      ? this.getMarkingZoneLabel(studioTransform.zone)
      : this.getMarkingZoneLabel(studioZoneKey));
    var studioPlacement = String(properties['Studio - Placement'] || '').trim();
    var studioUsedPartIds = Array.isArray(studioTransform.usedPartIds)
      ? studioTransform.usedPartIds.map(String).filter(Boolean)
      : [];
    if (!studioUsedPartIds.length && Array.isArray(studioTransform.artworks)) {
      studioUsedPartIds = studioTransform.artworks.reduce(function (partIds, artwork) {
        var artworkPartIds = Array.isArray(artwork && artwork.partIds)
          ? artwork.partIds
          : [artwork && artwork.partId].filter(Boolean);
        return partIds.concat(artworkPartIds.map(String));
      }, []);
    }
    studioUsedPartIds = this.dedupeList(studioUsedPartIds);
    var studioPhysicalLocationCount = Math.max(
      Number(studioTransform.physicalLocationCount || 0),
      studioUsedPartIds.length
    );
    var additionalLocationQuoteRequired = studioTransform.additionalLocationQuoteRequired === true ||
      studioPhysicalLocationCount > 1;
    var studioDetailParts = [];
    var hasStudioSignal = Boolean((resolvedProperties && resolvedProperties.studio.enabled) || properties['Studio Today Merch'] || properties['Today Merch Studio'] || properties['Studio TodayMerch'] || properties['TodayMerch Studio'] || studioFile || studioView || studioZone || studioPlacement || properties._studio_artwork_transform || properties._tm_studio_transform);
    var sizeState = this.getSizeBreakdownState(item);
    var sizeText = sizeState.summary || String(resolvedProperties ? resolvedProperties.sizes.summary : (properties._tm_size_summary || properties.Tailles || properties.Sizes || '')).trim();
    var sizeAdjustmentText = this.getSizeAdjustmentText(sizeState);

    var studioDisplayParts = [];

    if (studioView) {
      studioDetailParts.push(studioView);
      studioDisplayParts.push(studioView);
    }
    if (studioZone && studioZone !== studioView) {
      studioDetailParts.push(studioZone);
      studioDisplayParts.push(studioZone);
    }
    if (studioFile) studioDetailParts.push(studioFile);

    if (resolvedProperties) {
      resolvedProperties.branding.designs.forEach(function (asset, index) {
        var zoneLabel = asset.zoneId ? self.getMarkingZoneLabel(asset.zoneId) : (asset.legacyZoneLabel || '');
        self.addAssetEntry(designLinks, {
          label: index > 0 ? self.translate('originalDesignIndexed', { index: index + 1 }) : self.translate('originalDesignLabel'),
          href: self.valueLooksLikeAssetUrl(asset.value) ? asset.value : '',
          value: asset.value,
          fileName: asset.fileName,
          zoneLabel: zoneLabel
        });
      });
      resolvedProperties.branding.mockups.forEach(function (asset, index) {
        self.addAssetEntry(mockupLinks, {
          label: index > 0 ? self.translate('studioMockupIndexed', { index: index + 1 }) : self.translate('studioMockupLabel'),
          href: self.valueLooksLikeAssetUrl(asset.value) ? asset.value : '',
          value: asset.value,
          fileName: asset.fileName,
          zoneLabel: asset.zoneId ? self.getMarkingZoneLabel(asset.zoneId) : (asset.legacyZoneLabel || '')
        });
      });
    }

    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (!value) return;
      if (key === '_tm_mockup_status') return;
      if (resolvedProperties && (self.propertyKeyLooksLikeMockup(key) || self.propertyKeyLooksLikeDesignSource(key))) return;

      var href = String(value || '').trim();
      var zoneLabel = self.getAssetZoneLabelFromProperty(key);
      var isLink = self.valueLooksLikeAssetUrl(href);

      if (key.indexOf('Logo - ') === 0) {
        var localizedZoneLabel = self.getMarkingZoneLabel(zoneLabel) || zoneLabel;
        var logoEntry = {
          zoneLabel: localizedZoneLabel,
          href: isLink ? href : '',
          value: href,
          label: localizedZoneLabel ? self.translate('originalDesignLabel') + ' - ' + localizedZoneLabel : self.translate('originalDesignLabel'),
          actionLabel: isLink ? self.translate('viewAddedFileLabel') : href
        };

        logoLinks.push({
          zoneLabel: logoEntry.zoneLabel,
          href: logoEntry.href ? self.absoluteAssetUrl(logoEntry.href) : '',
          actionLabel: logoEntry.actionLabel
        });
        self.addAssetEntry(designLinks, logoEntry);
        return;
      }

      if (self.propertyKeyLooksLikeMockup(key)) {
        self.addAssetEntry(mockupLinks, {
          label: key,
          href: isLink ? href : '',
          value: href,
          fileName: self.getAssetFileName(href),
          zoneLabel: zoneLabel
        });
        return;
      }

      if (self.propertyKeyLooksLikeDesignSource(key)) {
        self.addAssetEntry(designLinks, {
          label: key.replace(/^Studio artwork/i, self.translate('originalDesignLabel')),
          href: isLink ? href : '',
          value: href,
          fileName: self.getAssetFileName(href),
          zoneLabel: zoneLabel
        });
      }
    });

    if (!logoLinks.length && logoZoneKeys.length) {
      logoLinks = logoZoneKeys.map(function (zoneKey) {
        return {
          zoneLabel: self.getMarkingZoneLabel(zoneKey),
          href: '',
          actionLabel: self.translate('viewAddedFileLabel')
        };
      });
    } else if (!logoLinks.length && logoSummary) {
      logoLinks = [{
        zoneLabel: logoSummary,
        href: '',
        actionLabel: ''
      }];
    }

    if (!designLinks.length && studioFile) {
      this.parseCommaSeparatedList(studioFile).forEach(function (fileName, index) {
        self.addAssetEntry(designLinks, {
          label: index > 0 ? self.translate('originalDesignIndexed', { index: index + 1 }) : self.translate('originalDesignLabel'),
          value: fileName,
          fileName: fileName
        });
      });
    }

    var mockupAlerts = mockupStatus.zones.filter(function (zone) {
      return zone.status && zone.status !== 'generated';
    }).map(function (zone) {
      var zoneLabel = zone.label || self.getMarkingZoneLabel(zone.key);
      if (resolvedProperties && zoneLabel === zone.key) {
        zoneLabel = zone.key.replace(/_/g, ' ').replace(/^./, function (letter) { return letter.toUpperCase(); });
      }
      return {
        zoneKey: zone.key,
        zoneLabel: zoneLabel,
        message: self.translate('mockupUnavailable') || 'Mockup indisponible'
      };
    });

    if (!mockupLinks.length && hasStudioSignal && !mockupAlerts.length) {
      mockupAlerts.push({ zoneKey: studioZoneKey, zoneLabel: studioZone || '', message: this.translate('mockupUnavailable') || 'Mockup indisponible' });
    }

    var placementSummary = '';
    if (studioTransform && (studioTransform.view || studioTransform.zone || studioTransform.artworks)) {
      var artworkCount = Array.isArray(studioTransform.artworks) ? studioTransform.artworks.length : 0;
      placementSummary = [
        studioTransform.view ? this.translate('studioViewLabel', { view: this.getMarkingZoneLabel(studioTransform.view) }) : '',
        studioTransform.zone ? this.translate('studioZoneLabel', { zone: this.getMarkingZoneLabel(studioTransform.zone) }) : '',
        artworkCount ? this.translateCount('studioDesignCountOne', 'studioDesignCountOther', artworkCount) : ''
      ].filter(Boolean).join(' · ');
    } else if (studioPlacement) {
      placementSummary = studioPlacement;
    }

    var extraDetails = [];
    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (!value || key.charAt(0) === '_') return;
      if (key === 'Personnalisation' || key === 'Personalization' || key === 'Logo' || key === 'Estimation marquage' || key === 'Branding estimate' || key === 'Tailles' || key === 'Sizes' || key.indexOf('Logo - ') === 0) return;
      if (key === 'Studio Today Merch' || key === 'Today Merch Studio' || key === 'Studio TodayMerch' || key === 'TodayMerch Studio' || key.indexOf('Studio - ') === 0) return;
      if (self.propertyKeyLooksLikeMockup(key) || self.propertyKeyLooksLikeDesignSource(key)) return;
      extraDetails.push({
        label: key,
        value: String(value || '').trim()
      });
    });

    return {
      variantText: variantText,
      personalizationText: personalizationText,
      logoLinks: logoLinks,
      designLinks: designLinks,
      mockupLinks: mockupLinks,
      mockupAlerts: mockupAlerts,
      mockupStatus: mockupStatus,
      extraDetails: extraDetails,
      sizeText: sizeText,
      sizeAdjustmentText: sizeAdjustmentText,
      hasSizeBreakdown: sizeState.hasBreakdown,
      sizeBreakdownValid: sizeState.valid,
      studioText: studioDetailParts.join(' · '),
      studioDisplayText: studioDisplayParts.join(' · '),
      placementSummary: placementSummary,
      studioUsedPartIds: studioUsedPartIds,
      studioPhysicalLocationCount: studioPhysicalLocationCount,
      additionalLocationQuoteRequired: additionalLocationQuoteRequired,
      fallbackZoneKeys: fallbackZoneKeys
    };
  };

  QuoteBuilder.prototype.buildItemMetaHtml = function (item) {
    var presentation = this.getItemPresentation(item);
    var blocks = [];

    if (presentation.variantText) {
      blocks.push(
        '<p class="quote-cart-item__variant-line">' +
          escapeHtml(presentation.variantText) +
        '</p>'
      );
    }

    if (!blocks.length) return '';
    return '<div class="quote-cart-item__meta">' + blocks.join('') + '</div>';
  };

  QuoteBuilder.prototype.getEmailLogoValue = function (entry) {
    if (!entry) return '';
    if (entry.href) return entry.href;

    var actionLabel = String(entry.actionLabel || '').trim();
    var defaultActionLabel = String(this.translate('viewAddedFileLabel')).trim();
    if (actionLabel && actionLabel !== defaultActionLabel) return actionLabel;

    return this.translate('fileSelectedLabel', { file: this.translate('uploadedFileLabel') });
  };

  QuoteBuilder.prototype.getEmailAssetValue = function (entry) {
    if (!entry) return '';
    return entry.href || entry.value || entry.fileName || entry.actionLabel || '';
  };

  QuoteBuilder.prototype.buildAssetLinksHtml = function (entries, groupLabel) {
    var self = this;
    var assets = Array.isArray(entries) ? entries.filter(function (entry) {
      return entry && (entry.href || entry.value || entry.fileName || entry.actionLabel);
    }) : [];
    if (!assets.length) return '';

    return (
      '<div class="quote-cart-item__logo-links" aria-label="' + escapeHtml(groupLabel) + '">' +
        assets.map(function (entry) {
          var linkText = entry.href ? (entry.fileName || entry.actionLabel || self.translate('openLabel')) : (entry.value || entry.fileName || entry.actionLabel || '');
          var zoneLabel = entry.zoneLabel || entry.label || groupLabel;
          if (entry.href) {
            return (
              '<a href="' + escapeHtml(entry.href) + '" class="quote-cart-item__logo-link" target="_blank" rel="noopener noreferrer">' +
                '<span class="quote-cart-item__logo-link-zone">' + escapeHtml(zoneLabel) + '</span>' +
                '<span class="quote-cart-item__logo-link-text">' + escapeHtml(linkText || self.translate('openLabel')) + '</span>' +
              '</a>'
            );
          }

          return (
            '<span class="quote-cart-item__logo-link quote-cart-item__logo-link--static">' +
              '<span class="quote-cart-item__logo-link-zone">' + escapeHtml(zoneLabel) + '</span>' +
              '<span class="quote-cart-item__logo-link-text">' + escapeHtml(linkText) + '</span>' +
            '</span>'
          );
        }).join('') +
      '</div>'
    );
  };

  QuoteBuilder.prototype.buildItemSummaryText = function (item) {
    var self = this;
    var pricing = this.getDisplayPricing(item);
    var title = item.product_title || item.title || this.translate('genericProductLabel');
    var presentation = this.getItemPresentation(item);
    var personalizationText = presentation.personalizationText || this.translate('personalizationPendingLabel');
    var lines = ['- ' + title + ' x ' + item.quantity + ' - ' + this.money(pricing.linePriceCents)];

    if (presentation.variantText) {
      lines.push('  - ' + this.translate('variantLabel') + ' : ' + presentation.variantText);
    }

    if (presentation.hasSizeBreakdown && (presentation.sizeText || presentation.sizeAdjustmentText)) {
      lines.push(
        '  - ' + this.translate('sizeLabel') + ' : ' +
        [presentation.sizeText, presentation.sizeAdjustmentText].filter(Boolean).join(' · ')
      );
    }

    if (personalizationText) {
      lines.push('  - ' + this.translate('personalizationLabel') + ' : ' + personalizationText);
    }

    if (presentation.studioText) {
      lines.push('  - ' + this.translate('studioDesignLabel') + ' : ' + presentation.studioText);
    }

    if (presentation.placementSummary && presentation.placementSummary !== presentation.studioText) {
      lines.push('  - ' + this.translate('studioPlacementLabel') + ' : ' + presentation.placementSummary);
    }

    if (presentation.mockupLinks.length) {
      presentation.mockupLinks.forEach(function (entry, index) {
        var label = entry.label || self.translate('studioMockupIndexed', { index: index + 1 });
        var value = self.getEmailAssetValue(entry);
        if (value) lines.push('  - ' + label + ' : ' + value);
      });
    }

    if (presentation.mockupAlerts.length) {
      presentation.mockupAlerts.forEach(function (alert) {
        lines.push('  - ' + (alert.zoneLabel ? alert.zoneLabel + ' : ' : '') + alert.message);
      });
    }

    if (presentation.designLinks.length) {
      presentation.designLinks.forEach(function (entry, index) {
        var label = entry.label || self.translate('originalDesignIndexed', { index: index + 1 });
        var value = self.getEmailAssetValue(entry);
        if (value) lines.push('  - ' + label + ' : ' + value);
      });
    }

    if (presentation.extraDetails.length) {
      presentation.extraDetails.forEach(function (detail) {
        if (!detail || !detail.value) return;
        lines.push('  - ' + detail.label + ' : ' + detail.value);
      });
    }

    return lines.join('\n');
  };

  QuoteBuilder.prototype.buildQuoteAssetSummaryText = function (assetKey) {
    var self = this;
    var blocks = this.cart.items.map(function (item) {
      var presentation = self.getItemPresentation(item);
      var entries = presentation && Array.isArray(presentation[assetKey]) ? presentation[assetKey] : [];
      var alerts = assetKey === 'mockupLinks' && Array.isArray(presentation.mockupAlerts)
        ? presentation.mockupAlerts
        : [];
      if (!entries.length && !alerts.length) return '';

      var title = item.product_title || item.title || self.translate('genericProductLabel');
      var lines = ['- ' + title];
      entries.forEach(function (entry, index) {
        var value = self.getEmailAssetValue(entry);
        if (!value) return;
        lines.push('  - ' + (entry.label || self.translate('fileIndexed', { index: index + 1 })) + ' : ' + value);
      });
      alerts.forEach(function (alert) {
        lines.push('  - ' + (alert.zoneLabel ? alert.zoneLabel + ' : ' : '') + alert.message);
      });

      return lines.length > 1 ? lines.join('\n') : '';
    }).filter(Boolean);

    return blocks.join('\n\n');
  };

  QuoteBuilder.prototype.collectQuoteAssets = function (assetKey) {
    var self = this;
    var assets = [];
    this.cart.items.forEach(function (item) {
      var presentation = self.getItemPresentation(item);
      var entries = presentation && Array.isArray(presentation[assetKey]) ? presentation[assetKey] : [];
      entries.forEach(function (entry) {
        if (!entry || !(entry.href || entry.value || entry.fileName || entry.actionLabel)) return;
        assets.push({
          item_title: item.product_title || item.title || '',
          label: entry.label || entry.zoneLabel || '',
          href: entry.href || '',
          value: entry.value || '',
          fileName: entry.fileName || '',
          actionLabel: entry.actionLabel || '',
          zoneLabel: entry.zoneLabel || ''
        });
      });
    });
    return assets;
  };

  QuoteBuilder.prototype.renderCart = function () {
    if (!this.cartItemsEl) return;

    if (!this.cart.items.length) {
      var emptyContinueLabel = this.translate('continueLabel');
      var returnIcon = this.config.returnIconHtml || '';
      this.cartItemsEl.innerHTML = [
        '<div class="qb__empty" data-qb-empty>',
        '<h3>' + escapeHtml(this.translate('emptyTitle')) + '</h3>',
        '<p>' + escapeHtml(this.translate('emptyText')) + '</p>',
        '<a class="qb__button qb__button--secondary" href="' + escapeHtml(this.config.continueUrl || '/') + '">' + returnIcon + '<span>' + escapeHtml(emptyContinueLabel) + '</span></a>',
        '</div>'
      ].join('');
      return;
    }

    var removeSymbol = this.config.removeIconHtml || '';
    var clockSymbol = this.config.clockIconHtml || '';
    var editLabel = this.translate('editLabel');
    var unitPriceLabel = this.translate('unitPriceLabel');
    var lineSubtotalLabel = this.translate('lineSubtotalLabel');

    var html = this.cart.items.map(function (item) {
      var pricing = this.getDisplayPricing(item);
      var regularUnitPriceCents = this.getRegularUnitPriceCents(item, pricing);
      var regularUnitPriceHtml = regularUnitPriceCents
        ? '<del class="quote-cart-item__regular-price">' + escapeHtml(this.money(regularUnitPriceCents)) + '</del>'
        : '';
      var displayedLinePriceCents = Number.isFinite(pricing.itemsTotalPriceCents) ? pricing.itemsTotalPriceCents : pricing.linePriceCents;
      var regularLinePriceCents = regularUnitPriceCents * Number(item.quantity || 0);
      var regularSubtotalHtml = regularLinePriceCents > Number(displayedLinePriceCents || 0)
        ? '<del class="quote-cart-item__regular-subtotal">' + escapeHtml(this.money(regularLinePriceCents)) + '</del>'
        : '';
      var title = item.product_title || item.title || this.translate('genericProductLabel');
      var variantHtml = '';
      var metaHtml = this.buildItemMetaHtml(item);
      var mediaHtml = this.buildItemMediaHtml(item, title);
      var editUrl = this.buildEditUrl(item);
      var productionDays = this.getItemProductionDays(item);
      var leadTimeNote = productionDays ? this.getLeadTimeNote(productionDays) : '';
      var noteHtml = leadTimeNote
        ? '<p class="quote-cart-item__note"><span class="quote-cart-item__note-icon" aria-hidden="true">' + clockSymbol + '</span><span>' + escapeHtml(leadTimeNote) + '</span></p>'
        : '';
      var isApparel = this.isApparelItem(item);
      var sizeState = isApparel ? this.getSizeBreakdownState(item) : null;
      var isSizeEditorOpen = isApparel && this.isSizeEditorOpen(item, sizeState);
      var quantityOrSizesHtml = isApparel
        ? (isSizeEditorOpen ? this.buildSizeBreakdownHtml(item) : (this.buildQuantityControlHtml(item) + this.buildSizeBreakdownHtml(item)))
        : this.buildQuantityControlHtml(item, { singleSize: true });
      var quantityLabelHtml = isSizeEditorOpen
        ? ''
        : '<span class="quote-cart-item__quantity-label">' + escapeHtml(this.translate('quantityLabel')) + '</span>';
      return [
        '<article class="cart-item quote-cart-item' + (this.loadingLineKey === item.key ? ' is-loading' : '') + '" data-line-key="' + escapeHtml(item.key) + '">',
        '<div class="quote-cart-item__grid">',
        '<div class="quote-cart-item__media-col">',
        mediaHtml,
        '</div>',
        '<div class="quote-cart-item__content-col">',
        '<div class="quote-cart-item__header">',
        '<div class="quote-cart-item__copy">',
        '<a href="' + escapeHtml(item.url || '#') + '" class="quote-cart-item__title">' + escapeHtml(title) + '</a>',
        metaHtml,
        '</div>',
        '<div class="quote-cart-item__actions">',
        '<button class="quote-cart-item__action quote-cart-item__action--remove" type="button" data-qb-remove="' + escapeHtml(item.key) + '" aria-label="' + escapeHtml(this.translate('removeItemLabel', { title: title })) + '">' + removeSymbol + '<span class="visually-hidden">' + escapeHtml(this.translate('removeItemLabel', { title: title })) + '</span></button>',
        '</div>',
        '</div>',
        '<div class="quote-cart-item__body">',
        '<div class="quote-cart-item__pricing" aria-label="' + escapeHtml(this.translate('linePriceLabel')) + '">',
        '<div class="quote-cart-item__price-metric quote-cart-item__price-metric--unit-price">',
        '<span class="quote-cart-item__price-label">' + escapeHtml(unitPriceLabel) + '</span>',
        '<span class="quote-cart-item__price-values">',
        '<strong class="quote-cart-item__price-value">' + escapeHtml(this.money(pricing.unitPriceCents)) + '</strong>',
        regularUnitPriceHtml,
        '</span>',
        '</div>',
        '</div>',
        '<div class="quote-cart-item__commerce">',
        quantityLabelHtml,
        variantHtml,
        quantityOrSizesHtml,
        '<a class="quote-cart-item__edit-link" href="' + escapeHtml(editUrl) + '" aria-label="' + escapeHtml(this.translate('editItemLabel', { title: title })) + '">' + escapeHtml(editLabel) + '</a>',
        '</div>',
        '</div>',
        '<div class="quote-cart-item__subtotal">',
        '<span class="quote-cart-item__subtotal-label">' + escapeHtml(lineSubtotalLabel) + '</span>',
        '<span class="quote-cart-item__subtotal-values">',
        '<strong class="quote-cart-item__subtotal-value">' + escapeHtml(this.money(displayedLinePriceCents)) + '</strong>',
        regularSubtotalHtml,
        '</span>',
        noteHtml,
        '</div>',
        '</div>',
        '</div>',
        '</article>'
      ].join('');
    }, this).join('');

    this.cartItemsEl.innerHTML = html;
    this.syncProductViewSwitchers(this.cartItemsEl, { animate: false });
    this.syncProductMediaStages(this.cartItemsEl);
  };

  QuoteBuilder.prototype.getSummaryProductBaseTitle = function (item) {
    var variantTitle = String(item && item.variant_title || '').trim();
    var productTitle = item && item.product_title ? String(item.product_title).trim() : '';

    if (!productTitle) {
      productTitle = item && item.title ? String(item.title).trim() : '';
      if (variantTitle && variantTitle !== 'Default Title') {
        [' - ' + variantTitle, ' / ' + variantTitle].some(function (suffix) {
          if (productTitle.slice(-suffix.length) === suffix) {
            productTitle = productTitle.slice(0, -suffix.length).trim();
            return true;
          }
          return false;
        });
      }
    }

    return productTitle || this.translate('genericProductLabel');
  };

  QuoteBuilder.prototype.getSummaryProductColorLabel = function (item) {
    var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    var colorPropertyKeys = ['Couleur', 'Coloris', 'Color', 'Colour', 'Teinte'];
    var propertyMatch = colorPropertyKeys.map(function (key) {
      return String(properties[key] || '').trim();
    }).filter(Boolean)[0];

    if (propertyMatch) return this.localizeOptionValue(propertyMatch);

    var options = Array.isArray(item && item.options_with_values) ? item.options_with_values : [];
    var optionMatch = options.map(function (option) {
      var optionName = this.normalizeLabelForMatch(option && option.name);
      var optionValue = String(option && option.value || '').trim();
      if (!optionValue || optionValue === 'Default Title') return '';
      if (optionName.indexOf('couleur') > -1 || optionName.indexOf('color') > -1 || optionName.indexOf('colour') > -1 || optionName.indexOf('coloris') > -1 || optionName.indexOf('teinte') > -1) {
        return optionValue;
      }
      return '';
    }, this).filter(Boolean)[0];

    if (optionMatch) return this.localizeOptionValue(optionMatch);
    if (options.length || this.isApparelItem(item)) return '';

    var variantTitle = String(item && item.variant_title || '').trim();
    var variantOptions = Array.isArray(item && item.variant_options) ? item.variant_options : [];

    if (variantOptions.length === 1 && variantOptions[0] && variantOptions[0] !== 'Default Title') {
      return this.localizeOptionValue(variantOptions[0]);
    }

    if (variantTitle && variantTitle !== 'Default Title' && variantTitle.indexOf('/') === -1 && variantTitle.indexOf(',') === -1) {
      return this.localizeOptionValue(variantTitle);
    }

    return '';
  };

  QuoteBuilder.prototype.getSummaryProductTitle = function (item) {
    var productTitle = this.getSummaryProductBaseTitle(item);
    var colorLabel = this.getSummaryProductColorLabel(item);
    return productTitle + (colorLabel ? ' (' + colorLabel + ')' : '');
  };

  QuoteBuilder.prototype.getSummaryProductImage = function (item) {
    var mediaState = this.getItemMediaState(item);
    var activeView = mediaState.activeView;
    var image = activeView && activeView.image ? activeView.image : item && item.image;

    if (image && typeof image === 'object') {
      image = image.src || image.url || image.preview_image && image.preview_image.src || '';
    }

    return String(image || '').trim();
  };

  QuoteBuilder.prototype.buildSummaryProductMediaHtml = function (item, title) {
    var mediaState = this.getItemMediaState(item);
    var activeView = mediaState.activeView;
    var image = activeView && activeView.image ? activeView.image : item && item.image;
    var imageAlt = activeView && activeView.alt
      ? activeView.alt
      : String(item && (item.product_title || item.title) || title || '').trim();
    if (image && typeof image === 'object') {
      image = image.src || image.url || image.preview_image && image.preview_image.src || '';
    }
    image = this.normalizeStudioPreviewUrl(image);

    if (!image) {
      return '<span class="qb__summary-product-placeholder" aria-hidden="true">' + escapeHtml(String(title || '').charAt(0) || 'P') + '</span>';
    }

    return (
      '<span class="qb__summary-product-media-stage" data-qb-media-stage>' +
        '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy" data-qb-summary-product-image>' +
        this.buildItemArtworkHtml(item, mediaState, { summary: true, activeOnly: true }) +
      '</span>'
    );
  };

  QuoteBuilder.prototype.formatSummaryZoneLabel = function (zoneLabel) {
    var normalizedKey = this.normalizeMarkingZoneKey(zoneLabel);
    var labels = this.i18n.zoneLabels && typeof this.i18n.zoneLabels === 'object' ? this.i18n.zoneLabels : {};

    if (labels[normalizedKey]) return labels[normalizedKey];
    return String(this.getMarkingZoneLabel(zoneLabel) || '').trim();
  };

  QuoteBuilder.prototype.formatSummaryZoneList = function (zones) {
    var values = this.dedupeList((zones || []).map(function (zone) {
      return String(zone || '').trim();
    }).filter(Boolean));

    if (!values.length) return '';
    try {
      return new Intl.ListFormat(this.config.locale, { style: 'long', type: 'conjunction' }).format(values);
    } catch (error) {
      return values.join(', ');
    }
  };

  QuoteBuilder.prototype.getSummaryProductPersonalizationText = function (item) {
    var presentation = this.getItemPresentation(item);
    var zoneLabels = [];

    if (presentation.fallbackZoneKeys && presentation.fallbackZoneKeys.length) {
      zoneLabels = presentation.fallbackZoneKeys.map(function (zoneKey) {
        return this.formatSummaryZoneLabel(zoneKey);
      }, this);
    } else if (presentation.personalizationText) {
      zoneLabels = String(presentation.personalizationText)
        .split(/\s*,\s*|\s+et\s+|\s*\/\s*|\s*\+\s*/)
        .map(function (zoneLabel) {
          return this.formatSummaryZoneLabel(zoneLabel);
        }, this);
    }

    return this.formatSummaryZoneList(zoneLabels) || this.translate('notDefined');
  };

  QuoteBuilder.prototype.formatSummaryProductMetaText = function (value) {
    var text = String(value || '').trim();
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  QuoteBuilder.prototype.buildSummaryProductsHtml = function () {
    if (!this.cart.items.length) {
      return '<p class="qb__summary-products-empty">' + escapeHtml(this.translate('emptyTitle')) + '</p>';
    }

    return this.cart.items.map(function (item) {
      var pricing = this.getDisplayPricing(item);
      var title = this.getSummaryProductTitle(item);
      var quantity = Number(item.quantity || 0);
      var unitPrice = this.money(pricing.unitPriceCents);
      var lineSubtotal = this.money(Number.isFinite(pricing.itemsTotalPriceCents) ? pricing.itemsTotalPriceCents : pricing.linePriceCents);
      var mediaHtml = this.buildSummaryProductMediaHtml(item, title);

      return [
        '<article class="qb__summary-product">',
        '<span class="qb__summary-product-media" data-line-key="' + escapeHtml(item.key || '') + '">' + mediaHtml + '</span>',
        '<span class="qb__summary-product-copy">',
        '<strong class="qb__summary-product-title"><span class="qb__summary-product-name">' + escapeHtml(title) + '</span></strong>',
        '<dl class="qb__summary-product-metrics">',
        '<div class="qb__summary-product-metric qb__summary-product-metric--quantity">',
        '<dt class="qb__summary-product-metric-label">' + escapeHtml(this.translate('quantityLabel')) + '</dt>',
        '<dd class="qb__summary-product-metric-value">' + escapeHtml(quantity) + '</dd>',
        '</div>',
        '<div class="qb__summary-product-metric qb__summary-product-metric--unit-price">',
        '<dt class="qb__summary-product-metric-label">' + escapeHtml(this.translate('unitPriceLabel')) + '</dt>',
        '<dd class="qb__summary-product-metric-value">' + escapeHtml(unitPrice) + '</dd>',
        '</div>',
        '<div class="qb__summary-product-metric qb__summary-product-metric--subtotal">',
        '<dt class="qb__summary-product-metric-label">' + escapeHtml(this.translate('lineSubtotalLabel')) + '</dt>',
        '<dd class="qb__summary-product-metric-value">' + escapeHtml(lineSubtotal) + '</dd>',
        '</div>',
        '</dl>',
        '</span>',
        '</article>'
      ].join('');
    }, this).join('');
  };

  QuoteBuilder.prototype.getTargetDateSummaryLabel = function () {
    var choice = this.getTargetDateChoice();
    if (!choice) return '-';

    if (!this.isExactTargetDateChoice(choice)) return String(choice.value || '').trim() || this.translate('notDefined');

    var value = this.targetDateInput ? String(this.targetDateInput.value || '').trim() : '';
    return value ? this.formatSelectedDateLabel(value) : '-';
  };

  QuoteBuilder.prototype.getShippingSummaryLabel = function () {
    var decision = this.form.querySelector('[data-qb-shipping-decision]:checked');
    var mode = this.form.querySelector('[data-qb-shipping-mode]:checked');
    if (!decision) return this.translate('notDefined');
    if (decision.getAttribute('data-qb-shipping-decision') === 'later') return this.translate('notDefined');
    if (!mode) return this.translate('notDefined');
    return this.translate(mode.getAttribute('data-qb-shipping-mode') === 'multiple' ? 'shippingMultiLabel' : 'shippingSingleLabel');
  };

  QuoteBuilder.prototype.syncSummary = function () {
    var units = Number(this.cart.item_count || 0);
    var references = Number(this.cart.items.length || 0);
    var subtotal = this.cart.items_subtotal_price;
    var articlesSubtotal = Number.isFinite(this.cart.items_articles_subtotal_price) ? this.cart.items_articles_subtotal_price : subtotal;
    var unitsLabel = units + ' ' + this.unitLabel(units);
    var money = this.money(subtotal);
    var articlesMoney = this.money(articlesSubtotal);
    var shipping = this.getShippingState().label;
    var summaryShipping = this.getShippingSummaryLabel();
    var targetDate = this.getTargetDateSummaryLabel();

    this.summaryReferenceUnitsEls.forEach(function (el) { el.textContent = unitsLabel; });
    this.summaryProductsEls.forEach(function (el) {
      el.innerHTML = this.buildSummaryProductsHtml();
      this.syncProductMediaStages(el);
    }, this);
    this.summaryTargetDateEls.forEach(function (el) { el.textContent = targetDate; });
    this.summarySubtotalEls.forEach(function (el) { el.textContent = articlesMoney; });
    this.summaryTotalEls.forEach(function (el) { el.textContent = money; });
    this.summaryShippingEls.forEach(function (el) { el.textContent = summaryShipping; });
    this.headerCountEls.forEach(function (el) {
      el.textContent = units;
      var countLink = el.closest('[aria-label]');
      if (countLink) countLink.setAttribute('aria-label', this.translateCount('selectionCountOne', 'selectionCountOther', units));
    }, this);

    if (this.hiddenReferencesEl) this.hiddenReferencesEl.value = references + ' ' + this.referencesLabel(references);
    if (this.hiddenUnitsEl) this.hiddenUnitsEl.value = units + ' ' + this.unitLabel(units);
    if (this.hiddenSubtotalEl) this.hiddenSubtotalEl.value = articlesMoney;
    if (this.hiddenShippingEl) this.hiddenShippingEl.value = shipping;
  };

  QuoteBuilder.prototype.syncHiddenFields = function () {
    var itemSummaries = this.cart.items.map(function (item) {
      return this.buildItemSummaryText(item);
    }, this).filter(Boolean);
    var itemsSummaryText = itemSummaries.join('\n\n');
    var mockupsSummaryText = this.buildQuoteAssetSummaryText('mockupLinks');
    var designsSummaryText = this.buildQuoteAssetSummaryText('designLinks');

    if (this.hiddenItemsEl) this.hiddenItemsEl.value = itemsSummaryText;
    if (this.hiddenMockupsEl) this.hiddenMockupsEl.value = mockupsSummaryText;
    if (this.hiddenDesignsEl) this.hiddenDesignsEl.value = designsSummaryText;
    if (this.hiddenUploadcareEl) this.hiddenUploadcareEl.value = this.uploadcareUrls.join('\n');
    if (this.hiddenClientProjectEl) this.hiddenClientProjectEl.value = this.clientProjectReference || '';

    var shipping = this.getShippingState();
    var project = this.form.querySelector('[name="contact[Type de projet]"]');
    var targetDate = this.form.querySelector('[name="contact[Date cible]"]');
    var assetsLink = this.form.querySelector('[name="contact[Lien vers assets]"]');
    var notes = this.form.querySelector('[name="contact[Notes projet]"]');
    var company = this.form.querySelector('[name="contact[Entreprise]"]');
    var firstName = this.form.querySelector('[name="contact[Prénom]"]');
    var lastName = this.form.querySelector('[name="contact[Nom]"]');
    var email = this.form.querySelector('[name="contact[email]"]');
    var phone = this.form.querySelector('[name="contact[Téléphone]"]');
    var preference = this.form.querySelector('[name="contact[Préférence de contact]"]');

    if (this.hiddenNameEl) this.hiddenNameEl.value = [firstName && firstName.value ? firstName.value.trim() : '', lastName && lastName.value ? lastName.value.trim() : ''].filter(Boolean).join(' ');
    if (this.hiddenPhoneEl) this.hiddenPhoneEl.value = phone && phone.value ? phone.value.trim() : '';
    if (this.hiddenRequestIdEl) this.hiddenRequestIdEl.value = this.getQuoteRequestId();

    if (this.hiddenBodyEl) {
      this.hiddenBodyEl.value = [
        this.translate('bodyTitle'),
        this.translate('bodyReferenceLabel') + ' ' + this.getQuoteRequestId(),
        '',
        this.translate('bodyProductsHeading'),
        itemsSummaryText || this.translate('bodyNoProducts'),
        '',
        this.translate('bodyMockupsHeading'),
        mockupsSummaryText || this.translate('bodyNoMockups'),
        '',
        this.translate('bodyDesignsHeading'),
        designsSummaryText || this.translate('bodyNoDesigns'),
        '',
        this.translate('bodySubtotalLabel') + ' ' + this.money(Number.isFinite(this.cart.items_articles_subtotal_price) ? this.cart.items_articles_subtotal_price : this.cart.items_subtotal_price),
        'Frais techniques : ' + this.money(Number.isFinite(this.cart.technical_fees_price) ? this.cart.technical_fees_price : 0),
        'Frais de préparation : ' + this.money(Number.isFinite(this.cart.preparation_fees_price) ? this.cart.preparation_fees_price : 0),
        'Total estimé : ' + this.money(this.cart.items_subtotal_price),
        this.translate('bodyShippingLabel') + ' ' + (shipping.label || ''),
        this.translate('designMockupLabel') + ' : ' + this.translate('freeLabel'),
        '',
        this.translate('bodyProjectHeading'),
        '- ' + this.translate('bodyProjectTypeLabel') + ' ' + (project && project.value ? project.value : this.translate('notProvided')),
        '- ' + this.translate('bodyTargetDateLabel') + ' ' + (targetDate && targetDate.value ? targetDate.value : this.translate('notProvidedFeminine')),
        '- ' + this.translate('bodyAssetsLinkLabel') + ' ' + (assetsLink && assetsLink.value ? assetsLink.value : this.translate('notProvided')),
        '- ' + this.translate('bodyUploadedFilesLabel') + ' ' + (this.uploadcareUrls.length ? this.uploadcareUrls.join(', ') : this.translate('noneLabel')),
        '- ' + this.translate('bodyNotesLabel') + ' ' + (notes && notes.value ? notes.value : this.translate('noneLabel')),
        '',
        this.translate('bodyContactHeading'),
        '- ' + this.translate('firstNameLabel') + ' : ' + (firstName && firstName.value ? firstName.value : this.translate('notProvided')),
        '- ' + this.translate('lastNameLabel') + ' : ' + (lastName && lastName.value ? lastName.value : this.translate('notProvided')),
        '- ' + this.translate('emailLabel') + ' : ' + (email && email.value ? email.value : this.translate('notProvided')),
        '- ' + this.translate('phoneLabel') + ' : ' + (phone && phone.value ? phone.value : this.translate('notProvided')),
        '- ' + this.translate('companyLabel') + ' : ' + (company && company.value ? company.value : this.translate('notProvidedFeminine')),
        '- ' + this.translate('contactPreferenceLabel') + ' : ' + (preference && preference.value ? preference.value : this.translate('noneLabel')),
        '',
        this.translate('bodyPageLabel') + ' ' + (this.config.pageUrl || '')
      ].join('\n');
    }
  };

  QuoteBuilder.prototype.getFieldValue = function (name) {
    var field = this.form ? this.form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]') : null;
    return field && field.value ? String(field.value).trim() : '';
  };

  QuoteBuilder.prototype.getRawFieldValue = function (name) {
    var elements = this.form && this.form.elements;
    var field = elements && typeof elements.namedItem === 'function' ? elements.namedItem(name) : null;
    if (!field && this.form && typeof this.form.querySelector === 'function') {
      field = this.form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');
    }
    if (field && typeof field.value === 'string') return field.value;
    return typeof this.getFieldValue === 'function' ? this.getFieldValue(name) : '';
  };

  QuoteBuilder.prototype.getQuoteRequestId = function () {
    if (!this.quoteRequestId) this.quoteRequestId = createQuoteRequestId();
    return this.quoteRequestId;
  };

  QuoteBuilder.prototype.getQuoteSubmittedAt = function () {
    if (!this.quoteSubmittedAt) this.quoteSubmittedAt = new Date().toISOString();
    return this.quoteSubmittedAt;
  };

  QuoteBuilder.prototype.serializeQuoteAsset = function (entry) {
    var rawHref = String(entry && (entry.href || entry.value) || '').trim();
    var href = '';
    if (rawHref) {
      try {
        var url = new URL(rawHref, window.location.origin);
        if (url.protocol === 'https:' && !url.username && !url.password) href = url.href;
      } catch (error) {
        href = '';
      }
    }

    return {
      label: entry && (entry.label || entry.zoneLabel) || '',
      zone: entry && entry.zoneLabel || '',
      href: href,
      file_name: entry && entry.fileName || ''
    };
  };

  QuoteBuilder.prototype.serializeQuoteProductImage = function (item) {
    var image = item && item.image;
    if (image && typeof image === 'object') {
      image = image.src || image.url || image.preview_image && image.preview_image.src || '';
    }
    var raw = String(image || '').trim();
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.origin);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      return url.href;
    } catch (error) {
      return '';
    }
  };

  QuoteBuilder.prototype.getQuotePricing = function () {
    var currency = window.TodayMerchMoney ? window.TodayMerchMoney.activeCurrency() : (this.config && this.config.currency) || 'EUR';
    var items = this.cart.items.map(function (item) { return this.getDisplayPricing(item); }, this);
    var valid = items.every(function (pricing) {
      return pricing.valid !== false && Number.isFinite(pricing.unitPriceCents) && Number.isFinite(pricing.linePriceCents) && (!pricing.currency || pricing.currency === currency);
    });
    var reason = !valid && items.some(function (pricing) { return pricing.pricingMode === 'quote_required'; }) ? 'supplier_quote_unavailable' : null;
    return { currency: currency, valid: valid, reason: reason, items: items,
      total: valid ? items.reduce(function (sum, pricing) { return sum + pricing.linePriceCents; }, 0) : null,
      itemsTotal: valid ? items.reduce(function (sum, pricing) { return sum + (Number.isFinite(pricing.itemsTotalPriceCents) ? pricing.itemsTotalPriceCents : pricing.linePriceCents); }, 0) : null,
      technicalFees: valid ? items.reduce(function (sum, pricing) { return sum + (Number.isFinite(pricing.technicalFeesCents) ? pricing.technicalFeesCents : 0); }, 0) : null,
      preparationFees: valid ? items.reduce(function (sum, pricing) { return sum + (Number.isFinite(pricing.preparationFeesCents) ? pricing.preparationFeesCents : 0); }, 0) : null };
  };

  QuoteBuilder.prototype.buildClientProjectPayload = function () {
    var quotePricing = this.getQuotePricing();
    if (!quotePricing.valid) throw new Error(quotePricing.reason === 'supplier_quote_unavailable' ? 'QUOTE_SUPPLIER_PRICE_UNAVAILABLE' : 'QUOTE_CURRENCY_UNAVAILABLE');
    var project = this.getRawFieldValue('contact[Type de projet]');
    var requestId = this.getQuoteRequestId();
    var submittedAt = this.getQuoteSubmittedAt();
    var self = this;

    var payload = {
      request_id: requestId,
      submitted_at: submittedAt,
      quote: {
        reference: requestId,
        submitted_at: submittedAt,
        title: project || this.translate('bodyTitle'),
        project_type: project,
        target_date: this.getFieldValue('contact[Date cible]'),
        notes: this.getRawFieldValue('contact[Notes projet]'),
        shipping: this.getShippingState().label || '',
        page_url: this.config.pageUrl || window.location.href,
        total: {
          amount: quotePricing.total / 100,
          currency: quotePricing.currency,
          items_amount: quotePricing.itemsTotal == null ? null : quotePricing.itemsTotal / 100,
          technical_fees_amount: quotePricing.technicalFees == null ? null : quotePricing.technicalFees / 100,
          preparation_fees_amount: quotePricing.preparationFees == null ? null : quotePricing.preparationFees / 100
        },
        contact: {
          first_name: this.getRawFieldValue('contact[Prénom]'),
          last_name: this.getRawFieldValue('contact[Nom]'),
          email: this.getFieldValue('contact[email]'),
          phone: this.getRawFieldValue('contact[Téléphone]'),
          company: this.getRawFieldValue('contact[Entreprise]'),
          preference: this.getFieldValue('contact[Préférence de contact]')
        },
        uploaded_files: this.uploadcareUrls.slice(),
        assets_link: this.getFieldValue('contact[Lien vers assets]'),
        mockups: this.collectQuoteAssets('mockupLinks').map(function (entry) {
          return self.serializeQuoteAsset(entry);
        }),
        designs: this.collectQuoteAssets('designLinks').map(function (entry) {
          return self.serializeQuoteAsset(entry);
        }),
        items: this.cart.items.map(function (item, itemIndex) {
          var pricing = quotePricing.items[itemIndex];
          var presentation = this.getItemPresentation(item);
          return {
            key: item.key || '',
            product_id: item.product_id || '',
            variant_id: item.variant_id || item.id || '',
            sku: item.sku || '',
            title: item.product_title || item.title || '',
            variant_title: presentation.variantText || '',
            quantity: Number(item.quantity || 0),
            sizes: presentation.sizeText || '',
            size_breakdown: this.parseSizeBreakdown(item),
            personalization: presentation.personalizationText || '',
            placement: presentation.placementSummary || presentation.studioText || '',
            mockups: presentation.mockupLinks.map(function (entry) {
              return self.serializeQuoteAsset(entry);
            }),
            designs: presentation.designLinks.map(function (entry) {
              return self.serializeQuoteAsset(entry);
            }),
            mockup_alerts: presentation.mockupAlerts.map(function (alert) {
              return {
                zone_key: alert.zoneKey || '',
                zone: alert.zoneLabel || '',
                message: alert.message || 'Mockup indisponible'
              };
            }),
            mockup_status: presentation.mockupStatus,
            properties: item.properties || {},
            unit_price_cents: pricing.unitPriceCents,
            line_price_cents: pricing.linePriceCents,
            items_total_price_cents: Number.isFinite(pricing.itemsTotalPriceCents) ? pricing.itemsTotalPriceCents : pricing.linePriceCents,
            technical_fees_cents: Number.isFinite(pricing.technicalFeesCents) ? pricing.technicalFeesCents : 0,
            preparation_fees_cents: Number.isFinite(pricing.preparationFeesCents) ? pricing.preparationFeesCents : 0,
            fee_mode: pricing.feeMode || '',
            currency: quotePricing.currency,
            source_currency: pricing.sourceCurrency || quotePricing.currency,
            source_unit_price_cents: pricing.sourceUnitPriceCents == null ? pricing.unitPriceCents : pricing.sourceUnitPriceCents,
            source_line_price_cents: pricing.sourceLinePriceCents == null ? pricing.linePriceCents : pricing.sourceLinePriceCents,
            image_url: this.serializeQuoteProductImage(item),
            url: item.url || ''
          };
        }, this)
      }
    };
    var attribution = window.TodayMerchLeadAttribution;
    if (attribution && typeof attribution.getSubmissionContext === 'function') {
      try {
        payload.commercial_context = attribution.getSubmissionContext(this.form);
      } catch (error) {
        // Commercial measurement must never prevent a quote request.
      }
    }
    try {
      var intentContext = window.TodayMerchCommercialIntent && window.TodayMerchCommercialIntent.getContext();
      if (intentContext) payload.intent_context = intentContext;
    } catch (error) {
      // Optional visitor measurement must never prevent a quote request.
    }
    return payload;
  };

  QuoteBuilder.prototype.createClientProject = function () {
    var apiBase = String(this.config.clientPortalApiBase || '').replace(/\/$/, '');
    if (!apiBase || this.clientProjectCreated) return Promise.resolve(null);
    if (this.clientProjectRequestPromise) return this.clientProjectRequestPromise;

    this.clientProjectSubmitInFlight = true;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    this.clientProjectAbortController = controller;
    var configuredTimeout = Number(this.config.auxiliaryRequestTimeoutMs);
    var requestTimeoutMs = Number.isFinite(configuredTimeout) && configuredTimeout >= 1 && configuredTimeout <= 30000
      ? configuredTimeout
      : 10000;
    var requestTimeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, requestTimeoutMs);
    var projectPayload = this.buildClientProjectPayload();
    var locale = this.config.locale || document.documentElement.lang || 'fr';
    var publicApi = window.TodayMerchPublicApi;
    projectPayload = publicApi && typeof publicApi.withLocale === 'function'
      ? publicApi.withLocale(projectPayload, locale)
      : Object.assign(projectPayload, { locale: String(locale).toLowerCase().split('-')[0] === 'en' ? 'en' : 'fr' });
    var mutationIntent = window.TodayMerchClientMutationIntent;
    var materialPayload;
    try {
      var serializedPayload = JSON.parse(JSON.stringify(projectPayload));
      materialPayload = { quote: serializedPayload.quote };
      if (materialPayload.quote && typeof materialPayload.quote === 'object' && !Array.isArray(materialPayload.quote)) {
        delete materialPayload.quote.reference;
        delete materialPayload.quote.submitted_at;
      } else {
        materialPayload = null;
      }
    } catch (error) {
      materialPayload = null;
    }
    var request = Promise.resolve().then(function () {
      if (!mutationIntent || typeof mutationIntent.get !== 'function'
        || typeof mutationIntent.withContract !== 'function' || typeof mutationIntent.clear !== 'function'
        || !materialPayload) {
        throw new Error('Secure mutation intent is unavailable');
      }
      return mutationIntent.get({
        operation: 'quote_requests.create',
        resource: 'company',
        payload: materialPayload,
        requestId: projectPayload.request_id,
        submittedAt: projectPayload.submitted_at
      });
    }).then(function (intent) {
      this.quoteRequestId = intent.request_id;
      this.quoteSubmittedAt = intent.submitted_at;
      projectPayload.request_id = intent.request_id;
      projectPayload.submitted_at = intent.submitted_at;
      if (projectPayload.quote && typeof projectPayload.quote === 'object') {
        projectPayload.quote.reference = intent.request_id;
        projectPayload.quote.submitted_at = intent.submitted_at;
      }
      var contract = mutationIntent.withContract(projectPayload, intent, 0);
      // Consent may have changed while the mutation contract was being prepared.
      delete contract.body.intent_context;
      try {
        var currentIntentContext = window.TodayMerchCommercialIntent && window.TodayMerchCommercialIntent.getContext();
        if (currentIntentContext) contract.body.intent_context = currentIntentContext;
      } catch (error) { /* Keep the quote request independent from measurement. */ }
      return fetch(apiBase + '/client/quote-requests', {
        method: 'POST',
        credentials: 'include',
        headers: Object.assign({
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }, contract.headers),
        body: JSON.stringify(contract.body),
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        return response.text().then(function (text) {
          var data = text ? JSON.parse(text) : {};
          if (!response.ok) {
            var publicApi = window.TodayMerchPublicApi;
            throw publicApi && typeof publicApi.responseError === 'function'
              ? publicApi.responseError(data, document.documentElement.lang)
              : new Error('Client portal unavailable');
          }
          var projectId = data && data.project && data.project.id;
          var nativeProjectId = typeof projectId === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(projectId);
          var legacyProjectId = typeof projectId === 'string' && /^gid:\/\/shopify\/Metaobject\/[1-9][0-9]*$/.test(projectId);
          if (!nativeProjectId && !legacyProjectId) {
            throw new Error('Client portal returned an invalid project');
          }
          return { data: data, intent: intent };
        });
      });
    }.bind(this))
      .then(function (confirmed) {
        var data = confirmed.data;
        var project = data && data.project;
        this.clientProjectReference = project ? (project.id || '') : '';
        this.clientProjectCreated = true;
        try {
          mutationIntent.clear('quote_requests.create', confirmed.intent);
        } catch (error) {
          // The confirmed server response remains authoritative; a retained record safely replays.
        }
        try {
          this.syncHiddenFields();
        } catch (error) {
          // Detached UI must never turn a confirmed external write into a new intent.
        }
        return data;
      }.bind(this))
      .catch(function (error) {
        var publicApi = window.TodayMerchPublicApi;
        var message = publicApi && typeof publicApi.errorMessage === 'function'
          ? publicApi.errorMessage(
            { code: error && error.code || 'CLIENT_REQUEST_FAILED' },
            this.config.locale || document.documentElement.lang
          )
          : this.translate('statusError');
        try { this.status(message, true); } catch (statusError) {}
        this.clientProjectCreated = false;
        try { this.syncHiddenFields(); } catch (syncError) {}
        return null;
      }.bind(this))
      .finally(function () {
        window.clearTimeout(requestTimeout);
        if (this.clientProjectAbortController === controller) this.clientProjectAbortController = null;
        this.clientProjectSubmitInFlight = false;
        this.clientProjectRequestPromise = null;
        if (this.root && typeof this.root.removeAttribute === 'function') this.root.removeAttribute('aria-busy');
      }.bind(this));
    this.clientProjectRequestPromise = request;
    if (this.root && typeof this.root.setAttribute === 'function') this.root.setAttribute('aria-busy', 'true');
    return request;
  };

  QuoteBuilder.prototype.getAutoReplyApiBase = function () {
    return String(this.config.autoReplyApiBase || this.config.clientPortalApiBase || '').replace(/\/$/, '');
  };

  QuoteBuilder.prototype.buildAutoReplyFields = function () {
    var project = this.getFieldValue('contact[Type de projet]');
    var rawFieldValue = this.getRawFieldValue.bind(this);
    var shippingMode = this.form.querySelector('[data-qb-shipping-mode]:checked');
    var shippingState = this.getShippingState();
    var shippingModeCode = shippingMode && shippingMode.getAttribute('data-qb-shipping-mode') || shippingState.code || '';
    var includesSingleShippingAddress = Boolean(
      shippingMode && shippingMode.getAttribute('data-qb-shipping-mode') === 'single'
    );

    return {
      request_type: { value: 'quote_request', valueCode: 'quote_request' },
      request_reference: this.getQuoteRequestId(),
      project_type: project,
      target_date: { value: this.getFieldValue('contact[Date cible]'), format: 'date' },
      project_notes: rawFieldValue('contact[Notes projet]'),
      shipping_mode: shippingModeCode
        ? { value: shippingModeCode, valueCode: shippingModeCode }
        : (shippingState.label || ''),
      shipping_address: includesSingleShippingAddress ? rawFieldValue('contact[Adresse de livraison]') : '',
      shipping_address_2: includesSingleShippingAddress ? rawFieldValue('contact[Complément d’adresse de livraison]') : '',
      shipping_postal_code: includesSingleShippingAddress ? rawFieldValue('contact[Code postal de livraison]') : '',
      shipping_city: includesSingleShippingAddress ? rawFieldValue('contact[Ville de livraison]') : '',
      shipping_country: includesSingleShippingAddress ? rawFieldValue('contact[Pays de livraison]') : '',
      product_references: this.hiddenReferencesEl ? this.hiddenReferencesEl.value : '',
      product_units: this.hiddenUnitsEl ? this.hiddenUnitsEl.value : '',
      products_subtotal_ex_vat: this.hiddenSubtotalEl ? this.hiddenSubtotalEl.value : '',
      products_summary: this.hiddenItemsEl ? this.hiddenItemsEl.value : '',
      studio_mockups: this.hiddenMockupsEl ? this.hiddenMockupsEl.value : '',
      original_designs: this.hiddenDesignsEl ? this.hiddenDesignsEl.value : '',
      uploadcare_files: this.hiddenUploadcareEl ? this.hiddenUploadcareEl.value : '',
      assets_link: this.getFieldValue('contact[Lien vers assets]'),
      first_name: rawFieldValue('contact[Prénom]'),
      last_name: rawFieldValue('contact[Nom]'),
      email: this.getFieldValue('contact[email]'),
      phone: rawFieldValue('contact[Téléphone]'),
      company: rawFieldValue('contact[Entreprise]'),
      contact_preference: this.getFieldValue('contact[Préférence de contact]')
    };
  };

  QuoteBuilder.prototype.buildAutoReplyPayload = function () {
    var structuredPayload = this.buildClientProjectPayload();
    var websiteField = this.form && this.form.querySelector('[name="website"]');
    var payload = {
      type: 'quote_request',
      request_id: structuredPayload.request_id,
      submitted_at: structuredPayload.submitted_at,
      page_url: this.config.pageUrl || window.location.href,
      contact: {
        first_name: this.getRawFieldValue('contact[Prénom]'),
        last_name: this.getRawFieldValue('contact[Nom]'),
        email: this.getFieldValue('contact[email]'),
        phone: this.getRawFieldValue('contact[Téléphone]'),
        company: this.getRawFieldValue('contact[Entreprise]')
      },
      fields: this.buildAutoReplyFields(),
      quote: structuredPayload.quote,
      website: websiteField ? websiteField.value : ''
    };
    if (structuredPayload.commercial_context) payload.commercial_context = structuredPayload.commercial_context;
    if (structuredPayload.intent_context) payload.intent_context = structuredPayload.intent_context;
    var locale = this.config.locale || document.documentElement.lang || 'fr';
    return window.TodayMerchPublicApi && typeof window.TodayMerchPublicApi.withLocale === 'function'
      ? window.TodayMerchPublicApi.withLocale(payload, locale)
      : Object.assign(payload, { locale: String(locale).toLowerCase().split('-')[0] === 'en' ? 'en' : 'fr' });
  };

  QuoteBuilder.prototype.sendAutoReply = function () {
    var apiBase = this.getAutoReplyApiBase();
    if (!apiBase || this.autoReplySent || this.autoReplySubmitInFlight) return Promise.resolve(null);

    this.autoReplySubmitInFlight = true;
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 20000);
    return Promise.resolve().then(function () {
      return fetch(apiBase + '/forms/autoreply', {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.buildAutoReplyPayload()),
        signal: controller ? controller.signal : undefined
      });
    }.bind(this))
      .then(function (response) {
        return response.text().then(function (text) {
          var data = {};
          try {
            data = text ? JSON.parse(text) : {};
          } catch (error) {}
          if (!response.ok) {
            var publicApi = window.TodayMerchPublicApi;
            if (publicApi && typeof publicApi.responseError === 'function') {
              throw publicApi.responseError(data, this.config.locale || document.documentElement.lang);
            }
            var responseError = new Error('Auto reply unavailable');
            responseError.code = data && data.code || 'AUTOREPLY_REQUEST_FAILED';
            throw responseError;
          }
          var client = data && data.client || {};
          var team = data && data.team || {};
          var accepted = data && data.accepted === true && (client.sent === true || client.queued === true) && team.sent === true;
          if (!accepted) {
            var deliveryError = new Error('Quote notifications were not accepted');
            deliveryError.code = data && data.code || 'AUTOREPLY_DELIVERY_FAILED';
            throw deliveryError;
          }
          this.autoReplySent = true;
          return Object.assign({}, data, {
            ok: true,
            accepted: true,
            queued: client.queued === true
          });
        }.bind(this));
      }.bind(this))
      .catch(function (error) {
        var code = error && error.code || 'AUTOREPLY_REQUEST_FAILED';
        var publicApi = window.TodayMerchPublicApi;
        var fallbackMessage = code === 'AUTOREPLY_RECIPIENT_UNDELIVERABLE'
          ? 'Merci de vérifier votre adresse e-mail ou d’utiliser une autre adresse.'
          : null;
        if (fallbackMessage && /^de(?:-|_|$)/i.test(String(this.config.locale || document.documentElement.lang).trim())) {
          fallbackMessage = publicApi && typeof publicApi.errorMessage === 'function'
            ? publicApi.errorMessage({ code: code }, this.config.locale || document.documentElement.lang)
            : 'Bitte überprüfen Sie Ihre E-Mail-Adresse oder verwenden Sie eine andere Adresse.';
        }
        if (code === 'AUTOREPLY_RECIPIENT_UNDELIVERABLE') {
          this.quoteRequestId = '';
          this.quoteSubmittedAt = '';
          try { this.syncHiddenFields(); } catch (syncError) {}
        }
        var message = fallbackMessage || (publicApi && typeof publicApi.errorMessage === 'function'
          ? publicApi.errorMessage(
            { code: code },
            this.config.locale || document.documentElement.lang
          )
          : this.translate('statusError'));
        this.status(message, true);
        return { ok: false, code: code };
      }.bind(this))
      .finally(function () {
        window.clearTimeout(timeout);
        this.autoReplySubmitInFlight = false;
      }.bind(this));
  };

  QuoteBuilder.prototype.showSubmitSuccess = function (options) {
    if (!this.successPageEl) return;
    var settings = options && typeof options === 'object' ? options : {};
    var wasSuccessful = this.root.classList.contains('is-submit-success');
    this.root.classList.add('is-submit-success');
    this.successPageEl.hidden = false;
    this.successPageEl.setAttribute('data-today-merch-lead-success', 'quote_submitted');
    if (this.statusEl) this.status('');
    if (this.mobileSubmitEl) this.mobileSubmitEl.disabled = true;
    this.submitButtons.forEach(function (button) {
      button.disabled = true;
      button.classList.remove('is-loading');
    });
    if (!wasSuccessful) {
      try {
        document.dispatchEvent(new CustomEvent('todaymerch:quote-succeeded', {
          detail: { lead_id: this.getRawFieldValue('contact[Lead ID]') }
        }));
      } catch (error) {}
    }

    if (settings.focus === false) return;
    window.requestAnimationFrame(function () {
      try {
        this.successPageEl.focus({ preventScroll: true });
      } catch (error) {
        try { this.successPageEl.focus(); } catch (focusError) {}
      }
      try {
        this.successPageEl.scrollIntoView({ block: 'start', behavior: 'smooth' });
      } catch (error) {}
    }.bind(this));
  };

  QuoteBuilder.prototype.updateSubmitState = function () {
    if (this.root.classList.contains('is-submit-success')) {
      this.submitButtons.forEach(function (button) {
        button.disabled = true;
        button.classList.remove('is-loading');
      });
      if (this.stepPrevEl) this.stepPrevEl.disabled = true;
      if (this.stepNextEl) this.stepNextEl.disabled = true;
      if (this.mobileSubmitEl) this.mobileSubmitEl.disabled = true;
      return;
    }
    var isFinalStep = this.currentStep >= this.totalWizardSteps;
    var submitDisabled = !this.cart.items.length || this.submitLoading || !isFinalStep;
    var actionReady = this.isStepActionReady();
    var actionDisabled = this.submitLoading || !actionReady;
    var self = this;
    this.submitButtons.forEach(function (button) {
      button.disabled = submitDisabled;
      button.textContent = self.translate(self.submitLoading ? 'submitLoadingLabel' : 'submitLabel');
      button.classList.toggle('is-loading', self.submitLoading);
    });
    if (this.stepPrevEl) this.stepPrevEl.disabled = this.submitLoading || this.currentStep <= 1;
    if (this.stepNextEl) {
      this.stepNextEl.disabled = actionDisabled;
      this.stepNextEl.classList.toggle('is-disabled-by-progress', actionDisabled);
    }
    if (this.mobileSubmitEl) {
      this.mobileSubmitEl.disabled = isFinalStep ? submitDisabled : actionDisabled;
      this.mobileSubmitEl.textContent = self.submitLoading
        ? self.translate('submitLoadingLabel')
        : self.translate(isFinalStep ? 'submitLabel' : 'wizardContinueLabel');
      this.mobileSubmitEl.classList.toggle('is-loading', self.submitLoading);
      this.mobileSubmitEl.classList.toggle('is-disabled-by-progress', !isFinalStep && actionDisabled);
    }
  };

  QuoteBuilder.prototype.publishCartUpdate = function (cart) {
    try {
      if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS && typeof window.FoxTheme.pubsub.publish === 'function') {
        window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      }
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    } catch (e) {}
  };

  QuoteBuilder.prototype.fetchCart = function () {
    var self = this;
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        self.cart = self.normalizeCart(cart);
        return cart;
      });
  };

  QuoteBuilder.prototype.showToast = function (message) {
    var self = this;
    if (!this.toastEl) return;
    if (this.toastMessageEl) this.toastMessageEl.textContent = message || this.translate('removedMessage');
    this.toastEl.hidden = false;
    window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(function () {
      self.hideToast();
    }, Number(this.config.removedUndoWindow || 8000));
  };

  QuoteBuilder.prototype.hideToast = function () {
    if (!this.toastEl) return;
    this.toastEl.hidden = true;
    window.clearTimeout(this.toastTimer);
  };

  QuoteBuilder.prototype.removeLine = function (lineKey) {
    if (this.cartBusy) return;
    var lineItem = this.cart.items.find(function (item) { return item.key === lineKey; });
    if (lineItem) {
      this.removedItem = {
        id: lineItem.id,
        quantity: lineItem.quantity,
        properties: lineItem.properties || {},
        selling_plan: lineItem.selling_plan_allocation && lineItem.selling_plan_allocation.selling_plan ? lineItem.selling_plan_allocation.selling_plan.id : null,
        title: lineItem.product_title || lineItem.title || this.translate('genericProductLabel'),
        rules: this.getItemRules(lineItem)
      };
    }
    this.updateLine(lineKey, 0, true, 'remove');
  };

  QuoteBuilder.prototype.undoRemove = function () {
    var self = this;
    if (this.cartBusy || !this.removedItem || !this.removedItem.id) return;
    var payload = { items: [{ id: this.removedItem.id, quantity: this.removedItem.quantity, properties: this.removedItem.properties || {} }] };
    if (this.removedItem.selling_plan) payload.items[0].selling_plan = this.removedItem.selling_plan;

    this.cartBusy = true;
    this.root.classList.add('is-cart-busy');

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Undo add failed');
        return response.json();
      })
      .then(function () {
        return self.fetchCart();
      })
      .then(function (cart) {
        self.cart = self.normalizeCart(cart);
        self.loadingLineKey = null;
        self.renderCart();
        self.syncSummary();
        self.syncHiddenFields();
        self.updateSubmitState();
        self.saveState();
        self.publishCartUpdate(cart);
        self.status(self.translate('statusUpdated'));
        self.hideToast();
        self.removedItem = null;
      })
      .catch(function () {
        self.status(self.translate('statusError'), true);
      })
      .finally(function () {
        self.cartBusy = false;
        self.root.classList.remove('is-cart-busy');
      });
  };

  QuoteBuilder.prototype.getSizeShell = function (lineKey) {
    return this.root.querySelector('[data-qb-size-shell][data-line-key="' + selectorEscape(lineKey) + '"]');
  };

  QuoteBuilder.prototype.collectSizeEditorBreakdown = function (shell) {
    var breakdown = {};
    if (!shell) return breakdown;

    shell.querySelectorAll('[data-qb-size-input]').forEach(function (input) {
      var size = String(input.getAttribute('data-size') || '').trim();
      var quantity = parseInt(input.value, 10);
      if (!Number.isFinite(quantity) || quantity < 0) quantity = 0;
      input.value = quantity > 0 ? String(quantity) : '';
      if (size && quantity > 0) breakdown[size] = quantity;
    });

    return breakdown;
  };

  QuoteBuilder.prototype.syncSizeEditor = function (shell) {
    if (!shell) return false;

    var lineKey = shell.getAttribute('data-line-key');
    var item = this.getItemByLineKey(lineKey);
    if (!item) return false;

    var breakdown = this.collectSizeEditorBreakdown(shell);
    var state = this.getSizeBreakdownState(item, breakdown);
    var hasExistingBreakdown = this.hasSizeBreakdown(item);
    var canSave = state.total === state.target && state.total > 0;
    var isInvalid = (state.total > 0 || hasExistingBreakdown) && !canSave;
    var stateEl = shell.querySelector('[data-qb-size-state]');
    var messageEl = shell.querySelector('[data-qb-size-message]');
    var clearButton = shell.querySelector('[data-qb-size-clear]');

    shell.classList.toggle('is-error', isInvalid);

    if (stateEl) {
      stateEl.textContent = isInvalid
        ? this.getSizeAdjustmentText(state)
        : this.translate(hasExistingBreakdown || state.total > 0 ? 'sizeCompleteLabel' : 'sizeOptionalLabel');
      stateEl.classList.toggle('is-warning', isInvalid);
    }

    if (messageEl) {
      messageEl.textContent = this.translate('sizeTotalLabel') + ' : ' + state.total + '/' + state.target;
    }

    if (clearButton) {
      var canClear = hasExistingBreakdown || state.total > 0;
      clearButton.disabled = !canClear;
      clearButton.setAttribute('aria-disabled', canClear ? 'false' : 'true');
    }

    return canSave;
  };

  QuoteBuilder.prototype.areSizeBreakdownsEqual = function (first, second) {
    return (this.apparelSizes || []).every(function (size) {
      return (parseInt(first && first[size], 10) || 0) === (parseInt(second && second[size], 10) || 0);
    });
  };

  QuoteBuilder.prototype.clearSizeAutoSave = function (lineKey) {
    this.sizeAutoSaveTimers = this.sizeAutoSaveTimers || {};

    if (lineKey) {
      if (this.sizeAutoSaveTimers[lineKey]) window.clearTimeout(this.sizeAutoSaveTimers[lineKey]);
      delete this.sizeAutoSaveTimers[lineKey];
      return;
    }

    Object.keys(this.sizeAutoSaveTimers).forEach(function (key) {
      window.clearTimeout(this.sizeAutoSaveTimers[key]);
      delete this.sizeAutoSaveTimers[key];
    }, this);
  };

  QuoteBuilder.prototype.scheduleSizeBreakdownAutoSave = function (shell) {
    if (!shell) return;

    var lineKey = shell.getAttribute('data-line-key');
    var item = this.getItemByLineKey(lineKey);
    if (!lineKey || !item || this.cartBusy) return;

    this.clearSizeAutoSave(lineKey);

    var breakdown = this.collectSizeEditorBreakdown(shell);
    var state = this.getSizeBreakdownState(item, breakdown);
    var existingBreakdown = this.parseSizeBreakdown(item);

    if (state.total !== state.target || state.total <= 0 || this.areSizeBreakdownsEqual(existingBreakdown, breakdown)) {
      return;
    }

    this.sizeAutoSaveTimers[lineKey] = window.setTimeout(function () {
      var currentShell = this.getSizeShell(lineKey);
      delete this.sizeAutoSaveTimers[lineKey];

      if (!currentShell || this.cartBusy || !this.syncSizeEditor(currentShell)) return;
      this.saveSizeBreakdown(lineKey);
    }.bind(this), 420);
  };

  QuoteBuilder.prototype.rememberReplacementLineViews = function (previousItem, viewOptions) {
    var options = Array.isArray(viewOptions) ? viewOptions : [];
    if (!previousItem || !options.length) return;

    var replacement = this.cart.items.find(function (item) {
      return Number(item.line || 0) === Number(previousItem.line || 0);
    }) || this.cart.items.find(function (item) {
      return String(item.variant_id || item.id || '') === String(previousItem.variant_id || previousItem.id || '') &&
        String(item.product_id || '') === String(previousItem.product_id || '');
    });

    if (replacement && replacement.key) {
      this.lineViewOptions[replacement.key] = options;
    }
  };

  QuoteBuilder.prototype.changeLineProperties = function (lineItem, properties, successMessage) {
    var self = this;
    if (this.cartBusy || !lineItem) return;

    this.clearSizeAutoSave(lineItem.key);

    var previousViewOptions = this.getItemViewOptions(lineItem);
    var payload = {
      quantity: Math.max(parseInt(lineItem.quantity, 10) || 1, 1),
      properties: properties || {}
    };

    if (Number(lineItem.line || 0) > 0) {
      payload.line = Number(lineItem.line || 0);
    } else {
      payload.id = lineItem.key;
    }

    this.loadingLineKey = lineItem.key;
    this.cartBusy = true;
    this.root.classList.add('is-cart-busy');
    this.status(this.translate('statusUpdating'));
    this.renderCart();

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart properties change failed');
        return response.json();
      })
      .then(function (cart) {
        self.cart = self.normalizeCart(cart);
        self.rememberReplacementLineViews(lineItem, previousViewOptions);
        self.loadingLineKey = null;
        self.openSizeEditorLineKey = null;
        self.renderCart();
        self.syncSummary();
        self.syncHiddenFields();
        self.updateSubmitState();
        self.saveState();
        self.publishCartUpdate(cart);
        var resolvedSuccessMessage = successMessage || self.translate('statusUpdated');
        self.status(resolvedSuccessMessage);
        window.setTimeout(function () {
          if (self.statusEl && self.statusEl.textContent === resolvedSuccessMessage) self.status('');
        }, 1800);
      })
      .catch(function () {
        self.loadingLineKey = null;
        self.status(self.translate('statusError'), true);
        self.fetchCart().then(function (cart) {
          self.cart = self.normalizeCart(cart);
          self.renderCart();
          self.syncSummary();
          self.syncHiddenFields();
          self.updateSubmitState();
        });
      })
      .finally(function () {
        self.cartBusy = false;
        self.root.classList.remove('is-cart-busy');
      });
  };

  QuoteBuilder.prototype.saveSizeBreakdown = function (lineKey) {
    if (this.cartBusy) return;

    this.clearSizeAutoSave(lineKey);

    var item = this.getItemByLineKey(lineKey);
    var shell = this.getSizeShell(lineKey);
    if (!item || !shell) return;

    if (!this.syncSizeEditor(shell)) {
      this.status(this.translate('sizeValidationError'), true);
      return;
    }

    var breakdown = this.collectSizeEditorBreakdown(shell);
    if (this.areSizeBreakdownsEqual(this.parseSizeBreakdown(item), breakdown)) {
      this.openSizeEditorLineKey = null;
      this.renderCart();
      return;
    }

    var summary = this.buildSizeBreakdownSummary(breakdown);
    var properties = this.cloneItemProperties(item);
    var sizeProperties = window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.buildSizeProperties
      ? window.TodayMerchLineItemProperties.buildSizeProperties(breakdown, summary)
      : { _tm_line_contract_version: '1', _tm_size_summary: summary, _tm_size_breakdown: JSON.stringify(breakdown) };
    properties = window.TodayMerchLineItemProperties && window.TodayMerchLineItemProperties.materializeCanonical
      ? window.TodayMerchLineItemProperties.materializeCanonical(properties, sizeProperties)
      : Object.assign(properties, sizeProperties);
    properties._tm_apparel = 'true';
    delete properties.Tailles;
    delete properties.Sizes;

    this.changeLineProperties(item, properties, this.translate('sizeSavedStatus'));
  };

  QuoteBuilder.prototype.clearSizeBreakdown = function (lineKey) {
    if (this.cartBusy) return;

    this.clearSizeAutoSave(lineKey);

    var item = this.getItemByLineKey(lineKey);
    if (!item) return;

    if (!this.hasSizeBreakdown(item)) {
      this.openSizeEditorLineKey = null;
      this.renderCart();
      return;
    }

    var properties = this.cloneItemProperties(item);
    properties._tm_apparel = 'true';
    delete properties._tm_size_breakdown;
    delete properties._tm_size_summary;
    delete properties.Tailles;
    delete properties.Sizes;

    this.changeLineProperties(item, properties, this.translate('sizeClearedStatus'));
  };

  QuoteBuilder.prototype.deferSizeBreakdown = function (lineKey) {
    if (this.cartBusy) return;

    this.clearSizeAutoSave(lineKey);

    var item = this.getItemByLineKey(lineKey);
    if (!item) return;

    this.openSizeEditorLineKey = null;

    if (!this.hasSizeBreakdown(item)) {
      this.renderCart();
      return;
    }

    var properties = this.cloneItemProperties(item);
    properties._tm_apparel = 'true';
    delete properties._tm_size_breakdown;
    delete properties._tm_size_summary;
    delete properties.Tailles;
    delete properties.Sizes;

    this.changeLineProperties(item, properties, this.translate('sizeLaterStatus'));
  };

  QuoteBuilder.prototype.buildOptimisticQuantityCart = function (lineKey, quantity, properties) {
    var items = this.cart.items.map(function (item) {
      var optimisticItem = Object.assign({}, item, {
        properties: Object.assign({}, item.properties || {}),
        quantity_rule: Object.assign({}, item.quantity_rule || {})
      });

      if (item.key !== lineKey) return optimisticItem;

      var finalUnitPrice = Number(item.final_price || item.price || 0);
      var regularUnitPrice = Number(item.price || finalUnitPrice);
      var originalUnitPrice = Number(item.original_price || regularUnitPrice);

      optimisticItem.quantity = quantity;
      optimisticItem.properties = Object.assign({}, properties || item.properties || {});
      optimisticItem.final_line_price = finalUnitPrice * quantity;
      optimisticItem.line_price = regularUnitPrice * quantity;
      optimisticItem.original_line_price = originalUnitPrice * quantity;

      return optimisticItem;
    });

    return this.normalizeCart(Object.assign({}, this.cart, {
      items: items,
      item_count: items.reduce(function (total, item) {
        return total + Number(item.quantity || 0);
      }, 0)
    }));
  };

  QuoteBuilder.prototype.updateLine = function (lineKey, quantity, removedAction, mode) {
    var self = this;
    if (this.cartBusy) return;

    var lineItem = this.cart.items.find(function (item) { return item.key === lineKey; });
    if (!lineItem) return;

    this.clearSizeAutoSave(lineKey);

    var rules = this.getItemRules(lineItem);
    var nextQuantity = this.normalizeQuantity(quantity, rules, mode || 'input');
    if (nextQuantity === Number(lineItem.quantity || 0)) {
      this.renderCart();
      return;
    }

    var previousCart = this.cart;
    var updatedProperties = null;
    if (window.TodayMerchQuantityPricing && nextQuantity > 0) {
      updatedProperties = window.TodayMerchQuantityPricing.buildUpdatedProperties(lineItem.properties || {}, nextQuantity, rules);
    }
    var hasOptimisticUpdate = nextQuantity > 0 && !removedAction;

    this.loadingLineKey = lineKey;
    this.cartBusy = true;
    this.root.classList.add('is-cart-busy');
    this.status(hasOptimisticUpdate ? '' : this.translate('statusUpdating'));

    var payload = { quantity: nextQuantity };
    if (Number(lineItem.line || 0) > 0) {
      payload.line = Number(lineItem.line || 0);
    } else {
      payload.id = lineKey;
    }
    if (updatedProperties) payload.properties = updatedProperties;

    if (hasOptimisticUpdate) {
      this.cart = this.buildOptimisticQuantityCart(lineKey, nextQuantity, updatedProperties);
      this.renderCart();
      this.syncSummary();
      this.syncHiddenFields();
      this.updateSubmitState();
    } else {
      this.renderCart();
    }

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart change failed');
        return response.json();
      })
      .then(function (cart) {
        self.cart = self.normalizeCart(cart);
        self.loadingLineKey = null;
        self.renderCart();
        self.syncSummary();
        self.syncHiddenFields();
        self.updateSubmitState();
        self.saveState();
        self.publishCartUpdate(cart);
        var updatedMessage = self.translate('statusUpdated');
        self.status(updatedMessage);
        if (removedAction && self.removedItem) self.showToast(self.translate('removedMessage'));
        window.setTimeout(function () {
          if (self.statusEl && self.statusEl.textContent === updatedMessage) self.status('');
        }, 1800);
      })
      .catch(function () {
        self.loadingLineKey = null;
        self.status(self.translate('statusError'), true);
        if (hasOptimisticUpdate) {
          self.cart = previousCart;
          self.renderCart();
          self.syncSummary();
          self.syncHiddenFields();
          self.updateSubmitState();
        }
        self.fetchCart().then(function (cart) {
          self.cart = self.normalizeCart(cart);
          self.renderCart();
          self.syncSummary();
          self.syncHiddenFields();
          self.updateSubmitState();
        });
      })
      .finally(function () {
        self.cartBusy = false;
        self.root.classList.remove('is-cart-busy');
      });
  };

  QuoteBuilder.prototype.setFieldError = function (wrapper, message) {
    if (!wrapper) return;
    wrapper.classList.add('is-error');
    var errorEl = wrapper.querySelector('[data-qb-error]') || wrapper.querySelector('.qb__field-error');
    if (errorEl) {
      errorEl.textContent = message || '';
      errorEl.classList.add('is-visible');
    }
    var input = wrapper.querySelector('input, textarea, select');
    if (input) input.setAttribute('aria-invalid', 'true');
  };

  QuoteBuilder.prototype.clearFieldError = function (wrapper) {
    if (!wrapper) return;
    wrapper.classList.remove('is-error');
    var errorEl = wrapper.querySelector('[data-qb-error]') || wrapper.querySelector('.qb__field-error');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }
    var input = wrapper.querySelector('input, textarea, select');
    if (input) input.removeAttribute('aria-invalid');
  };

  QuoteBuilder.prototype.validateInput = function (input) {
    if (!input || input.disabled) return true;
    var wrapper = input.closest('[data-qb-field-wrapper]');
    var value = typeof input.value === 'string' ? input.value.trim() : '';
    var label = input.getAttribute('data-qb-required-label') || input.getAttribute('aria-label') || this.translate('requiredFieldFallback');
    var isHidden = input.offsetParent === null && input.type !== 'hidden';

    if (isHidden && !input.required && !value) return true;

    if (input.required && !value) {
      this.setFieldError(wrapper, label + this.translate('requiredSuffix'));
      return false;
    }

    if (input.type === 'email' && value && !input.checkValidity()) {
      this.setFieldError(wrapper, this.translate('invalidEmail'));
      return false;
    }

    if (input.type === 'url' && value && !input.checkValidity()) {
      this.setFieldError(wrapper, this.translate('invalidUrl'));
      return false;
    }

    this.clearFieldError(wrapper);
    return true;
  };

  QuoteBuilder.prototype.validateShipping = function () {
    var valid = true;
    var decision = this.form.querySelector('[data-qb-shipping-decision]:checked');
    if (!decision) {
      valid = false;
      if (this.shippingDecisionGroup) this.shippingDecisionGroup.classList.add('is-error');
      if (this.shippingDecisionErrorEl) {
        this.shippingDecisionErrorEl.textContent = this.translate('shippingDecisionError');
        this.shippingDecisionErrorEl.classList.add('is-visible');
      }
    } else {
      if (this.shippingDecisionGroup) this.shippingDecisionGroup.classList.remove('is-error');
      if (this.shippingDecisionErrorEl) {
        this.shippingDecisionErrorEl.textContent = '';
        this.shippingDecisionErrorEl.classList.remove('is-visible');
      }
    }

    if (decision && decision.getAttribute('data-qb-shipping-decision') === 'now') {
      var mode = this.form.querySelector('[data-qb-shipping-mode]:checked');
      if (!mode) {
        valid = false;
        if (this.shippingModeGroup) this.shippingModeGroup.classList.add('is-error');
        if (this.shippingModeErrorEl) {
          this.shippingModeErrorEl.textContent = this.translate('shippingModeError');
          this.shippingModeErrorEl.classList.add('is-visible');
        }
      } else {
        if (this.shippingModeGroup) this.shippingModeGroup.classList.remove('is-error');
        if (this.shippingModeErrorEl) {
          this.shippingModeErrorEl.textContent = '';
          this.shippingModeErrorEl.classList.remove('is-visible');
        }
      }
    } else {
      if (this.shippingModeGroup) this.shippingModeGroup.classList.remove('is-error');
      if (this.shippingModeErrorEl) {
        this.shippingModeErrorEl.textContent = '';
        this.shippingModeErrorEl.classList.remove('is-visible');
      }
    }

    return valid;
  };

  QuoteBuilder.prototype.validateConsent = function () {
    if (!this.consentInput) return true;
    if (!this.consentInput.required || this.consentInput.checked) {
      this.consentInput.setAttribute('aria-invalid', 'false');
      if (this.consentWrapper) this.consentWrapper.classList.remove('is-error');
      if (this.consentErrorEl) {
        this.consentErrorEl.textContent = '';
        this.consentErrorEl.classList.remove('is-visible');
        this.consentErrorEl.hidden = true;
      }
      return true;
    }
    this.consentInput.setAttribute('aria-invalid', 'true');
    if (this.consentWrapper) this.consentWrapper.classList.add('is-error');
    if (this.consentErrorEl) {
      this.consentErrorEl.textContent = this.translate('consentError');
      this.consentErrorEl.classList.add('is-visible');
      this.consentErrorEl.hidden = false;
    }
    return false;
  };

  QuoteBuilder.prototype.validateSizeBreakdowns = function () {
    var openIssue = null;

    this.root.querySelectorAll('[data-qb-size-shell]').forEach(function (shell) {
      if (openIssue || !shell.querySelector('[data-qb-size-input]')) return;

      var lineKey = shell.getAttribute('data-line-key');
      var item = this.getItemByLineKey(lineKey);
      if (!item) return;

      var breakdown = this.collectSizeEditorBreakdown(shell);
      var state = this.getSizeBreakdownState(item, breakdown);

      if (state.total !== state.target) {
        openIssue = { type: 'invalid', lineKey: lineKey, shell: shell };
        return;
      }

      if (state.total === state.target && state.total > 0 && !this.areSizeBreakdownsEqual(this.parseSizeBreakdown(item), breakdown)) {
        openIssue = { type: 'pending', lineKey: lineKey, shell: shell };
      }
    }, this);

    if (openIssue) {
      this.openSizeEditorLineKey = openIssue.lineKey;
      this.syncSizeEditor(openIssue.shell);

      if (openIssue.type === 'pending') {
        this.saveSizeBreakdown(openIssue.lineKey);
      } else {
        this.status(this.translate('sizeSubmitError'), true);
      }

      return {
        valid: false,
        element: openIssue.shell || this.cartItemsEl
      };
    }

    var invalidItem = this.cart.items.find(function (item) {
      if (!this.isApparelItem(item) || !this.hasSizeBreakdown(item)) return false;
      return !this.getSizeBreakdownState(item).valid;
    }, this);

    if (!invalidItem) return { valid: true, element: null };

    this.openSizeEditorLineKey = invalidItem.key;
    this.renderCart();

    var shell = this.getSizeShell(invalidItem.key);
    if (shell) this.syncSizeEditor(shell);
    this.status(this.translate('sizeSubmitError'), true);

    return {
      valid: false,
      element: shell || this.cartItemsEl
    };
  };

  QuoteBuilder.prototype.validateForm = function () {
    this.syncContactPreference();
    var self = this;
    var firstInvalid = null;
    var valid = true;

    this.root.querySelectorAll('[data-qb-field-wrapper] input, [data-qb-field-wrapper] textarea, [data-qb-field-wrapper] select').forEach(function (input) {
      if (!self.validateInput(input)) {
        valid = false;
        if (!firstInvalid) firstInvalid = input;
      }
    });

    if (!this.validateTargetDateChoice()) {
      valid = false;
      if (!firstInvalid) firstInvalid = this.targetDateChoiceGroup;
    }

    if (!this.validateShipping()) {
      valid = false;
      if (!firstInvalid) firstInvalid = this.shippingDecisionGroup;
    }

    if (!this.validateConsent()) {
      valid = false;
      if (!firstInvalid) firstInvalid = this.consentInput;
    }

    var sizeValidation = this.validateSizeBreakdowns();
    if (!sizeValidation.valid) {
      valid = false;
      if (!firstInvalid) firstInvalid = sizeValidation.element;
    }

    if (!this.cart.items.length) {
      valid = false;
      this.status(this.translate('submitEmpty'), true);
      if (!firstInvalid) firstInvalid = this.cartItemsEl;
    }

    if (!valid) {
      var invalidPanel = firstInvalid && typeof firstInvalid.closest === 'function' ? firstInvalid.closest('[data-qb-step]') : null;
      if (invalidPanel) this.setCurrentWizardStep(invalidPanel.getAttribute('data-qb-step'), { scroll: true });
      this.focusWizardElement(firstInvalid);
    }

    return valid;
  };

  QuoteBuilder.prototype.saveState = function () {
    if (!this.storageKey) return;
    try {
      var state = {};
      this.form.querySelectorAll('[data-qb-persist]').forEach(function (field) {
        var key = field.getAttribute('data-qb-persist');
        if (!key) return;
        if (field.type === 'radio') {
          if (field.checked) state[key] = field.value;
          return;
        }
        if (field.type === 'checkbox') {
          state[key] = field.checked;
          return;
        }
        state[key] = field.value;
      });
      state.uploadcareUrls = this.uploadcareUrls;
      localStorage.setItem(this.storageKey, JSON.stringify(state));
    } catch (error) {}
  };

  QuoteBuilder.prototype.restoreState = function () {
    if (!this.storageKey) return false;
    try {
      var raw = localStorage.getItem(this.storageKey);
      if (!raw) return false;
      var state = JSON.parse(raw);
      var self = this;
      this.form.querySelectorAll('[data-qb-persist]').forEach(function (field) {
        var key = field.getAttribute('data-qb-persist');
        if (!key || !(key in state)) return;
        if (field.type === 'radio') {
          field.checked = state[key] === field.value;
          return;
        }
        if (field.type === 'checkbox') {
          field.checked = Boolean(state[key]);
          return;
        }
        field.value = state[key];
      });
      this.uploadcareUrls = Array.isArray(state.uploadcareUrls) ? state.uploadcareUrls : [];
      this.syncProjectOther();
      this.syncProgressiveBrief();
      this.syncShippingUI();
      this.syncContactPreference();
      this.renderUploadcareList();
      window.setTimeout(function () {
        self.syncSummary();
        self.syncHiddenFields();
      }, 0);
      return true;
    } catch (error) {
      return false;
    }
  };

  QuoteBuilder.prototype.resetUnsavedProgressiveState = function () {
    this.targetDateChoiceInputs.forEach(function (input) {
      input.checked = false;
      input.setAttribute('aria-invalid', 'false');
    });
    if (this.targetDateInput) this.targetDateInput.value = '';
    this.calendarMonthDate = null;
    this.dateStripStartDate = null;
    this.toggleTargetCalendarPopover(false);
    this.resetProjectAnswer();
    this.resetShippingAnswer();
    this.clearTargetDateChoiceError();
    this.clearFieldError(this.targetDateField);
  };

  QuoteBuilder.prototype.clearSavedState = function () {
    if (!this.storageKey) return;
    try {
      localStorage.removeItem(this.storageKey);
    } catch (error) {}
  };

  QuoteBuilder.prototype.renderUploadcareList = function () {
    if (!this.uploadcareListEl || !this.uploadcareStateEl) return;
    if (!this.uploadcareUrls.length) {
      this.uploadcareStateEl.textContent = this.translate('uploadcareEmptyLabel');
      this.uploadcareListEl.hidden = true;
      this.uploadcareListEl.innerHTML = '';
      return;
    }
    this.uploadcareStateEl.textContent = this.translate('uploadcareReadyLabel');
    this.uploadcareListEl.hidden = false;
    var fileLabel = this.translate('uploadedFileLabel');
    var openLabel = this.translate('openLabel');
    this.uploadcareListEl.innerHTML = this.uploadcareUrls.map(function (url, index) {
      var cleanUrl = String(url || '').trim();
      if (!cleanUrl) return '';
      return '<li><a href="' + escapeHtml(cleanUrl) + '" target="_blank" rel="noopener">' + escapeHtml(fileLabel + ' ' + (index + 1)) + '</a><span>' + escapeHtml(cleanUrl.split('/').filter(Boolean).pop() || openLabel) + '</span></li>';
    }).join('');
  };

  QuoteBuilder.prototype.initUploadcare = function () {
    var self = this;
    if (!this.config.enableUploadcare || !this.config.uploadcarePubkey) {
      this.renderUploadcareList();
      return Promise.resolve();
    }
    if (this.uploadcareInitialized) return Promise.resolve();
    this.uploadcareInitialized = true;

    function loadUploadcareComponents() {
      if (window.customElements && customElements.get('uc-upload-ctx-provider')) {
        return Promise.resolve();
      }
      if (!self.config.uploadcareScriptUrl) {
        return Promise.reject(new Error('Uploadcare script URL unavailable'));
      }
      if (!window.__todayMerchUploadcareLoader) {
        window.__todayMerchUploadcareLoader = import(self.config.uploadcareScriptUrl)
          .then(function (UC) {
            if (!window.__todayMerchUploadcareDefined) {
              UC.defineComponents(UC);
              window.__todayMerchUploadcareDefined = true;
            }
          })
          .catch(function (error) {
            window.__todayMerchUploadcareLoader = null;
            throw error;
          });
      }
      return window.__todayMerchUploadcareLoader;
    }

    function ensureUploadcareReady() {
      if (!(window.customElements && typeof customElements.whenDefined === 'function')) {
        return Promise.reject(new Error('Custom elements unavailable'));
      }
      if (customElements.get('uc-upload-ctx-provider')) return Promise.resolve();

      return new Promise(function (resolve, reject) {
        var timeoutId = window.setTimeout(function () {
          reject(new Error('Uploadcare components not ready'));
        }, 5000);

        customElements.whenDefined('uc-upload-ctx-provider')
          .then(function () {
            window.clearTimeout(timeoutId);
            resolve();
          })
          .catch(function (error) {
            window.clearTimeout(timeoutId);
            reject(error);
          });
      });
    }

    return loadUploadcareComponents()
      .then(ensureUploadcareReady)
      .then(function () {
        var provider = self.root.querySelector('uc-upload-ctx-provider[ctx-name="' + selectorEscape(self.config.uploadcareCtx) + '"]');
        if (!provider || typeof provider.getAPI !== 'function') {
          self.renderUploadcareList();
          return;
        }

        function syncFromUploader() {
          try {
            var state = provider.getAPI().getOutputCollectionState() || {};
            self.uploadcareUrls = (state.successEntries || []).map(function (entry) {
              return entry && entry.cdnUrl ? entry.cdnUrl : null;
            }).filter(Boolean);
            self.renderUploadcareList();
            self.syncHiddenFields();
            self.saveState();
          } catch (error) {
            self.renderUploadcareList();
          }
        }

        provider.addEventListener('change', syncFromUploader);
        provider.addEventListener('common-upload-success', syncFromUploader);
        provider.addEventListener('common-upload-failed', function () {
          if (self.uploadcareStateEl) self.uploadcareStateEl.textContent = self.translate('uploadcareErrorLabel');
        });
        syncFromUploader();
      })
      .catch(function () {
        self.uploadcareInitialized = false;
        if (self.uploadcareStateEl) self.uploadcareStateEl.textContent = self.translate('uploadcareErrorLabel');
      });
  };

  QuoteBuilder.prototype.bindEvents = function () {
    var self = this;

    function handleWizardClick(event) {
      var progressBack = event.target.closest('[data-qb-progress-back]');
      if (progressBack) {
        event.preventDefault();
        self.goToPreviousWizardStep();
        return true;
      }

      var stepNav = event.target.closest('[data-qb-step-nav]');
      if (stepNav) {
        event.preventDefault();
        self.goToWizardStep(stepNav.getAttribute('data-qb-step-nav'));
        return true;
      }

      var stepPrev = event.target.closest('[data-qb-step-prev]');
      if (stepPrev) {
        event.preventDefault();
        self.goToPreviousWizardStep();
        return true;
      }

      var stepNext = event.target.closest('[data-qb-step-next]');
      if (stepNext) {
        event.preventDefault();
        self.goToNextWizardStep();
        return true;
      }

      return false;
    }

    if (this.wizardEl && !this.root.contains(this.wizardEl)) {
      this.wizardEl.addEventListener('click', handleWizardClick);
    }

    this.root.addEventListener('click', function (event) {
      if (handleWizardClick(event)) return;

      var projectCard = event.target.closest('[data-qb-project-card]');
      if (projectCard) {
        event.preventDefault();
        if (projectCard.disabled) return;
        self.setProjectChoice(projectCard.getAttribute('data-qb-project-value'));
        return;
      }

      var viewButton = event.target.closest('[data-qb-product-view]');
      if (viewButton) {
        event.preventDefault();
        self.switchProductView(viewButton);
        return;
      }

      var qtyButton = event.target.closest('[data-qb-qty]');
      if (qtyButton) {
        event.preventDefault();
        var lineKey = qtyButton.getAttribute('data-line-key');
        var input = self.root.querySelector('[data-qb-qty-input][data-line-key="' + selectorEscape(lineKey) + '"]');
        if (!input) return;
        var rules = self.getItemRules(self.cart.items.find(function (item) { return item.key === lineKey; }) || {});
        var current = parseInt(input.value, 10) || rules.min;
        var direction = qtyButton.getAttribute('data-qb-qty');
        var next = direction === 'increase' ? current + rules.increment : current - rules.increment;
        self.updateLine(lineKey, next, false, direction);
        return;
      }

      var sizeToggle = event.target.closest('[data-qb-size-toggle]');
      if (sizeToggle) {
        event.preventDefault();
        self.openSizeEditorLineKey = sizeToggle.getAttribute('data-line-key');
        self.renderCart();
        window.setTimeout(function () {
          var shell = self.getSizeShell(self.openSizeEditorLineKey);
          var firstInput = shell && shell.querySelector('[data-qb-size-input]');
          if (firstInput && typeof firstInput.focus === 'function') firstInput.focus({ preventScroll: true });
        }, 0);
        return;
      }

      var sizeSave = event.target.closest('[data-qb-size-save]');
      if (sizeSave) {
        event.preventDefault();
        self.saveSizeBreakdown(sizeSave.getAttribute('data-line-key'));
        return;
      }

      var sizeClear = event.target.closest('[data-qb-size-clear]');
      if (sizeClear) {
        event.preventDefault();
        self.clearSizeBreakdown(sizeClear.getAttribute('data-line-key'));
        return;
      }

      var sizeCancel = event.target.closest('[data-qb-size-cancel]');
      if (sizeCancel) {
        event.preventDefault();
        self.deferSizeBreakdown(sizeCancel.getAttribute('data-line-key'));
        return;
      }

      var removeButton = event.target.closest('[data-qb-remove]');
      if (removeButton) {
        event.preventDefault();
        self.removeLine(removeButton.getAttribute('data-qb-remove'));
        return;
      }

      var toastUndo = event.target.closest('[data-qb-toast-undo]');
      if (toastUndo) {
        event.preventDefault();
        self.undoRemove();
        return;
      }

      var toastClose = event.target.closest('[data-qb-toast-close]');
      if (toastClose) {
        event.preventDefault();
        self.hideToast();
        return;
      }

      var dateStripPrev = event.target.closest('[data-qb-date-strip-prev]');
      if (dateStripPrev) {
        event.preventDefault();
        self.changeDateStrip(-1);
        return;
      }

      var dateStripNext = event.target.closest('[data-qb-date-strip-next]');
      if (dateStripNext) {
        event.preventDefault();
        self.changeDateStrip(1);
        return;
      }

      var dateStripDay = event.target.closest('[data-qb-date-strip-day]');
      if (dateStripDay) {
        event.preventDefault();
        self.selectTargetDate(dateStripDay.getAttribute('data-qb-date-strip-day'));
        self.toggleTargetCalendarPopover(false);
        return;
      }

      var calendarToggle = event.target.closest('[data-qb-calendar-toggle]');
      if (calendarToggle) {
        event.preventDefault();
        self.toggleTargetCalendarPopover();
        return;
      }

      var calendarPrev = event.target.closest('[data-qb-calendar-prev]');
      if (calendarPrev) {
        event.preventDefault();
        self.changeTargetCalendarMonth(-1);
        return;
      }

      var calendarNext = event.target.closest('[data-qb-calendar-next]');
      if (calendarNext) {
        event.preventDefault();
        self.changeTargetCalendarMonth(1);
        return;
      }

      var calendarDay = event.target.closest('[data-qb-calendar-day]');
      if (calendarDay && !calendarDay.disabled) {
        event.preventDefault();
        self.selectTargetDate(calendarDay.getAttribute('data-qb-calendar-day'));
        self.toggleTargetCalendarPopover(false);
        return;
      }

      var mobileSubmit = event.target.closest('[data-qb-mobile-submit]');
      if (mobileSubmit) {
        event.preventDefault();
        if (self.currentStep < self.totalWizardSteps) {
          self.goToNextWizardStep();
          return;
        }
        if (self.form && typeof self.form.requestSubmit === 'function') {
          var submit = self.form.querySelector('[data-qb-submit]');
          self.form.requestSubmit(submit || undefined);
        } else if (self.form) {
          self.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      }
    });

    if (this.assetsDrawerEl) {
      this.assetsDrawerEl.addEventListener('toggle', function () {
        if (self.assetsDrawerEl.open && !self.uploadcareInitialized) {
          self.initUploadcare().then(function () {
            self.syncHiddenFields();
          });
        }
      });
    }

    this.root.addEventListener('change', function (event) {
      var target = event.target;
      var qtyInput = target.closest('[data-qb-qty-input]');
      if (qtyInput) {
        self.updateLine(qtyInput.getAttribute('data-line-key'), qtyInput.value, false);
        return;
      }

      if (target.matches('[data-qb-shipping-decision], [data-qb-shipping-mode]')) {
        self.syncShippingUI();
        self.validateShipping();
      }

      if (target.matches('[data-qb-target-date-choice]')) {
        var wantsExactDate = self.isExactTargetDateChoice(target);
        if (self.targetDateInput) self.targetDateInput.value = '';
        self.calendarMonthDate = null;
        self.dateStripStartDate = null;
        self.toggleTargetCalendarPopover(false);
        self.clearTargetDateChoiceError();
        self.clearFieldError(self.targetDateField);
        self.syncProgressiveBrief();
        if (wantsExactDate) self.toggleTargetCalendarPopover(true);
        self.updateSubmitState();
      }

      if (target === self.projectSelect) {
        self.syncProjectOther();
        self.syncProjectCards();
        self.syncProgressiveBrief();
        self.updateSubmitState();
      }

      if (target === self.contactPreferenceEl) {
        self.syncContactPreference();
      }

      if (target === self.consentInput) {
        self.validateConsent();
      }

      var wrapper = target.closest('[data-qb-field-wrapper]');
      if (wrapper) self.validateInput(target);

      self.syncSummary();
      self.syncHiddenFields();
      self.saveState();
      self.updateSubmitState();
    });

    this.root.addEventListener('input', function (event) {
      var target = event.target;
      var sizeInput = target.closest('[data-qb-size-input]');
      if (sizeInput) {
        var sizeShell = sizeInput.closest('[data-qb-size-shell]');
        self.syncSizeEditor(sizeShell);
        self.scheduleSizeBreakdownAutoSave(sizeShell);
        return;
      }

      var wrapper = target.closest('[data-qb-field-wrapper]');
      if (wrapper) self.validateInput(target);
      if (target === self.projectSelect) {
        self.syncProjectOther();
        self.syncProgressiveBrief();
        self.updateSubmitState();
      }
      self.syncHiddenFields();
      self.saveState();
      self.updateSubmitState();
    });

    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        if (self.root && self.root.classList && self.root.classList.contains('is-submit-success')) {
          event.preventDefault();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          return;
        }

        if (self.currentStep < self.totalWizardSteps) {
          event.preventDefault();
          self.goToNextWizardStep();
          return;
        }

        self.syncProjectOther();
        self.syncProgressiveBrief();
        self.syncShippingUI();
        self.syncSummary();
        self.syncHiddenFields();

        if (!self.getQuotePricing().valid) {
          event.preventDefault();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          self.status(String(self.config.locale || document.documentElement.lang).indexOf('fr') === 0
            ? 'La conversion des prix est temporairement indisponible. Rechargez la page avant d’envoyer votre demande.'
            : 'Price conversion is temporarily unavailable. Reload the page before sending your request.', true);
          return;
        }

        if (!self.validateForm()) {
          event.preventDefault();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          return;
        }

        event.preventDefault();
        if (self.quoteSubmissionInFlight) return;

        self.quoteSubmissionInFlight = true;

        var submissionFinished = false;
        var auxiliaryWatchdog;
        var submissionErrorMessage = function (code) {
          var publicApi = window.TodayMerchPublicApi;
          if (code === 'AUTOREPLY_RECIPIENT_UNDELIVERABLE') {
            if (/^de(?:-|_|$)/i.test(String(self.config.locale || document.documentElement.lang).trim())) {
              return publicApi && typeof publicApi.errorMessage === 'function'
                ? publicApi.errorMessage({ code: code }, self.config.locale || document.documentElement.lang)
                : 'Bitte überprüfen Sie Ihre E-Mail-Adresse oder verwenden Sie eine andere Adresse.';
            }
            return 'Merci de vérifier votre adresse e-mail ou d’utiliser une autre adresse.';
          }
          if (publicApi && typeof publicApi.errorMessage === 'function') {
            return publicApi.errorMessage(
              { code: code },
              self.config.locale || document.documentElement.lang
            );
          }
          try { return self.translate('statusError'); } catch (error) { return ''; }
        };
        var releaseSubmission = function () {
          if (auxiliaryWatchdog) window.clearTimeout(auxiliaryWatchdog);
          if (self.clientProjectAbortController) self.clientProjectAbortController.abort();
          self.quoteSubmissionInFlight = false;
          self.submitLoading = false;
          self.updateSubmitState();
        };
        var finishSubmission = function () {
          if (submissionFinished) return;
          submissionFinished = true;
          releaseSubmission();
          self.clearSavedState();
          self.showSubmitSuccess({ focus: true });
        };
        var stopSubmission = function (code) {
          if (submissionFinished) return;
          submissionFinished = true;
          releaseSubmission();
          self.status(submissionErrorMessage(code), true);
        };
        var auxiliaryWatchdogValue = Number(self.config.auxiliaryWatchdogMs);
        var auxiliaryWatchdogMs = Number.isFinite(auxiliaryWatchdogValue) && auxiliaryWatchdogValue >= 1 && auxiliaryWatchdogValue <= 30000
          ? auxiliaryWatchdogValue
          : 22000;

        self.submitLoading = true;
        self.updateSubmitState();
        self.status(self.translate('submitLoadingLabel'), false);
        self.saveState();

        var autoReplyRequired = self.autoReplySent !== true;
        var autoReplyApiBase = self.getAutoReplyApiBase();
        var shouldCreateClientProject = !self.clientProjectCreated && !self.clientProjectSubmitInFlight && self.config.clientPortalApiBase;
        var shouldSendAutoReply = autoReplyRequired && !self.autoReplySubmitInFlight && autoReplyApiBase;
        if (autoReplyRequired && !shouldSendAutoReply) {
          stopSubmission('AUTOREPLY_REQUEST_FAILED');
          return;
        }
        auxiliaryWatchdog = window.setTimeout(function () {
          if (autoReplyRequired && self.autoReplySent !== true) stopSubmission('AUTOREPLY_DELIVERY_FAILED');
          else finishSubmission();
        }, auxiliaryWatchdogMs);
        Promise.resolve()
          .then(function () {
            return !submissionFinished && shouldSendAutoReply ? self.sendAutoReply() : null;
          })
          .then(function (autoReplyResult) {
            if (submissionFinished) return;
            if (shouldSendAutoReply && (autoReplyResult && autoReplyResult.ok === false || self.autoReplySent !== true)) {
              stopSubmission(autoReplyResult && autoReplyResult.code || 'AUTOREPLY_DELIVERY_FAILED');
              return null;
            }
            return shouldCreateClientProject ? self.createClientProject() : null;
          })
          .then(function () {
            if (submissionFinished) return;
            finishSubmission();
          })
          .catch(function (error) {
            if (submissionFinished) return;
            // The optional client portal cannot invalidate accepted quote notifications.
            if (self.autoReplySent === true) finishSubmission();
            else stopSubmission(error && error.code ? error.code : 'AUTOREPLY_REQUEST_FAILED');
          });
      });
    }

    window.addEventListener('resize', function () {
      self.setStickyOffset();
      self.syncProductViewSwitchers(self.cartItemsEl, { animate: false });
    });
  };

  QuoteBuilder.prototype.init = function () {
    var self = this;
    this.setStickyOffset();
    if (this.successPageEl && !this.successPageEl.hidden) {
      this.clearSavedState();
      this.showSubmitSuccess({ focus: true });
      return;
    }
    var restoredState = this.restoreState();
    if (!restoredState) this.resetUnsavedProgressiveState();
    this.bindEvents();
    this.syncProjectOther();
    this.syncProjectCards();
    this.syncProgressiveBrief();
    this.syncShippingUI();
    this.syncContactPreference();
    this.renderCart();
    this.syncSummary();
    this.syncHiddenFields();
    this.setCurrentWizardStep(1, { scroll: false });
    this.updateSubmitState();
    this.renderUploadcareList();
    if (!this.assetsDrawerEl || this.assetsDrawerEl.open) {
      this.initUploadcare().then(function () {
        self.syncHiddenFields();
      });
    }
  };

  if (window.__TODAYMERCH_QUOTE_BUILDER_TEST__) {
    window.TodayMerchQuoteBuilderTest = { QuoteBuilder: QuoteBuilder };
    return;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-qb-root]').forEach(function (root) {
      try {
        new QuoteBuilder(root).init();
      } catch (error) {
        console.error('Quote builder init failed', error);
      }
    });
  });
})();
